export const khoiData = [
  {
    nameProvince: "TỈNH AN GIANG",
    address: "số 213 đường Lê Hồng Phong, phường Rạch Giá, tỉnh An Giang.",
    phone: "02973.814.024",
    website: "https://hoinongdanag.org.vn",
    email: "hnd@angiang.gov.vn",
    zipCode: "02973",
    contentComponent: (
      <tbody>
                  <tr>
                    <th>
                      <p>
                        <b>TT</b>
                      </p>
                    </th>
                    <th>
                      <p>
                        <b>Họ tên</b>
                      </p>
                    </th>
                    <th>
                      <p>
                        <b>Chức vụ</b>
                      </p>
                    </th>
                    <th>
                      <p>
                        <b>Số điện thoại</b>
                      </p>
                    </th>
                    <th>
                      <p>
                        <b>Địa chỉ Email</b>
                      </p>
                    </th>
                  </tr>
                  <tr>
                    <td>
                      <p>
                        <b>I</b>
                      </p>
                    </td>
                    <td colSpan={4}>
                      <p>
                        <b>TT</b>
                      </p>
                    </td>
                  </tr>
                  <tr>
                    <td>
                      <p>1</p>
                    </td>
                    <td>
                      <p>Nguyễn Văn Cọp</p>
                    </td>
                    <td>
                      <p>Chủ tịch</p>
                    </td>
                    <td>
                      <p>091.901.7411</p>
                    </td>
                    <td>
                      <p>
                        nvcop.hnd
                        <br />
                        @angiang.gov.vn
                      </p>
                    </td>
                  </tr>
                  <tr>
                    <td>
                      <p>2</p>
                    </td>
                    <td>
                      <p>Phan Tùng Lâm</p>
                    </td>
                    <td>
                      <p>
                        Phó Chủ tịch kiêm Trưởng Ban Công tác Hội quần chúng
                      </p>
                    </td>
                    <td>
                      <p>091.942.4777</p>
                    </td>
                    <td>
                      <p>
                        ptlam.hnd
                        <br />
                        @angiang.gov.vn
                      </p>
                    </td>
                  </tr>
                  <tr>
                    <td>
                      <p>3</p>
                    </td>
                    <td>
                      <p>Lâm Quốc Toàn</p>
                    </td>
                    <td>
                      <p>Phó Chủ tịch kiêm Trưởng Ban CTND</p>
                    </td>
                    <td>
                      <p>094.491.2399</p>
                    </td>
                    <td>
                      <p>
                        lqtoan.hnd
                        <br />
                        @angiang.gov.vn
                      </p>
                    </td>
                  </tr>
                  <tr>
                    <td>
                      <p>
                        <b>II</b>
                      </p>
                    </td>
                    <td colSpan={4}>
                      <p>
                        <b>TỔ VĂN PHÒNG</b>&nbsp;
                      </p>
                    </td>
                  </tr>
                  <tr>
                    <td>
                      <p>1</p>
                    </td>
                    <td>
                      <p>Võ Thị Thanh Bình</p>
                    </td>
                    <td>
                      <p>Phó ban, Tổ trưởng</p>
                    </td>
                    <td>
                      <p>091.950.3626</p>
                    </td>
                    <td>
                      <p>
                        vttbinh.hnd
                        <br />
                        @angiang.gov.vn
                      </p>
                    </td>
                  </tr>
                  <tr>
                    <td>
                      <p>2</p>
                    </td>
                    <td>
                      <p>Trần Quốc Việt</p>
                    </td>
                    <td>
                      <p>Tổ phó</p>
                    </td>
                    <td>
                      <p>097.399.9930</p>
                    </td>
                    <td>
                      <p>
                        tqviet.hnd
                        <br />
                        @angiang.gov.vn
                      </p>
                    </td>
                  </tr>
                  <tr>
                    <td>
                      <p>3</p>
                    </td>
                    <td>
                      <p>Nguyễn Quốc Đạt</p>
                    </td>
                    <td>
                      <p>Kế toán</p>
                    </td>
                    <td>
                      <p>091.995.3958</p>
                    </td>
                    <td>
                      <p>
                        nqdat.hnd
                        <br />
                        @angiang.gov.vn
                      </p>
                    </td>
                  </tr>
                  <tr>
                    <td>
                      <p>5</p>
                    </td>
                    <td>
                      <p>Nguyễn Hoàng Nhựt Quang</p>
                    </td>
                    <td>
                      <p>Nhân viên</p>
                    </td>
                    <td>
                      <p>090.379.4843</p>
                    </td>
                    <td>
                      <p>
                        nhnquang.hnd
                        <br />
                        @angiang.gov.vn
                      </p>
                    </td>
                  </tr>
                  <tr>
                    <td>
                      <p>6</p>
                    </td>
                    <td>
                      <p>Trần Thị Thúy Hằng</p>
                    </td>
                    <td>
                      <p>Chuyên viên, Văn thư</p>
                    </td>
                    <td>
                      <p>091.913.3371</p>
                    </td>
                    <td>
                      <p>
                        ttthang.hnd
                        <br />
                        @angiang.gov.vn
                      </p>
                    </td>
                  </tr>
                  <tr>
                    <td>
                      <p>7</p>
                    </td>
                    <td>
                      <p>Ung Thị Thúy Hoa</p>
                    </td>
                    <td>
                      <p>NV phục vụ</p>
                    </td>
                    <td>
                      <p>094.244.8323</p>
                    </td>
                    <td>
                      <p>&nbsp;</p>
                    </td>
                  </tr>
                  <tr>
                    <td>
                      <p>8</p>
                    </td>
                    <td>
                      <p>Trương Quốc Việt</p>
                    </td>
                    <td>
                      <p>NV lái xe</p>
                    </td>
                    <td>
                      <p>094.584.2000</p>
                    </td>
                    <td>
                      <p>&nbsp;</p>
                    </td>
                  </tr>
                  <tr>
                    <td>
                      <p>
                        <b>III</b>
                      </p>
                    </td>
                    <td colSpan={4}>
                      <p>
                        <b>TỔ XÂY DỰNG HỘI</b>
                      </p>
                    </td>
                  </tr>
                  <tr>
                    <td>
                      <p>1</p>
                    </td>
                    <td>
                      <p>Nguyễn Tiến Nhân</p>
                    </td>
                    <td>
                      <p>Phó ban, Tổ trưởng</p>
                    </td>
                    <td>
                      <p>091.868.8112</p>
                    </td>
                    <td>
                      <p>
                        ntnhan.hnd
                        <br />
                        @angiang.gov.vn
                      </p>
                    </td>
                  </tr>
                  <tr>
                    <td>
                      <p>2</p>
                    </td>
                    <td>
                      <p>Nguyễn Ngọc Dung</p>
                    </td>
                    <td>
                      <p>Phó ban, Tổ phó</p>
                    </td>
                    <td>
                      <p>090.850.0888</p>
                    </td>
                    <td>
                      <p>
                        nndung.hnd
                        <br />
                        @angiang.gov.vn
                      </p>
                    </td>
                  </tr>
                  <tr>
                    <td>
                      <p>3</p>
                    </td>
                    <td>
                      <p>Nguyễn Thanh Vân</p>
                    </td>
                    <td>
                      <p>Chuyên viên</p>
                    </td>
                    <td>
                      <p>082.400.8286</p>
                    </td>
                    <td>
                      <p>
                        ntvan.hnd
                        <br />
                        @angiang.gov.vn
                      </p>
                    </td>
                  </tr>
                  <tr>
                    <td>
                      <p>4</p>
                    </td>
                    <td>
                      <p>Nguyễn Thị Trang</p>
                    </td>
                    <td>
                      <p>Chuyên viên</p>
                    </td>
                    <td>
                      <p>097.880.8489</p>
                    </td>
                    <td>
                      <p>
                        nttrang.hnd
                        <br />
                        @angiang.gov.vn
                      </p>
                    </td>
                  </tr>
                  <tr>
                    <td>
                      <p>5</p>
                    </td>
                    <td>
                      <p>Trần Đình Trọng</p>
                    </td>
                    <td>
                      <p>Chuyên viên</p>
                    </td>
                    <td>
                      <p>090.671.7107</p>
                    </td>
                    <td>
                      <p>
                        tdtrong.hnd
                        <br />
                        @angiang.gov.vn
                      </p>
                    </td>
                  </tr>
                  <tr>
                    <td>
                      <p>
                        <b>IV</b>
                      </p>
                    </td>
                    <td colSpan={4}>
                      <p>
                        <b>TỔ KT-XH</b>
                      </p>
                    </td>
                  </tr>
                  <tr>
                    <td>
                      <p>1</p>
                    </td>
                    <td>
                      <p>Hà Phi Hùng</p>
                    </td>
                    <td>
                      <p>Phó ban, Tổ trưởng</p>
                    </td>
                    <td>
                      <p>098.381.7417</p>
                    </td>
                    <td>
                      <p>
                        hphung.hnd
                        <br />
                        @angiang.gov.vn
                      </p>
                    </td>
                  </tr>
                  <tr>
                    <td>
                      <p>2</p>
                    </td>
                    <td>
                      <p>Nguyễn Văn Phẳng</p>
                    </td>
                    <td>
                      <p>Phó ban, Tổ phó</p>
                    </td>
                    <td>
                      <p>094.960.9949</p>
                    </td>
                    <td>
                      <p>
                        nvphang.hnd
                        <br />
                        @angiang.gov.vn
                      </p>
                    </td>
                  </tr>
                  <tr>
                    <td>
                      <p>3</p>
                    </td>
                    <td>
                      <p>Nguyễn Thị Thùy Linh</p>
                    </td>
                    <td>
                      <p>Chuyên viên</p>
                    </td>
                    <td>
                      <p>091.425.3778</p>
                    </td>
                    <td>
                      <p>
                        nttlinh.hnd
                        <br />
                        @angiang.gov.vn
                      </p>
                    </td>
                  </tr>
                  <tr>
                    <td>
                      <p>4</p>
                    </td>
                    <td>
                      <p>Thời Minh Huy</p>
                    </td>
                    <td>
                      <p>Chuyên viên</p>
                    </td>
                    <td>
                      <p>091.907.2760</p>
                    </td>
                    <td>
                      <p>
                        tmhuy.hnd
                        <br />
                        @angiang.gov.vn
                      </p>
                    </td>
                  </tr>
                  <tr>
                    <td>
                      <p>5</p>
                    </td>
                    <td>
                      <p>Trần Anh Thư</p>
                    </td>
                    <td>
                      <p>Chuyên viên</p>
                    </td>
                    <td>
                      <p>096.150.6015</p>
                    </td>
                    <td>
                      <p>
                        tathu.hnd
                        <br />
                        @angiang.gov.vn
                      </p>
                    </td>
                  </tr>
                  <tr>
                    <td>
                      <p>
                        <b>V</b>
                      </p>
                    </td>
                    <td colSpan={4}>
                      <p>
                        <b>TRUNG TÂM HTND VÀ GIÁO DỤC NGHỀ NGHIỆP</b>
                      </p>
                    </td>
                  </tr>
                  <tr>
                    <td>
                      <p>1</p>
                    </td>
                    <td>
                      <p>Lâm Quốc Toàn</p>
                    </td>
                    <td>
                      <p>Phó Chủ tịch kiêm Giám đốc</p>
                    </td>
                    <td>
                      <p>094.491.2399</p>
                    </td>
                    <td>
                      <p>
                        lqtoan.hnd
                        <br />
                        @angiang.gov.vn
                      </p>
                    </td>
                  </tr>
                  <tr>
                    <td>
                      <p>2</p>
                    </td>
                    <td>
                      <p>Nguyễn Văn Phẳng</p>
                    </td>
                    <td>
                      <p>Phó ban kiêm Phó Giám đốc</p>
                    </td>
                    <td>
                      <p>094.960.9949</p>
                    </td>
                    <td>
                      <p>
                        nvphang.hnd
                        <br />
                        @angiang.gov.vn
                      </p>
                    </td>
                  </tr>
                  <tr>
                    <td>
                      <p>3</p>
                    </td>
                    <td>
                      <p>Hoàng Thị Kim Yến</p>
                    </td>
                    <td>
                      <p>Kế toán</p>
                    </td>
                    <td>
                      <p>083.434.5198</p>
                    </td>
                    <td>
                      <p>
                        htkyen.hnd
                        <br />
                        @angiang.gov.vn
                      </p>
                    </td>
                  </tr>
                  <tr>
                    <td>
                      <p>4</p>
                    </td>
                    <td>
                      <p>Nguyễn Hồng Ngân</p>
                    </td>
                    <td>
                      <p>Nhân viên</p>
                    </td>
                    <td>
                      <p>091.414.1659</p>
                    </td>
                    <td>
                      <p>&nbsp;</p>
                    </td>
                  </tr>
                  <tr>
                    <td>
                      <p>5</p>
                    </td>
                    <td>
                      <p>Phan Thị Cẩm Tiên</p>
                    </td>
                    <td>
                      <p>Nhân viên</p>
                    </td>
                    <td>
                      <p>085.416.6149</p>
                    </td>
                    <td>
                      <p>&nbsp;</p>
                    </td>
                  </tr>
                  <tr>
                    <td>
                      <p>
                        <b>VI</b>
                      </p>
                    </td>
                    <td colSpan={4}>
                      <p>
                        <b>QUỸ HTND (KIÊM NHIỆM)</b>
                      </p>
                    </td>
                  </tr>
                  <tr>
                    <td>
                      <p>1</p>
                    </td>
                    <td>
                      <p>Võ Thị Thanh Bình</p>
                    </td>
                    <td>
                      <p>Phó ban kiêm Giám đốc</p>
                    </td>
                    <td>
                      <p>091.950.3626</p>
                    </td>
                    <td>
                      <p>
                        vttbinh.hnd
                        <br />
                        @angiang.gov.vn
                      </p>
                    </td>
                  </tr>
                  <tr>
                    <td>
                      <p>2</p>
                    </td>
                    <td>
                      <p>Hà Phi Hùng</p>
                    </td>
                    <td>
                      <p>Phó ban kiêm Phó Giám đốc</p>
                    </td>
                    <td>
                      <p>098.381.7417</p>
                    </td>
                    <td>
                      <p>
                        hphung.hnd
                        <br />
                        @angiang.gov.vn
                      </p>
                    </td>
                  </tr>
                  <tr>
                    <td>
                      <p>3</p>
                    </td>
                    <td>
                      <p>Nguyễn Thị Trang</p>
                    </td>
                    <td>
                      <p>Kế toán</p>
                    </td>
                    <td>
                      <p>097.880.8489</p>
                    </td>
                    <td>
                      <p>
                        nttrang.hnd
                        <br />
                        @angiang.gov.vn
                      </p>
                    </td>
                  </tr>
                  <tr>
                    <td>
                      <p>4</p>
                    </td>
                    <td>
                      <p>Nguyễn Thanh Vân</p>
                    </td>
                    <td>
                      <p>Nghiệp vụ</p>
                    </td>
                    <td>
                      <p>082.400.8286</p>
                    </td>
                    <td>
                      <p>
                        ntvan.hnd
                        <br />
                        @angiang.gov.vn
                      </p>
                    </td>
                  </tr>
                  <tr>
                    <td>
                      <p>5</p>
                    </td>
                    <td>
                      <p>Trần Quốc Việt</p>
                    </td>
                    <td>
                      <p>Nghiệp vụ</p>
                    </td>
                    <td>
                      <p>097.399.9930</p>
                    </td>
                    <td>
                      <p>
                        tqviet.hnd
                        <br />
                        @angiang.gov.vn
                      </p>
                    </td>
                  </tr>
                  <tr>
                    <td>
                      <p>6</p>
                    </td>
                    <td>
                      <p>Phan Thị Bích Huy</p>
                    </td>
                    <td>
                      <p>Nhân viên</p>
                    </td>
                    <td>
                      <p>036.615.5888</p>
                    </td>
                    <td>
                      <p>
                        bichhuy2004
                        <br />
                        @gmail.com
                      </p>
                    </td>
                  </tr>
      </tbody>
    ),
    photoName: "anGiang"
  },
  {
    nameProvince: "TỈNH BẮC NINH",
    address: "tầng 7, tòa B, khu Liên cơ quan, Quảng trường 3/2w, phường Bắc Giang, tỉnh Bắc Ninh.",
    phone: "",
    website: "https://hoinongdan.bacgiang.gov.vn",
    email: "bctnd@bacninh.gov.vn",
    zipCode: "",
    contentComponent: (
      <tbody>
                  <tr>
                    <th>
                      <p>
                        <b>TT</b>
                      </p>
                    </th>
                    <th>
                      <p>
                        <b>Họ và tên</b>
                      </p>
                    </th>
                    <th>
                      <p>
                        <b>Chức vụ</b>
                      </p>
                    </th>
                    <th>
                      <p>
                        <b>Số điện thoại</b>
                      </p>
                    </th>
                  </tr>
                  <tr>
                    <td>
                      <p>1</p>
                    </td>
                    <td>
                      <p>Nguyễn Hoàng Trung</p>
                    </td>
                    <td>
                      <p>Chủ tịch</p>
                    </td>
                    <td>
                      <p>0964.677.979</p>
                    </td>
                  </tr>
                  <tr>
                    <td>
                      <p>2</p>
                    </td>
                    <td>
                      <p>Lã Văn Đoàn</p>
                    </td>
                    <td>
                      <p>Phó Chủ tịch TT</p>
                    </td>
                    <td>
                      <p>0912.352.948</p>
                    </td>
                  </tr>
                  <tr>
                    <td>
                      <p>3</p>
                    </td>
                    <td>
                      <p>Nguyễn Thế Thi</p>
                    </td>
                    <td>
                      <p>Phó Chủ tịch</p>
                    </td>
                    <td>
                      <p>0973.605.098</p>
                    </td>
                  </tr>
                  <tr>
                    <td>
                      <p>4</p>
                    </td>
                    <td>
                      <p>Đào Duy Hữu</p>
                    </td>
                    <td>
                      <p>Phó Chủ tịch</p>
                    </td>
                    <td>
                      <p>0978.025.889</p>
                    </td>
                  </tr>
                  <tr>
                    <td>
                      <p>5</p>
                    </td>
                    <td>
                      <p>Tống Thị Quyên</p>
                    </td>
                    <td>
                      <p>Phó ban TT</p>
                    </td>
                    <td>
                      <p>0988.844.046</p>
                    </td>
                  </tr>
                  <tr>
                    <td>
                      <p>6</p>
                    </td>
                    <td>
                      <p>Phan Thị Thu Hiền</p>
                    </td>
                    <td>
                      <p>Phó ban</p>
                    </td>
                    <td>
                      <p>0982.424.595</p>
                    </td>
                  </tr>
                  <tr>
                    <td>
                      <p>7</p>
                    </td>
                    <td>
                      <p>Dương Tiến Đang</p>
                    </td>
                    <td>
                      <p>Phó ban</p>
                    </td>
                    <td>
                      <p>0989.132.175</p>
                    </td>
                  </tr>
                  <tr>
                    <td>
                      <p>8</p>
                    </td>
                    <td>
                      <p>Nguyễn Thị Lân</p>
                    </td>
                    <td>
                      <p>Phó ban</p>
                    </td>
                    <td>
                      <p>0919.583.009</p>
                    </td>
                  </tr>
                  <tr>
                    <td>
                      <p>9</p>
                    </td>
                    <td>
                      <p>Đinh Hương Sơn</p>
                    </td>
                    <td>
                      <p>Phó ban</p>
                    </td>
                    <td>
                      <p>0948.146.866</p>
                    </td>
                  </tr>
                  <tr>
                    <td>
                      <p>10</p>
                    </td>
                    <td>
                      <p>Nguyễn Văn Nhật</p>
                    </td>
                    <td>
                      <p>Chuyên viên</p>
                    </td>
                    <td>
                      <p>0912.992.443</p>
                    </td>
                  </tr>
                  <tr>
                    <td>
                      <p>11</p>
                    </td>
                    <td>
                      <p>Phùng Thị Vị</p>
                    </td>
                    <td>
                      <p>Chuyên viên</p>
                    </td>
                    <td>
                      <p>0988.677.900</p>
                    </td>
                  </tr>
                  <tr>
                    <td>
                      <p>12</p>
                    </td>
                    <td>
                      <p>Tạ Thị Thu Hà</p>
                    </td>
                    <td>
                      <p>Chuyên viên</p>
                    </td>
                    <td>
                      <p>0967.754.434</p>
                    </td>
                  </tr>
                  <tr>
                    <td>
                      <p>13</p>
                    </td>
                    <td>
                      <p>Trần Thị Thanh Hòa</p>
                    </td>
                    <td>
                      <p>Chuyên viên</p>
                    </td>
                    <td>
                      <p>0813.148.862</p>
                    </td>
                  </tr>
                  <tr>
                    <td>
                      <p>14</p>
                    </td>
                    <td>
                      <p>Nguyễn Mạnh Tùng</p>
                    </td>
                    <td>
                      <p>Chuyên viên</p>
                    </td>
                    <td>
                      <p>0918.876.326</p>
                    </td>
                  </tr>
                  <tr>
                    <td>
                      <p>15</p>
                    </td>
                    <td>
                      <p>Thân Thị Dũng</p>
                    </td>
                    <td>
                      <p>Chuyên viên</p>
                    </td>
                    <td>
                      <p>0978.572.919</p>
                    </td>
                  </tr>
                  <tr>
                    <td>
                      <p>16</p>
                    </td>
                    <td>
                      <p>Nguyễn Thị Thanh Tâm</p>
                    </td>
                    <td>
                      <p>Chuyên viên</p>
                    </td>
                    <td>
                      <p>0968.561.982</p>
                    </td>
                  </tr>
                  <tr>
                    <td>
                      <p>17</p>
                    </td>
                    <td>
                      <p>Nguyễn Bá Tuyến</p>
                    </td>
                    <td>
                      <p>Chuyên viên</p>
                    </td>
                    <td>
                      <p>0911.097.507</p>
                    </td>
                  </tr>
                  <tr>
                    <td>
                      <p>18</p>
                    </td>
                    <td>
                      <p>Nghiêm Thị Liên</p>
                    </td>
                    <td>
                      <p>Chuyên viên</p>
                    </td>
                    <td>
                      <p>0931.227.331</p>
                    </td>
                  </tr>
                  <tr>
                    <td>
                      <p>19</p>
                    </td>
                    <td>
                      <p>Nguyễn Thị Thanh</p>
                    </td>
                    <td>
                      <p>Nhân viên</p>
                    </td>
                    <td>
                      <p>0977.511.058</p>
                    </td>
                  </tr>
                  <tr>
                    <td>
                      <p>20</p>
                    </td>
                    <td>
                      <p>Nguyễn Thị Yến Minh</p>
                    </td>
                    <td>
                      <p>Nhân viên</p>
                    </td>
                    <td>
                      <p>0985.166.705</p>
                    </td>
                  </tr>
                  <tr>
                    <td>
                      <p>21</p>
                    </td>
                    <td>
                      <p>Lê Văn Hà</p>
                    </td>
                    <td>
                      <p>Lái xe </p>
                    </td>
                    <td>
                      <p>0985.030.268</p>
                    </td>
                  </tr>
                  <tr>
                    <td>
                      <p>22</p>
                    </td>
                    <td>
                      <p>Lục Văn Ngọc</p>
                    </td>
                    <td>
                      <p>Lái xe</p>
                    </td>
                    <td>
                      <p>0978.593.116</p>
                    </td>
                  </tr>
                  <tr>
                    <td>
                      <p>23</p>
                    </td>
                    <td>
                      <p>Đặng Đức Hải</p>
                    </td>
                    <td>
                      <p>Lái xe</p>
                    </td>
                    <td>
                      <p>0974.686.656</p>
                    </td>
                  </tr>
      </tbody>
    ),
    photoName: "bacNinh"
  },
  {
    nameProvince: "TỈNH CÀ MAU",
    address: "Số 4, đường Trần Nguyên Đán, phường Tân Thành, tỉnh Cà Mau.",
    phone: "(0290) 3 831 331",
    website: "https://hoinongdan.camau.gov.vn",
    email: "hoinongdantinhcm@gmail.com",
    zipCode: "0290",
    contentComponent: (
      <tbody>
                  <tr>
                    <th>
                      <p>
                        <b>TT</b>
                      </p>
                    </th>
                    <th>
                      <p>
                        <b>Họ và tên</b>
                      </p>
                    </th>
                    <th>
                      <p>
                        <b>Chức vụ</b>
                      </p>
                    </th>
                    <th>
                      <p>
                        <b>Số điện thoại</b>
                      </p>
                    </th>
                    <th>
                      <p>
                        <b>Email</b>
                      </p>
                    </th>
                  </tr>
                  <tr>
                    <td>
                      <p>1</p>
                    </td>
                    <td>
                      <p>Nguyễn Hoàng Thoại</p>
                    </td>
                    <td>
                      <p>Chủ tịch</p>
                    </td>
                    <td>
                      <p>0935.925.925</p>
                    </td>
                    <td>
                      <p>
                        hnd.nhthoai
                        <br />
                        @camau.gov.vn
                      </p>
                    </td>
                  </tr>
                  <tr>
                    <td>
                      <p>2</p>
                    </td>
                    <td>
                      <p>Đỗ Hoàng Tuấn</p>
                    </td>
                    <td>
                      <p>Phó Chủ tịch TT, Trưởng Ban CTND</p>
                    </td>
                    <td>
                      <p>0919.667.114</p>
                    </td>
                    <td>
                      <p>
                        hnd.dhtuan
                        <br />
                        @camau.gov.vn
                      </p>
                    </td>
                  </tr>
                  <tr>
                    <td>
                      <p>3</p>
                    </td>
                    <td>
                      <p>Tiêu Việt Tiên</p>
                    </td>
                    <td>
                      <p>Phó Chủ tịch</p>
                    </td>
                    <td>
                      <p>0918.328.822</p>
                    </td>
                    <td>
                      <p>
                        hnd.tvtien
                        <br />
                        @camau.gov.vn
                      </p>
                    </td>
                  </tr>
                  <tr>
                    <td>
                      <p>4</p>
                    </td>
                    <td>
                      <p>Nguyễn Hữu Nghị</p>
                    </td>
                    <td>
                      <p>Phó ban</p>
                    </td>
                    <td>
                      <p>0918.440.998</p>
                    </td>
                    <td>
                      <p>
                        hnd.nhnghi
                        <br />
                        @camau.gov.vn
                      </p>
                    </td>
                  </tr>
                  <tr>
                    <td>
                      <p>5</p>
                    </td>
                    <td>
                      <p>Trần Thị Lan Anh</p>
                    </td>
                    <td>
                      <p>Phó ban</p>
                    </td>
                    <td>
                      <p>0942.253.652</p>
                    </td>
                    <td>
                      <p>
                        hnd.ttlanh
                        <br />
                        @camau.gov.vn
                      </p>
                    </td>
                  </tr>
                  <tr>
                    <td>
                      <p>6</p>
                    </td>
                    <td>
                      <p>Trần Văn Thuận</p>
                    </td>
                    <td>
                      <p>Phó ban</p>
                    </td>
                    <td>
                      <p>0917.933.669</p>
                    </td>
                    <td>
                      <p>
                        hnd.tvthuan
                        <br />
                        @camau.gov.vn
                      </p>
                    </td>
                  </tr>
                  <tr>
                    <td>
                      <p>7</p>
                    </td>
                    <td>
                      <p>Trần Thị Hồng Thắm</p>
                    </td>
                    <td>
                      <p>Chuyên viên</p>
                    </td>
                    <td>
                      <p>0917.161.613</p>
                    </td>
                    <td />
                  </tr>
                  <tr>
                    <td>
                      <p>8</p>
                    </td>
                    <td>
                      <p>Đặng Văn Luốt</p>
                    </td>
                    <td>
                      <p>Chuyên viên</p>
                    </td>
                    <td>
                      <p>0919.606.780</p>
                    </td>
                    <td />
                  </tr>
                  <tr>
                    <td>
                      <p>9</p>
                    </td>
                    <td>
                      <p>Bành Thị Tuyết Phương</p>
                    </td>
                    <td>
                      <p>Chuyên viên</p>
                    </td>
                    <td>
                      <p>0949.687.577</p>
                    </td>
                    <td />
                  </tr>
                  <tr>
                    <td>
                      <p>10</p>
                    </td>
                    <td>
                      <p>Lưu Tấn Lộc</p>
                    </td>
                    <td>
                      <p>Chuyên viên, Văn thư - Lưu trữ</p>
                    </td>
                    <td>
                      <p>0914.734.438</p>
                    </td>
                    <td>
                      <p>
                        hnd.ltloc
                        <br />
                        @camau.gov.vn
                      </p>
                    </td>
                  </tr>
                  <tr>
                    <td>
                      <p>11</p>
                    </td>
                    <td>
                      <p>Lê Phương Thùy</p>
                    </td>
                    <td>
                      <p>Chuyên viên</p>
                    </td>
                    <td>
                      <p>0918.377.505</p>
                    </td>
                    <td />
                  </tr>
                  <tr>
                    <td>
                      <p>12</p>
                    </td>
                    <td>
                      <p>Hồ Vinh Lộc</p>
                    </td>
                    <td>
                      <p>Chuyên viên</p>
                    </td>
                    <td>
                      <p>0819.268.270</p>
                    </td>
                    <td />
                  </tr>
                  <tr>
                    <td>
                      <p>13</p>
                    </td>
                    <td>
                      <p>Biện Văn Thừa</p>
                    </td>
                    <td>
                      <p>Chuyên viên</p>
                    </td>
                    <td>
                      <p>0948.845.905</p>
                    </td>
                    <td />
                  </tr>
                  <tr>
                    <td>
                      <p>14</p>
                    </td>
                    <td>
                      <p>Nguyễn Thúy Kiều</p>
                    </td>
                    <td>
                      <p>Chuyên viên</p>
                    </td>
                    <td>
                      <p>0944.263.339</p>
                    </td>
                    <td />
                  </tr>
                  <tr>
                    <td>
                      <p>15</p>
                    </td>
                    <td>
                      <p>Trần Kim Long</p>
                    </td>
                    <td>
                      <p>Chuyên viên</p>
                    </td>
                    <td>
                      <p>0939.268.439</p>
                    </td>
                    <td />
                  </tr>
                  <tr>
                    <td>
                      <p>16</p>
                    </td>
                    <td>
                      <p>Phương Đông</p>
                    </td>
                    <td>
                      <p>Chuyên viên</p>
                    </td>
                    <td>
                      <p>0945.172.839</p>
                    </td>
                    <td />
                  </tr>
                  <tr>
                    <td>
                      <p>17</p>
                    </td>
                    <td>
                      <p>Huỳnh Minh Trung</p>
                    </td>
                    <td>
                      <p>Chuyên viên TT HTND&amp;GDNN</p>
                    </td>
                    <td>
                      <p>0916.401.976</p>
                    </td>
                    <td />
                  </tr>
                  <tr>
                    <td>
                      <p>18</p>
                    </td>
                    <td>
                      <p>Nguyễn Văn Trạng</p>
                    </td>
                    <td>
                      <p>Chuyên viên TT HTND&amp;GDNN</p>
                    </td>
                    <td>
                      <p>0812.878.969</p>
                    </td>
                    <td />
                  </tr>
                  <tr>
                    <td>
                      <p>19</p>
                    </td>
                    <td>
                      <p>Nguyễn Thị Mỹ Nhung</p>
                    </td>
                    <td>
                      <p>Chuyên viên TT HTND&amp;GDNN</p>
                    </td>
                    <td>
                      <p>0918.171.045</p>
                    </td>
                    <td />
                  </tr>
      </tbody>
    ),
    photoName: "caMau"
  },
  {
    nameProvince: "TỈNH CAO BẰNG",
    address: "tầng 4, MTTQ VN tỉnh Cao Bằng, khu trung tâm Hành chính, phường Thục Phán, tỉnh Cao Bằng.",
    phone: "0206.385.8885",
    website: "",
    email: "",
    zipCode: "",
    contentComponent: (
      <tbody>
          <tr>
          <th><p><b>TT</b></p></th>
          <th><p><b>Họ và tên</b></p></th>
          <th><p><b>Chức vụ</b></p></th>
          <th><p><b>Số điện thoại</b></p></th>
          </tr>
          <tr>
          <td><p>1</p></td>
          <td><p>Lý Thị Huệ</p></td>
          <td><p>Chủ tịch</p></td>
          <td><p>0912.529.176</p></td>
          </tr>
          <tr>
          <td><p>2</p></td>
          <td><p>Nông Quốc Hoàn</p></td>
          <td><p>Phó chủ tịch-Trưởng ban CTND</p></td>
          <td><p>0836.993.656</p></td>
          </tr>
          <tr>
          <td><p>3</p></td>
          <td><p>Hoàng Thị Hường</p></td>
          <td><p>Phó ban</p></td>
          <td><p>0915.955.765</p></td>
          </tr>
          <tr>
          <td><p>4</p></td>
          <td><p>Đặng Quang Vĩnh</p></td>
          <td><p>Phó ban</p></td>
          <td><p>0945.740.865</p></td>
          </tr>
          <tr>
          <td><p>5</p></td>
          <td><p>Nông Công Họa</p></td>
          <td><p>Phó ban</p></td>
          <td><p>0858.252.868</p></td>
          </tr>
          <tr>
          <td><p>6</p></td>
          <td><p>Nông Quốc Huân</p></td>
          <td><p>Phó ban</p></td>
          <td><p>0768.368.721</p></td>
          </tr>
          <tr>
          <td><p>7</p></td>
          <td><p>Mã Thị Trang</p></td>
          <td><p>Chuyên viên</p></td>
          <td><p>0818.857.685</p></td>
          </tr>
          <tr>
          <td><p>8</p></td>
          <td><p>Lục Thị Dư</p></td>
          <td><p>Chuyên viên</p></td>
          <td><p>0988.071.568</p></td>
          </tr>
          <tr>
          <td><p>9</p></td>
          <td><p>Tô Hương Lan</p></td>
          <td><p>Chuyên viên</p></td>
          <td><p>0846.526.986</p></td>
          </tr>
          <tr>
          <td><p>10</p></td>
          <td><p>Hoàng Thị Mại Loan</p></td>
          <td><p>Chuyên viên</p></td>
          <td><p>0975.076.006</p></td>
          </tr>
          <tr>
          <td><p>11</p></td>
          <td><p>Đàm Tuấn Hải</p></td>
          <td><p>Chuyên viên</p></td>
          <td><p>0793.315.666</p></td>
          </tr>
        </tbody>
    ),
    photoName: "caoBang"
  },
  {
    nameProvince: "THÀNH PHỐ CẦN THƠ",
    address: "96 Lý Tự Trọng, Phường Ninh Kiều, thành phố Cần Thơ.",
    phone: "0292.383.1035",
    website: "",
    email: "hoinongdan@cantho.gov.vn",
    zipCode: "0292",
    contentComponent: (
      <tbody>
        <tr>
          <th><p><b>TT</b></p></th>
          <th><p><b>Họ và tên</b></p></th>
          <th><p><b>Chức vụ</b></p></th>
          <th><p><b>Số điện thoại</b></p></th>
          <th><p><b>Email</b></p></th>
        </tr>
        <tr>
          <td><p>1</p></td>
          <td><p>Nguyễn Văn Sử</p></td>
          <td><p>Chủ tịch</p></td>
          <td><p>091.894.4917</p></td>
          <td><p><a href="mailto:nvsu@cantho.gov.vn" target="_blank" rel="noopener noreferrer"><span style={{color: 'windowtext', textDecoration: 'none'}}>nvsu<br />
                  @cantho.gov.vn</span></a></p></td>
        </tr>
        <tr>
          <td><p>2</p></td>
          <td><p>Phạm Thanh Hoài</p></td>
          <td><p>Phó Chủ tịch, Trưởng ban CTND</p></td>
          <td><p>090.759.3707</p></td>
          <td><p><a href="mailto:pthoai@cantho.gov.vn" target="_blank" rel="noopener noreferrer"><span style={{color: 'windowtext', textDecoration: 'none'}}>pthoai<br />
                  @cantho.gov.vn</span></a></p></td>
        </tr>
        <tr>
          <td><p>3</p></td>
          <td><p>Đặng Tấn Giang</p></td>
          <td><p>Phó Chủ tịch, Trưởng ban Tôn giáo Dân tộc MTTQVN TP</p></td>
          <td><p>097.661.6126</p></td>
          <td><p><a href="mailto:dtgiang3@cantho.gov.vn" target="_blank" rel="noopener noreferrer"><span style={{color: 'windowtext', textDecoration: 'none'}}>dtgiang3<br />
                  @cantho.gov.vn</span></a></p></td>
        </tr>
        <tr>
          <td><p>4</p></td>
          <td><p>Lê Thị Tuyết Trinh</p></td>
          <td><p>Phó ban</p></td>
          <td><p>083.532.7555</p></td>
          <td><p><a href="mailto:ltttrinh10@cantho.gov.vn" target="_blank" rel="noopener noreferrer"><span style={{color: 'windowtext', textDecoration: 'none'}}>ltttrinh10<br />
                  @cantho.gov.vn</span></a></p></td>
        </tr>
        <tr>
          <td><p>5</p></td>
          <td><p>Trần Ngọc Mai</p></td>
          <td><p>Phó ban</p></td>
          <td><p>091.935.9873</p></td>
          <td><p><a href="mailto:tnmai@cantho.gov.vn" target="_blank" rel="noopener noreferrer"><span style={{color: 'windowtext', textDecoration: 'none'}}>tnmai<br />
                  @cantho.gov.vn</span></a></p></td>
        </tr>
        <tr>
          <td><p>6</p></td>
          <td><p>Lê Thị Ánh Minh</p></td>
          <td><p>Phó ban</p></td>
          <td><p>094.914.7105</p></td>
          <td><p><a href="mailto:ltaminh@cantho.gov.vn" target="_blank" rel="noopener noreferrer"><span style={{color: 'windowtext', textDecoration: 'none'}}>ltaminh<br />
                  @cantho.gov.vn</span></a></p></td>
        </tr>
        <tr>
          <td><p>7</p></td>
          <td><p>Nguyễn Xuân Kim Thúy Diễm</p></td>
          <td><p>Chuyên viên</p></td>
          <td><p>098.530.3370</p></td>
          <td><p>nxktdiem<br />
              @cantho.gov.vn</p></td>
        </tr>
        <tr>
          <td><p>8</p></td>
          <td><p>Trịnh Hồng Thắm</p></td>
          <td><p>Kế toán cơ quan</p></td>
          <td><p>097.760.9144</p></td>
          <td><p>trinhhongtham<br />
              @cantho.gov.vn</p></td>
        </tr>
        <tr>
          <td><p>9</p></td>
          <td><p>Nguyễn Thị Thuỳ Trâm</p></td>
          <td><p>Chuyên viên</p></td>
          <td><p>094.407.7717</p></td>
          <td><p><a href="mailto:ntttram3@cantho.gov.vn" target="_blank" rel="noopener noreferrer"><span style={{color: 'windowtext', textDecoration: 'none'}}>ntttram3<br />
                  @cantho.gov.vn</span></a></p></td>
        </tr>
        <tr>
          <td><p>10</p></td>
          <td><p>Trần Mỹ Dung</p></td>
          <td><p>Chuyên viên</p></td>
          <td><p>091.973.0895</p></td>
          <td><p><a href="mailto:tmdung1@cantho.gov.vn" target="_blank" rel="noopener noreferrer"><span style={{color: 'windowtext', textDecoration: 'none'}}>tmdung1<br />
                  @cantho.gov.vn</span></a></p></td>
        </tr>
        <tr>
          <td><p>11</p></td>
          <td><p>Ngô Nguyễn Kim Thư</p></td>
          <td><p>Chuyên viên</p></td>
          <td><p>091.811.7429</p></td>
          <td><p>nnkthu<br />
              @cantho.gov.vn</p></td>
        </tr>
        <tr>
          <td><p>12</p></td>
          <td><p>Huỳnh Trung Tuấn</p></td>
          <td><p>Chuyên viên</p></td>
          <td><p>098.825.8685</p></td>
          <td><p><a href="mailto:trungtuan@cantho.gov.vn" target="_blank" rel="noopener noreferrer"><span style={{color: 'windowtext', textDecoration: 'none'}}>trungtuan<br />
                  @cantho.gov.vn</span></a></p></td>
        </tr>
        <tr>
          <td><p>13</p></td>
          <td><p>Đặng Phương Nam</p></td>
          <td><p>Chuyên viên</p></td>
          <td><p>097.386.6820</p></td>
          <td><p>phuongnam<br />
              @cantho.gov.vn</p></td>
        </tr>
        <tr>
          <td><p>14</p></td>
          <td><p>Phạm Mỹ Phương</p></td>
          <td><p>Chuyên viên, phụ trách VT-LT</p></td>
          <td><p>039.645.1898</p></td>
          <td><p><a href="mailto:pmphuong5@cantho.gov.vn" target="_blank" rel="noopener noreferrer"><span style={{color: 'windowtext', textDecoration: 'none'}}>pmphuong5<br />
                  @cantho.gov.vn</span></a></p></td>
        </tr>
        <tr>
          <td><p>15</p></td>
          <td><p>Nguyễn Minh Hòn</p></td>
          <td><p>Chuyên viên</p></td>
          <td><p>091.916.6654</p></td>
          <td><p><a href="mailto:nmhon@cantho.gov.vn" target="_blank" rel="noopener noreferrer"><span style={{color: 'windowtext', textDecoration: 'none'}}>nmhon<br />
                  @cantho.gov.vn</span></a></p></td>
        </tr>
        <tr>
          <td><p>16</p></td>
          <td><p>Nguyễn Trường Thạnh</p></td>
          <td><p>Chuyên viên</p></td>
          <td><p>034.268.0908</p></td>
          <td><p><a href="mailto:ntthanh15@cantho.gov.vn" target="_blank" rel="noopener noreferrer"><span style={{color: 'windowtext', textDecoration: 'none'}}>ntthanh15<br />
                  @cantho.gov.vn</span></a></p></td>
        </tr>
        <tr>
          <td><p>17</p></td>
          <td><p>Trần Duy Nam</p></td>
          <td><p>Chuyên viên</p></td>
          <td><p>094.399.7262</p></td>
          <td><p>tranduynam<br />
              @cantho.gov.vn</p></td>
        </tr>
        <tr>
          <td><p>18</p></td>
          <td><p>Lư Tuấn</p></td>
          <td><p>Chuyên viên</p></td>
          <td><p>091.816.0160</p></td>
          <td><p>lutuan<br />
              @cantho.gov.vn</p></td>
        </tr>
        <tr>
          <td><p>19</p></td>
          <td><p>Huỳnh Văn Tựu</p></td>
          <td><p>Chuyên viên, KT Quỹ HTND</p></td>
          <td><p>097.273.9518</p></td>
          <td><p><a href="mailto:hvtuu@cantho.gov.vn" target="_blank" rel="noopener noreferrer"><span style={{color: 'windowtext', textDecoration: 'none'}}>hvtuu<br />
                  @cantho.gov.vn</span></a></p></td>
        </tr>
        <tr>
          <td><p>20</p></td>
          <td><p>Võ Nguyễn Tuyết Nhung</p></td>
          <td><p>Nhân viên</p></td>
          <td><p>096.581.6872</p></td>
          <td><p><a href="mailto:vntnhung@cantho,gov.vn" target="_blank" rel="noopener noreferrer"><span style={{color: 'windowtext', textDecoration: 'none'}}>vntnhung<br />
                  @cantho,gov.vn</span></a></p></td>
        </tr>
        <tr>
          <td><p>21</p></td>
          <td><p>Trần Tấn Phú</p></td>
          <td><p>Lái xe</p></td>
          <td><p>090.751.6988</p></td>
          <td />
        </tr>
        <tr>
          <td><p>22</p></td>
          <td><p>Võ Tấn Trung</p></td>
          <td><p>Bảo vệ</p></td>
          <td><p>090.934.5158</p></td>
          <td />
        </tr>
      </tbody>
    ),
    photoName: "canTho"
  },
  {
    nameProvince: "THÀNH PHỐ ĐÀ NẴNG",
    address: "12 Hồ Nguyên Trừng, phường Hòa Cương, thành phố Đà Nẵng.",
    phone: "023.635.51214",
    website: "hoinongdandanang.org.vn",
    email: "hnd@danang.gov.vn",
    zipCode: "",
    contentComponent: (
      <tbody>
  <tr>
<th><p><b>TT</b></p></th>
<th><p><b>Họ và tên</b></p></th>
<th><p><b>Chức vụ</b></p></th>
<th><p><b>Số điện thoại</b></p></th>
</tr>
<tr>
<td><p>1</p></td>
<td><p>Lê Thị Minh Tâm</p></td>
<td><p>Chủ tịch</p></td>
<td><p>093.516.8165</p></td>
</tr>
<tr>
<td><p>2</p></td>
<td><p>Nguyễn Út</p></td>
<td><p>Phó Chủ tịch, kiêm Trưởng Ban CTND</p></td>
<td><p>098.300.1426</p></td>
</tr>
<tr>
<td><p>3</p></td>
<td><p>Thái Thị Bích Phin</p></td>
<td><p>Phó Chủ tịch </p></td>
<td><p>091.912.4855</p></td>
</tr>
<tr>
<td><p>4</p></td>
<td><p>Đỗ Thị Tâm</p></td>
<td><p>Phó ban</p></td>
<td><p>098.334.8303</p></td>
</tr>
<tr>
<td><p>5</p></td>
<td><p>Lê Văn Phú</p></td>
<td><p>Phó ban</p></td>
<td><p>091.409.7037</p></td>
</tr>
<tr>
<td><p>6</p></td>
<td><p>Bùi Quốc Yên</p></td>
<td><p>Phó ban</p></td>
<td><p>091.415.7999</p></td>
</tr>
<tr>
<td><p>7</p></td>
<td><p>Nguyễn Phương Hoài Thảo</p></td>
<td><p>Phó ban</p></td>
<td><p>086.904.0808</p></td>
</tr>
<tr>
<td><p>8</p></td>
<td><p>Nguyễn Văn Trường</p></td>
<td><p>Phó ban</p></td>
<td><p>097.717.2867</p></td>
</tr>
<tr>
<td><p>9</p></td>
<td><p>Ngô Thị Ánh Ngọc</p></td>
<td><p>Chuyên viên</p></td>
<td><p>093.484.8348</p></td>
</tr>
<tr>
<td><p>10</p></td>
<td><p>Trần Hoàng Hải</p></td>
<td><p>Chuyên viên</p></td>
<td><p>093.479.5185</p></td>
</tr>
<tr>
<td><p>11</p></td>
<td><p>Nguyễn Thị Ngọ</p></td>
<td><p>Chuyên viên</p></td>
<td><p>093.506.4066</p></td>
</tr>
<tr>
<td><p>12</p></td>
<td><p>Nguyễn Sinh Vương</p></td>
<td><p>Chuyên viên</p></td>
<td><p>037.489.2227</p></td>
</tr>
<tr>
<td><p>13</p></td>
<td><p>Nguyễn Tấn Trọng</p></td>
<td><p>Chuyên viên</p></td>
<td><p>097.722.7760</p></td>
</tr>
<tr>
<td><p>14</p></td>
<td><p>Trần Xuân Lộc</p></td>
<td><p>Chuyên viên</p></td>
<td><p>039.939.8544</p></td>
</tr>
<tr>
<td><p>15</p></td>
<td><p>Trần Thị Thu Ba</p></td>
<td><p>Chuyên viên</p></td>
<td><p>037.737.4797</p></td>
</tr>
<tr>
<td><p>16</p></td>
<td><p>Ngô Thị Lệ Thương</p></td>
<td><p>Chuyên viên</p></td>
<td><p>033.409.9079</p></td>
</tr>
<tr>
<td><p>17</p></td>
<td><p>Nguyễn Thị Ngọc Tuyền</p></td>
<td><p>Chuyên viên</p></td>
<td><p>090.530.9445</p></td>
</tr>
<tr>
<td><p>18</p></td>
<td><p>Ngô Thị Kim Hồng</p></td>
<td><p>Nhân viên</p></td>
<td><p>090.594.2946</p></td>
</tr>
<tr>
<td><p>19</p></td>
<td><p>Nguyễn Thị Diệu</p></td>
<td><p>NV tạp vụ</p></td>
<td><p>093.566.7459</p></td>
</tr>
<tr>
<td><p>20</p></td>
<td><p>Huỳnh Ngọc Khâm</p></td>
<td><p>Bảo vệ</p></td>
<td><p>037.952.4310</p></td>
</tr>
<tr>
<td><p>21</p></td>
<td><p>Nguyễn Trà Sơn</p></td>
<td><p>Lái xe </p></td>
<td><p>038.658.3951</p></td>
</tr>
<tr>
<td><p>22</p></td>
<td><p>Võ Thị Phương Dung</p></td>
<td><p>NV Quỹ HTND</p></td>
<td><p>077.544.4221</p></td>
</tr>
</tbody>
    ),
    photoName: "daNang"
  },
  {
    nameProvince: "TỈNH ĐẮK LẮK",
    address: "21 A Trường Chinh, phường Buôn Ma Thuộc, tỉnh Đắk Lắk.",
    phone: "",
    website: "",
    email: "",
    zipCode: "",
    contentComponent: (
      <tbody>
<tr>
  <th><p><b>TT</b></p></th>
  <th><p><b>Họ và tên</b></p></th>
  <th><p><b>Chức vụ</b></p></th>
  <th><p><b>Số điện thoại</b></p></th>
  <th><p><b>Thư điện tử</b></p></th>
</tr>
<tr>
  <td><p>01</p></td>
  <td><p>Ya Toan Ênuôl</p></td>
  <td><p>Chủ tịch</p></td>
  <td><p>096.557.0870</p></td>
  <td><p><a href="mailto:yatoan@gmail.com"><span style={{color: 'windowtext', textDecoration: 'none'}}>yatoan<br />
          @gmail.com</span></a></p></td>
</tr>
<tr>
  <td><p>02</p></td>
  <td><p>Võ Văn Dũng</p></td>
  <td><p>Phó Chủ tịch</p></td>
  <td><p>086.871.7979</p></td>
  <td><p><a href="mailto:dung24979@gmail.com"><span style={{color: 'windowtext', textDecoration: 'none'}}>dung24979<br />
          @gmail.com</span></a></p></td>
</tr>
<tr>
  <td><p>03</p></td>
  <td><p>Trần Thị Phương Hằng</p></td>
  <td><p>Phó ban</p></td>
  <td><p>098.813.1383</p></td>
  <td><p><a href="mailto:phuonghang75@gmail.com"><span style={{color: 'windowtext', textDecoration: 'none'}}>phuonghang75<br />
          @gmail.com</span></a></p></td>
</tr>
<tr>
  <td><p>04</p></td>
  <td><p>Phạm Thị Thêm</p></td>
  <td><p>Phó ban</p></td>
  <td><p>098.434.5444</p></td>
  <td><p><a href="mailto:themphamdaklak@gmail.com"><span style={{color: 'windowtext', textDecoration: 'none'}}>themphamdaklak<br />
          @gmail.com</span></a></p></td>
</tr>
<tr>
  <td><p>05</p></td>
  <td><p>Mai Xuân Hải</p></td>
  <td><p>Phó ban</p></td>
  <td><p>098.301.6927</p></td>
  <td><p><a href="mailto:haikthndpy@gmail.com"><span style={{color: 'windowtext', textDecoration: 'none'}}>haikthndpy<br />
          @gmail.com</span></a></p></td>
</tr>
<tr>
  <td><p>06</p></td>
  <td><p>Nguyễn Trọng Truyển</p></td>
  <td><p>Phó ban</p></td>
  <td><p>090.466.7118</p></td>
  <td><p><a href="mailto:truyenythu@gmail.com"><span style={{color: 'windowtext', textDecoration: 'none'}}>truyenythu<br />
          @gmail.com</span></a></p></td>
</tr>
<tr>
  <td><p>07</p></td>
  <td><p>Nguyễn Văn Kiên</p></td>
  <td><p>Phó ban</p></td>
  <td><p>091.704.2929</p></td>
  <td><p><a href="mailto:nguyen_kien1905@yahoo.com"><span style={{color: 'windowtext', textDecoration: 'none'}}>nguyen_kien1905<br />
          @yahoo.com</span></a></p></td>
</tr>
<tr>
  <td><p>08</p></td>
  <td><p>Vũ Thị Kim Nga</p></td>
  <td><p>Phó ban</p></td>
  <td><p>098.213.1767</p></td>
  <td><p><a href="mailto:nga79dl@gmail.com"><span style={{color: 'windowtext', textDecoration: 'none'}}>nga79dl<br />
          @gmail.com</span></a></p></td>
</tr>
<tr>
  <td><p>09</p></td>
  <td><p>Huỳnh Văn Thanh</p></td>
  <td><p>Phó ban</p></td>
  <td><p>090.353.9479</p></td>
  <td><p><a href="mailto:thanhpy20@gmail.com"><span style={{color: 'windowtext', textDecoration: 'none'}}>thanhpy20<br />
          @gmail.com</span></a></p></td>
</tr>
<tr>
  <td><p>10</p></td>
  <td><p>Trần Thị Kim Phượng</p></td>
  <td><p>Chuyên viên</p></td>
  <td><p>094.523.3379</p></td>
  <td><p><a href="mailto:Kimphuongsld@gmail.com"><span style={{color: 'windowtext', textDecoration: 'none'}}>Kimphuongsld<br />
          @gmail.com</span></a></p></td>
</tr>
<tr>
  <td><p>11</p></td>
  <td><p>Hồ Thị Minh Nguyên</p></td>
  <td><p>Chuyên viên</p></td>
  <td><p>090.650.6503</p></td>
  <td><p><a href="mailto:nguyenttndpy@gmail.com"><span style={{color: 'windowtext', textDecoration: 'none'}}>nguyenttndpy<br />
          @gmail.com</span></a></p></td>
</tr>
<tr>
  <td><p>12</p></td>
  <td><p>Phạm Thanh Trúc</p></td>
  <td><p>Chuyên viên</p></td>
  <td><p>082.709.8869</p></td>
  <td><p><a href="mailto:trucbandhq@gmail.com"><span style={{color: 'windowtext', textDecoration: 'none'}}>trucbandhq<br />
          @gmail.com</span></a></p></td>
</tr>
<tr>
  <td><p>13</p></td>
  <td><p>Trương Quang Quang</p></td>
  <td><p>Chuyên viên</p></td>
  <td><p>093.531.3163</p></td>
  <td><p><a href="mailto:quangtruong160585@gmail.com"><span style={{color: 'windowtext', textDecoration: 'none'}}>quangtruong160585<br />
          @gmail.com</span></a></p></td>
</tr>
<tr>
  <td><p>14</p></td>
  <td><p>Huỳnh Trần Hải Lộc</p></td>
  <td><p>Chuyên viên</p></td>
  <td><p>090.506.4406</p></td>
  <td><p><a href="mailto:hailoclndn0203@gmail.com"><span style={{color: 'windowtext', textDecoration: 'none'}}>hailoclndn0203<br />
          @gmail.com</span></a></p></td>
</tr>
<tr>
  <td><p>15</p></td>
  <td><p>Trịnh Văn Hoằng</p></td>
  <td><p>Chuyên viên</p></td>
  <td><p>096.164.3487</p></td>
  <td><p><a href="mailto:hoanghndpy@gmail.com"><span style={{color: 'windowtext', textDecoration: 'none'}}>hoanghndpy<br />
          @gmail.com</span></a></p></td>
</tr>
<tr>
  <td><p>16</p></td>
  <td><p>H Hương Hmǒk</p></td>
  <td><p>Chuyên viên</p></td>
  <td><p>096.362.5593</p></td>
  <td><p><a href="mailto:huonghmok94@gmail.com"><span style={{color: 'windowtext', textDecoration: 'none'}}>huonghmok94<br />
          @gmail.com</span></a></p></td>
</tr>
<tr>
  <td><p>17</p></td>
  <td><p>Phạm Thị Thanh Trâm</p></td>
  <td><p>Chuyên viên</p></td>
  <td><p>091.520.5469</p></td>
  <td><p><a href="mailto:phamthanhtram28@gmail.com"><span style={{color: 'windowtext', textDecoration: 'none'}}>phamthanhtram28<br />
          @gmail.com</span></a></p></td>
</tr>
<tr>
  <td><p>18</p></td>
  <td><p>Ngô Thị Mẳng</p></td>
  <td><p>Chuyên viên</p></td>
  <td><p>098.587.7062</p></td>
  <td><p><a href="mailto:mangphuyen@gmail.com"><span style={{color: 'windowtext', textDecoration: 'none'}}>mangphuyen<br />
          @gmail.com</span></a></p></td>
</tr>
</tbody>
    ),
    photoName: "dakLak"
  },
  {
    nameProvince: "TỈNH ĐIỆN BIÊN",
    address: "Tổ dân phố 02, phường Điện Biên Phủ, tỉnh Điện Biên.",
    phone: "",
    website: "",
    email: "",
    zipCode: "",
    contentComponent: (
      <tbody>
  <tr>
  <th><p><b>TT</b></p></th>
  <th><p><b>Họ và tên</b></p></th>
  <th><p><b>Chức vụ</b></p></th>
  <th><p><b>Số điện thoại</b></p></th>
 </tr>
 <tr>
  <td><p>1</p></td>
  <td><p>Trần Quý Hùng</p></td>
  <td><p>Chủ tịch</p></td>
  <td><p>091.121.1082</p></td>
 </tr>
 <tr>
  <td><p>2</p></td>
  <td><p>Lù Văn Thanh</p></td>
  <td><p>Phó Chủ tịch</p></td>
  <td><p>091.462.9877</p></td>
 </tr>
 <tr>
  <td><p>3</p></td>
  <td><p>Quàng Văn Phương</p></td>
  <td><p>Phó ban</p></td>
  <td><p>091.338.2004</p></td>
 </tr>
 <tr>
  <td><p>4</p></td>
  <td><p>Quàng Văn Trường</p></td>
  <td><p>Phó ban</p></td>
  <td><p>091.750.2510</p></td>
 </tr>
 <tr>
  <td><p>5</p></td>
  <td><p>Sùng A Công</p></td>
  <td><p>Phó ban</p></td>
  <td><p>098.427.2210</p></td>
 </tr>
 <tr>
  <td><p>6</p></td>
  <td><p>Trần Văn Hạnh</p></td>
  <td><p>Chuyên viên</p></td>
  <td><p>091.277.1119</p></td>
 </tr>
 <tr>
  <td><p>7</p></td>
  <td><p>Dương Thị Hương</p></td>
  <td><p>Chuyên viên</p></td>
  <td><p>091.592.8008</p></td>
 </tr>
 <tr>
  <td><p>8</p></td>
  <td><p>Trịnh Văn Toàn</p></td>
  <td><p>Chuyên viên</p></td>
  <td><p>098.898.0228</p></td>
 </tr>
 <tr>
  <td><p>9</p></td>
  <td><p>Lường Văn Thiêm</p></td>
  <td><p>Chuyên viên</p></td>
  <td><p>038.331.1532</p></td>
 </tr>
 <tr>
  <td><p>10</p></td>
  <td><p>Đỗ Thị Hiền</p></td>
  <td><p>Chuyên viên</p></td>
  <td><p>091.119.6226</p></td>
 </tr>
 <tr>
  <td><p>11</p></td>
  <td><p>Cà Văn Minh</p></td>
  <td><p>Chuyên viên</p></td>
  <td><p>088.814.4111</p></td>
 </tr>
</tbody>
    ),
    photoName: "dienBien"
  },
  {
    nameProvince: "TỈNH ĐỒNG NAI",
    address: "185, Đường Hà Huy Giáp, phường Trấn Biên, tỉnh Đồng Nai.",
    phone: "0251.3.823.474",
    website: "hoinongdan.dongnai.gov.vn",
    email: "hoinongdantinhdn@gmail.com",
    zipCode: "0251",
    contentComponent: (
      <tbody>
  <tr>
  <th><p><b>TT</b></p></th>
  <th><p><b>Họ và tên</b></p></th>
  <th><p><b>Chức vụ</b></p></th>
  <th><p><b>Số điện thoại</b></p></th>
  <th><p><b>Email</b></p></th>
 </tr>
 <tr>
  <td><p>1</p></td>
  <td><p>Nguyễn Hữu Nguyên</p></td>
  <td><p>Chủ
  tịch</p></td>
  <td><p>0937.385.003</p></td>
  <td><p>nguyennh<br/>
  @dongnai.gov.vn</p></td>
 </tr>
 <tr>
  <td><p>2</p></td>
  <td><p>Nguyễn Văn Giang</p></td>
  <td><p>Phó
  Chủ tịch, Trưởng Ban CTND</p></td>
  <td><p>0902.900.511</p></td>
  <td></td>
 </tr>
 <tr>
  <td><p>3</p></td>
  <td><p>Nguyễn Huy Hoàng</p></td>
  <td><p>Phó
  ban</p></td>
  <td><p>0388.328.916</p></td>
  <td></td>
 </tr>
 <tr>
  <td><p>4</p></td>
  <td><p>Nguyễn Bảo Thái</p></td>
  <td><p>Phó
  ban</p></td>
  <td><p>0913.796.806</p></td>
  <td></td>
 </tr>
 <tr>
  <td><p>5</p></td>
  <td><p>Lê
  Thị Thu Hương</p></td>
  <td><p>Phó
  ban</p></td>
  <td><p>0919.881.739</p></td>
  <td></td>
 </tr>
 <tr>
  <td><p>6</p></td>
  <td><p>Nguyễn
  Thị Hiếu</p></td>
  <td><p>Phó
  ban</p></td>
  <td><p>0989.798.727</p></td>
  <td><p>hieunt.hnd <br/>
  @dongnai.gov.vn</p></td>
 </tr>
 <tr>
  <td><p>7</p></td>
  <td><p>Nguyễn
  Thị Thu Dinh</p></td>
  <td><p>Phó
  ban</p></td>
  <td><p>0369.121.007</p></td>
  <td><p>dinhntt.hnd <br/>
  @dongnai.gov.vn</p></td>
 </tr>
 <tr>
  <td><p>8</p></td>
  <td><p>Phạm
  Thị Ngọc Minh</p></td>
  <td><p>Phó
  ban</p></td>
  <td><p>0915.992.996</p></td>
  <td><p>minhptn.hnd <br/>
  @dongnai.gov.vn</p></td>
 </tr>
 <tr>
  <td><p>9</p></td>
  <td><p>Nguyễn Thị Minh Tuyền</p></td>
  <td><p>Chuyên viên</p></td>
  <td><p>0986.969.397</p></td>
  <td></td>
 </tr>
 <tr>
  <td><p>10</p></td>
  <td><p>Chu
  Thị Mai Hiền</p></td>
  <td><p>Chuyên viên</p></td>
  <td><p>0919.410.887</p></td>
  <td><p>hienctm.hnd<br/>
  @dongnai.gov.vn</p></td>
 </tr>
 <tr>
  <td><p>11</p></td>
  <td><p>Vũ
  Tấn Minh</p></td>
  <td><p>Chuyên viên</p></td>
  <td><p>0333.037.148</p></td>
  <td></td>
 </tr>
 <tr>
  <td><p>12</p></td>
  <td><p>Nguyễn Thị Nga</p></td>
  <td><p>Chuyên viên</p></td>
  <td><p>0907.509.247</p></td>
  <td></td>
 </tr>
 <tr>
  <td><p>13</p></td>
  <td><p>Nguyễn
  Trung Tuấn</p></td>
  <td><p>Chuyên viên</p></td>
  <td><p>0812.063.646</p></td>
  <td></td>
 </tr>
 <tr>
  <td><p>14</p></td>
  <td><p>Trần Thị Dung</p></td>
  <td><p>Chuyên viên</p></td>
  <td><p>0375.038.585</p></td>
  <td></td>
 </tr>
 <tr>
  <td><p>15</p></td>
  <td><p>Nguyễn
  Thị Biên Thuỳ</p></td>
  <td><p>Chuyên viên</p></td>
  <td><p>0982.278.519</p></td>
  <td></td>
 </tr>
 <tr>
  <td><p>16</p></td>
  <td><p>Nguyễn
  Thị Thuý</p></td>
  <td><p>Chuyên viên</p></td>
  <td><p>0975.974.218</p></td>
  <td></td>
 </tr>
 <tr>
  <td><p>17</p></td>
  <td><p>Nguyễn
  Hữu Gia Văn</p></td>
  <td><p>Chuyên viên</p></td>
  <td><p>0975.753.492</p></td>
  <td></td>
 </tr>
 <tr>
  <td><p>18</p></td>
  <td><p>Nguyễn Ngọc Linh</p></td>
  <td><p>Chuyên viên</p></td>
  <td><p>0966.448.661</p></td>
  <td></td>
 </tr>
 <tr>
  <td><p>19</p></td>
  <td><p>Nguyễn
  Thị Huỳnh Trang</p></td>
  <td><p>Chuyên viên</p></td>
  <td><p>0938.636.416</p></td>
  <td></td>
 </tr>
 <tr>
  <td><p>20</p></td>
  <td><p>Vũ Minh Thuận</p></td>
  <td><p>Chuyên viên</p></td>
  <td><p>0968.009.595</p></td>
  <td></td>
 </tr>
 <tr>
  <td><p>21</p></td>
  <td><p>Trần
  Xuân Quế</p></td>
  <td><p>Chuyên viên</p></td>
  <td><p>0985.761.207</p></td>
  <td></td>
 </tr>
</tbody>
    ),
    photoName: "dongNai"
  },
  {
    nameProvince: "TỈNH ĐỒNG THÁP",
    address: "Số 19, Gạch Rầm, phường Mỹ Tho, tỉnh Đồng Tháp.",
    phone: "0273 3872 201",
    website: "https://hndtinh.dongthap.gov.vn",
    email: "hoinongdantinhdongthap@gmail.com",
    zipCode: "0273",
    contentComponent: (
      <>
      <thead>
      <tr>
        <th rowSpan={2}><p><b>TT</b></p></th>
        <th rowSpan={2}><p><b>Họ và tên</b></p></th>
        <th rowSpan={2}><p><b>Chức vụ</b></p></th>
        <th colSpan={2}><p><b>Số máy điện thoại</b></p></th>
        <th rowSpan={2}><p><b>Email</b></p></th>
      </tr>
      <tr>
        <th><p><b>Cơ quan</b></p></th>
        <th><p><b>Di động</b></p></th>
      </tr>
      </thead>
      <tbody>
 <tr>
  <td><p>1</p></td>
  <td><p>Nguyễn Thị Hồng Phượng</p></td>
  <td><p>Chủ tịch</p></td>
  <td><p>3872201</p></td>
  <td><p>0194.703.046</p></td>
  <td><p>nguyenhongphuong975<br/>
  @gmail.com</p></td>
 </tr>
 <tr>
  <td><p>2</p></td>
  <td><p>Trần Minh Trung</p></td>
  <td><p>Phó Chủ tịch TT, Trưởng Ban CTND</p></td>
  <td><p>3872201</p></td>
  <td><p>0908.606.812</p></td>
  <td><p>tranminhtrunga40<br/>
  @gmail.com</p></td>
 </tr>
 <tr>
  <td><p>3</p></td>
  <td><p>Phạm Văn Toàn</p></td>
  <td><p>Phó Chủ tịch</p></td>
  <td><p>3872201</p></td>
  <td><p>0908.722.912</p></td>
  <td><p>phamvantoan82<br/>
  @yahoo.com.vn</p></td>
 </tr>
 <tr>
  <td><p>4</p></td>
  <td><p>Phan Hữu Quân</p></td>
  <td><p>Trưởng bộ phận Tổ chức – Hành chính</p></td>
  <td><p>3872201</p></td>
  <td><p>0946.131.240</p></td>
  <td><p>quanhnd1982<br/>
  @gmail.com</p></td>
 </tr>
 <tr>
  <td><p>5</p></td>
  <td><p>Huỳnh Công Minh</p></td>
  <td><p>Trưởng bộ phận KT-XH</p></td>
  <td><p>3872201</p></td>
  <td><p>0917.727.123</p></td>
  <td><p>huynhminhnd<br/>
  @gmail.com</p></td>
 </tr>
 <tr>
  <td><p>6</p></td>
  <td><p>Đặng Hồng Hà</p></td>
  <td><p>UVBTV</p></td>
  <td><p>3872201</p></td>
  <td><p>0917.645.068</p><p>&nbsp;</p></td>
  <td><p>dangha174hnd<br/>
  @gmail.com</p></td>
 </tr>
 <tr>
  <td><p>7</p></td>
  <td><p>Nguyễn Thị Mỹ Hạnh</p></td>
  <td><p>UVBTV</p></td>
  <td><p>3872201</p></td>
  <td><p>0982.055.123</p></td>
  <td><p>myhanhdongthap32<br/>
  @gmail.com</p></td>
 </tr>
 <tr>
  <td><p>8</p></td>
  <td><p>Phạm Thị Minh Triều</p></td>
  <td><p>UVBCH</p></td>
  <td><p>3872201</p></td>
  <td><p>0944.797.369</p></td>
  <td><p>nminhtrieu<br/>
  @gmail.com</p></td>
 </tr>
 <tr>
  <td><p>9</p></td>
  <td><p>Đặng Thành Tâm</p></td>
  <td><p>UVBCH</p></td>
  <td><p>3872201</p></td>
  <td><p>0786.852.999</p></td>
  <td><p>dttamhnd<br/>
  @gmail.com</p></td>
 </tr>
 <tr>
  <td><p>10</p></td>
  <td><p>Ngô Hoàng Việt</p></td>
  <td><p>CVC</p></td>
  <td><p>3872201</p></td>
  <td><p>0938.093.717</p></td>
  <td><p>vietngo83<br/>
  @gmail.com</p></td>
 </tr>
 <tr>
  <td><p>11</p></td>
  <td><p>Dương Tấn Lợi</p></td>
  <td><p>Chuyên viên</p></td>
  <td><p>3872201</p></td>
  <td><p>0918.899.340</p></td>
  <td><p>lduongtan<br/>
  @yahoo.com.vn</p></td>
 </tr>
 <tr>
  <td><p>12</p></td>
  <td><p>Võ Tuấn Anh</p></td>
  <td><p>Chuyên viên</p></td>
  <td><p>3872201</p></td>
  <td><p>0989.813.589</p></td>
  <td><p>vtanh.1989<br/>
  @gmail.com</p></td>
 </tr>
 <tr>
  <td><p>13</p></td>
  <td><p>Nguyễn Quốc Thắng</p></td>
  <td><p>Chuyên viên</p></td>
  <td><p>3872201</p></td>
  <td><p>0907.297.227</p></td>
  <td><p>thang1980dt<br/>
  @gmail.com</p></td>
 </tr>
 <tr>
  <td><p>14</p></td>
  <td><p>Lê Thị Thuý Hằng</p></td>
  <td><p>Kế toán</p></td>
  <td><p>3872201</p></td>
  <td><p>0906.174.271</p></td>
  <td><p>thuyhanglt8284<br/>
  @gmail.com</p></td>
 </tr>
 <tr>
  <td><p>15</p></td>
  <td><p>Đinh Thị Nga</p></td>
  <td><p>Chuyên viên</p></td>
  <td><p>3872201</p></td>
  <td><p>0919.450.491</p></td>
  <td><p>ngahoinongdantg<br/>
  @gmail.com</p></td>
 </tr>
 <tr>
  <td><p>16</p></td>
  <td><p>Nguyễn Thị Yến Oanh</p></td>
  <td><p>Chuyên viên</p></td>
  <td><p>3872201</p></td>
  <td><p>0986.226.440</p></td>
  <td><p>yenoanhnguyen1984<br/>
  @gmail.com</p></td>
 </tr>
 <tr>
  <td><p>17</p></td>
  <td><p>Nguyễn Tấn Hải</p></td>
  <td><p>Chuyên viên</p></td>
  <td><p>3872201</p></td>
  <td><p>0967.947.550</p></td>
  <td><p>ntanhai<br/>
  @gmail.com</p></td>
 </tr>
 <tr>
  <td><p>18</p></td>
  <td><p>Lê Phương Toàn</p></td>
  <td><p>Văn thư, lưu trữ</p></td>
  <td><p>3872201</p></td>
  <td><p>0949.211.268</p></td>
  <td><p>toanle031191<br/>
  @gmail.com</p></td>
 </tr>
 <tr>
  <td><p>19</p></td>
  <td><p>Lê Thị Mai</p></td>
  <td><p>NV Quỹ HTND</p></td>
  <td><p>3979809</p></td>
  <td><p>0918.809.616</p></td>
  <td><p><a href="mailto:maitvnn1981@gmail.com">maitvnn1981<br/>
  @gmail.com</a></p></td>
 </tr>
 <tr>
  <td><p>20</p></td>
  <td><p>Đoàn Trúc Linh</p></td>
  <td><p>NV Quỹ HTND</p></td>
  <td><p>3979809</p></td>
  <td><p>0913.885.562</p></td>
  <td><p>truclinh02kt<br/>
  @gmail.com</p></td>
 </tr>
 <tr>
  <td><p>21</p></td>
  <td><p>Võ Trần Cẩm Nhung</p></td>
  <td><p>Kế toán Quỹ HTND</p></td>
  <td><p>3979809</p></td>
  <td><p>0388.362.589</p></td>
  <td><p>votrancamnhung.tg<br/>
  @gmail.com</p></td>
 </tr>
 <tr>
  <td><p>22</p></td>
  <td><p>Nguyễn Minh Khang</p></td>
  <td><p>NV Quỹ HTND</p></td>
  <td><p>3979809</p></td>
  <td><p>0342.769.064</p></td>
  <td><p>nguyenminhkhang441<br/>
  @gmail.com</p></td>
 </tr>
 <tr>
  <td><p>23</p></td>
  <td><p>Trần Thanh Mai</p></td>
  <td><p>NV Quỹ HTND</p></td>
  <td><p>3979809</p></td>
  <td><p>0962.128.754</p></td>
  <td><p>tranthanhmai19112001<br/>
  @gmail.com</p></td>
 </tr>
 <tr>
  <td><p>24</p></td>
  <td><p>Võ Cao Sơn</p></td>
  <td><p>Lái xe</p></td>
  <td><p>3872201</p></td>
  <td><p>0986.447.412</p></td>
  <td><p>&nbsp;</p></td>
 </tr>
      </tbody>
      </>
    ),
    photoName: "dongThap"
  },
  {
    nameProvince: "TỈNH GIA LAI",
    address: "198 Phan Bội Châu, phường Quy Nhơn, tỉnh Gia Lai.",
    phone: "02563.822.048",
    website: "http://hoinongdangialai.org.vn",
    email: "bancongtacnongdangl@gmail.com",
    zipCode: "0256",
    contentComponent: (
      <>
     <thead>
       <tr>
          <th rowSpan={2}><p><b>TT</b></p></th>
          <th rowSpan={2}><p><b>Họ và tên</b></p></th>
          <th rowSpan={2}><p><b>Chức vụ</b></p></th>
          <th colSpan={2}><p><b>Số điện thoại</b></p></th>
          <th rowSpan={2}><p><b>Email</b></p></th>
      </tr>
      <tr>
        <th><p><b>Cơ quan</b></p></th>
        <th><p><b>Di động</b></p></th>
      </tr>
     </thead>
     
     <tbody>
  <tr>
  <td><p>1</p></td>
  <td><p>Rơ Chăm H' Hồng</p></td>
  <td><p>Chủ tịch</p></td>
  <td><p>3822848</p></td>
  <td><p>091.402.2489</p></td>
  <td><p>hongrc78<br/>
  @gmail.com</p></td>
 </tr>
 <tr>
  <td><p>2</p></td>
  <td><p>Y Khâm</p></td>
  <td><p>Phó Chủ tịch kiêm Trưởng ban CTND</p></td>
  <td><p>3811758</p></td>
  <td><p>036.673.0678</p></td>
  <td><p>ykhamgl<br/>
  @gmail.com</p></td>
 </tr>
 <tr>
  <td><p>3</p></td>
  <td><p>Trần Thị Thủy</p></td>
  <td><p>Phó ban</p></td>
  <td><p>3829877</p></td>
  <td><p>098.553.5056</p></td>
  <td><p>thuy1977gl<br/>
  @gmail.com</p></td>
 </tr>
 <tr>
  <td><p>4</p></td>
  <td><p>Nguyễn Thị Cẩm Thúy</p></td>
  <td><p>Phó ban </p><p>&nbsp;</p></td>
  <td><p>3811352</p></td>
  <td><p>090.504.2477</p></td>
  <td><p>nguyenthicamthuy205<br/>
  @gmail.com</p></td>
 </tr>
 <tr>
  <td><p>5</p></td>
  <td><p>Nguyễn Văn Đức</p></td>
  <td><p>CVC Ban CTND</p></td>
  <td><p>3822048</p></td>
  <td><p>098.224.3149</p></td>
  <td><p>minhduc020781<br/>
  @gmail.com</p></td>
 </tr>
 <tr>
  <td><p>6</p></td>
  <td><p>Lê Thị Thanh Thúy</p></td>
  <td><p>CVC </p></td>
  <td><p>3822048</p></td>
  <td><p>091.448.2484</p></td>
  <td><p>sanaly20811<br/>
  @gmail.com</p></td>
 </tr>
 <tr>
  <td><p>7</p></td>
  <td><p>Lưu Thị Diệp</p></td>
  <td><p>CVC </p></td>
  <td><p>3829876</p></td>
  <td><p>098.301.5326</p></td>
  <td><p>thudiephnd<br/>
  @gmail.com</p></td>
 </tr>
 <tr>
  <td><p>8</p></td>
  <td><p>Phạm Thị Thanh Hoa</p></td>
  <td><p>Chuyên viên </p></td>
  <td><p>3829876</p></td>
  <td><p>090.561.1620</p></td>
  <td><p>thanhhoahndtgl<br/>
  @gmail.com</p></td>
 </tr>
 <tr>
  <td><p>9</p></td>
  <td><p>Nguyễn Thị Thúy Hòa</p></td>
  <td><p>Chuyên viên/Văn thư</p></td>
  <td><p>3822048</p></td>
  <td><p>097.369.8792 </p></td>
  <td><p>hoahndgl90<br/>
  @gmail.com</p></td>
 </tr>
 <tr>
  <td><p>10</p></td>
  <td><p>Nguyễn Thị Thoa</p></td>
  <td><p>Chuyên viên </p></td>
  <td><p>&nbsp;</p></td>
  <td><p>037.459.9168</p></td>
  <td><p>nguyenthoa1989hn<br/>
  @gmail.com</p></td>
 </tr>
 <tr>
  <td><p>11</p></td>
  <td><p>Phan Thị Tuyết</p></td>
  <td><p>Chuyên viên</p></td>
  <td><p>&nbsp;</p></td>
  <td><p>098.501.3575</p></td>
  <td><p>fantuyet<br/>
  @gmail.com</p></td>
 </tr>
 <tr>
  <td><p>12</p></td>
  <td><p>Hồ Thị Dung</p></td>
  <td><p>CV kiêm thủ quỹ</p></td>
  <td><p>&nbsp;</p></td>
  <td><p>039.207.6344</p></td>
  <td><p>hodung270787<br/>
  @gmail.com</p></td>
 </tr>
 <tr>
  <td><p>13</p></td>
  <td><p>Lê Minh Khoa</p></td>
  <td><p>Chuyên viên</p></td>
  <td><p>&nbsp;</p></td>
  <td><p>097.800.0484</p></td>
  <td><p>lekhoa0209<br/>
  @gmail.com</p></td>
 </tr>
 <tr>
  <td><p>14</p></td>
  <td><p>Lưu Thị Kim Nhung</p></td>
  <td><p>CVC</p></td>
  <td><p>3829877</p></td>
  <td><p>090.241.2210</p></td>
  <td><p>xdhnongdangialai<br/>
  @gmail.com</p></td>
 </tr>
 <tr>
  <td><p>15</p></td>
  <td><p>Nguyễn Văn Hòa</p></td>
  <td><p>CVC</p></td>
  <td><p>&nbsp;</p></td>
  <td><p>093.583.2789</p></td>
  <td><p>hoanongdan20<br/>
  @gmail.com</p></td>
 </tr>
 <tr>
  <td><p>16</p></td>
  <td><p>Đặng Trịnh Bích Diệp</p></td>
  <td><p>Chuyên viên/Kế toán</p></td>
  <td><p>&nbsp;</p></td>
  <td><p>098.364.6220</p></td>
  <td><p>dtbdiep<br/>
  @gmail.com</p></td>
 </tr>
 <tr>
  <td><p>17</p></td>
  <td><p>Đỗ Minh Tiến</p></td>
  <td><p>Chuyên viên</p></td>
  <td><p>&nbsp;</p></td>
  <td><p>098.818.8459</p></td>
  <td><p>minhtienttknknbd<br/>
  @gmail.com</p></td>
 </tr>
 <tr>
  <td><p>18</p></td>
  <td><p>Phan Thanh Tường</p></td>
  <td><p>Chuyên viên</p></td>
  <td><p>3811352</p></td>
  <td><p>090.577.4717</p></td>
  <td><p>tuongphuoc1010<br/>
  @gmail.com</p></td>
 </tr>
 <tr>
  <td><p>19</p></td>
  <td><p>Lê Thị Xuân</p></td>
  <td><p>Chuyên viên</p></td>
  <td><p>3829877</p></td>
  <td><p>034.957.4680</p></td>
  <td><p>lexuan91.gialai<br/>
  @gmail.com</p></td>
 </tr>
 <tr>
  <td><p>20</p></td>
  <td><p>Phan Thị Bảo Oanh</p></td>
  <td><p>Chuyên viên</p></td>
  <td><p>3811352</p></td>
  <td><p>097.441.2245</p></td>
  <td><p>oanhhndgl.1990<br/>
  @gmail.com</p></td>
 </tr>
 <tr>
  <td><p>21</p></td>
  <td><p>Nguyễn Thị Thùy Dung</p></td>
  <td><p>Chuyên viên</p></td>
  <td><p>3811352</p></td>
  <td><p>097.972.4662</p></td>
  <td><p>thuydunghndgl<br/>
  @gmail.com</p></td>
 </tr>
 <tr>
  <td><p>22</p></td>
  <td><p>Nguyễn Công Sơn</p></td>
  <td><p>Chuyên viên</p></td>
  <td><p>3811352</p></td>
  <td><p>091.301.4479</p></td>
  <td><p>nguyencongsonmttq<br/>
  @gmail.com</p></td>
 </tr>
 <tr>
  <td><p>23</p></td>
  <td><p>Nguyễn Thị Thúy Trà</p></td>
  <td><p>Chuyên viên</p></td>
  <td><p>3811352</p></td>
  <td><p>094.514.7768</p></td>
  <td><p>tranguyennhe<br/>
  @gmail.com</p></td>
 </tr>
 <tr>
  <td><p>24</p></td>
  <td><p>Huỳnh Văn Hải</p></td>
  <td><p>Lái xe</p></td>
  <td><p>3822048</p></td>
  <td><p>093.554.1459</p></td>
  <td><p>Huynhhaihoinongdan<br/>
  @gmail.com</p></td>
 </tr>
 <tr>
  <td><p>25</p></td>
  <td><p>Phạm Quang Tường</p></td>
  <td><p>Nhân viên</p></td>
  <td><p>3822048</p></td>
  <td><p>098.829.3786</p></td>
  <td><p>phamtuong0183<br/>
  @gmail.com</p></td>
 </tr>
 <tr>
  <td><p>26</p></td>
  <td><p>Võ Đình Long</p></td>
  <td><p>Bảo vệ</p></td>
  <td><p>3822048</p></td>
  <td><p>036.708.2896</p></td>
  <td><p>&nbsp;</p></td>
 </tr>
      </tbody>
      </>
    ),
    photoName: "giaLai"
  },
  {
    nameProvince: "THÀNH PHỐ HÀ NỘI",
    address: "Số 29 Hoàng Diệu, phường Hà Đông, Hà Nội.",
    phone: "",
    website: "",
    email: "vanthu_hndhn@hanoi.gov.vn",
    zipCode: "0243",
    contentComponent: (
      <tbody>
        <tr>
  <th><p><b>TT</b></p></th>
  <th><p><b>Họ và tên</b></p></th>
  <th><p><b>Chức vụ</b></p></th>
  <th><p><b>Số điện thoại</b></p></th>
  <th><p><b>Email</b></p></th>
 </tr>
 <tr>
  <td><p>1</p></td>
  <td><p>Phạm Hải Hoa</p></td>
  <td><p>Chủ tịch</p></td>
  <td><p>0969.848.226</p></td>
  <td><p>phamhaihoa_hndtp<br/>
  @hanoi.gov.vn</p></td>
 </tr>
 <tr>
  <td><p>2</p></td>
  <td><p>Phạm Thị Thu Hiền</p></td>
  <td><p>Phó ban, GĐ Quỹ HTND</p></td>
  <td><p>0944.651.981</p></td>
  <td><p>phamthithuhien_hndtp<br/>
  @hanoi.gov.vn</p></td>
 </tr>
 <tr>
  <td><p>3</p></td>
  <td><p>Nguyễn Thị Hòa</p></td>
  <td><p>Phó ban</p></td>
  <td><p>097.284.8182</p></td>
  <td><p>nguyenthihoa_hndtp<br/>
  @hanoi.gov.vn</p></td>
 </tr>
 <tr>
  <td><p>4</p></td>
  <td><p>Lưu Thị Thu</p></td>
  <td><p>Phó ban</p></td>
  <td><p>0948.495.773</p></td>
  <td><p>luuthithu_hndtp<br/>
  @hanoi.gov.vn</p></td>
 </tr>
 <tr>
  <td><p>5</p></td>
  <td><p>Trịnh Thị Nguyệt Quế</p></td>
  <td><p>Kế toán quỹ</p></td>
  <td><p>090.469.9569</p></td>
  <td><p>trinhthinguyetque_hndtp<br/>
  @hanoi.gov.vn</p></td>
 </tr>
 <tr>
  <td><p>6</p></td>
  <td><p>Nguyễn Thị Luật</p></td>
  <td><p>Kế toán</p></td>
  <td><p>0983.563.983</p></td>
  <td><p>nguyenthiluat_hndtp<br/>
  @hanoi.gov.vn</p></td>
 </tr>
 <tr>
  <td><p>7</p></td>
  <td><p>Bùi Văn Thanh</p></td>
  <td><p>Chuyên viên</p></td>
  <td><p>08.266.266.82</p></td>
  <td><p>buivanthanh_hndtp<br/>
  @hanoi.gov.vn</p></td>
 </tr>
 <tr>
  <td><p>8</p></td>
  <td><p>Nguyễn Thị Thu Thủy</p></td>
  <td><p>Chuyên viên</p></td>
  <td><p>0915.66.2345</p></td>
  <td><p>nguyenthithuthuy_hndtp<br/>
  @hanoi.gov.vn</p></td>
 </tr>
 <tr>
  <td><p>9</p></td>
  <td><p>Lê Thu Hoàn</p></td>
  <td><p>Văn thư/Thủ quỹ</p></td>
  <td><p>0964.878.775</p></td>
  <td><p>lethuhoan_hndtp<br/>
  @hanoi.gov.vn</p></td>
 </tr>
 <tr>
  <td><p>10</p></td>
  <td><p>Nguyễn Anh Đức</p></td>
  <td><p>Chuyên viên</p></td>
  <td><p>0356.053.530</p></td>
  <td><p>nguyenanhduc_hndtp<br/>
  @hanoi.gov.vn</p></td>
 </tr>
 <tr>
  <td><p>11</p></td>
  <td><p>Tô Thị Thanh Huyền</p></td>
  <td><p>Chuyên viên</p></td>
  <td><p>0946.881.838</p></td>
  <td><p>tothithanhhuyen_hndtp<br/>
  @hanoi.gov.vn</p></td>
 </tr>
 <tr>
  <td><p>12</p></td>
  <td><p>Bùi Thị Hải Yến</p></td>
  <td><p>Chuyên viên</p></td>
  <td><p>0975.497.693</p></td>
  <td><p>buithihaiyen_hndtp<br/>
  @hanoi.gov.vn</p></td>
 </tr>
 <tr>
  <td><p>13</p></td>
  <td><p>Trịnh Thị Thanh Thủy</p></td>
  <td><p>Cán bộ</p></td>
  <td><p>0975.781.268</p></td>
  <td></td>
 </tr>
 <tr>
  <td><p>14</p></td>
  <td><p>Nguyễn Thị Kiều Mai</p></td>
  <td><p>Tạp vụ</p></td>
  <td><p>0345.334.388</p></td>
  <td></td>
 </tr>
 <tr>
  <td><p>15</p></td>
  <td><p>Tạ Xuân Trường</p></td>
  <td><p>Lái xe</p></td>
  <td><p>0904.736.869</p></td>
  <td></td>
 </tr>
 <tr>
  <td><p>16</p></td>
  <td><p>Vũ Thế Sinh</p></td>
  <td><p>Bảo vệ</p></td>
  <td><p>0332.893.509</p></td>
  <td></td>
 </tr>
 <tr>
  <td><p>17</p></td>
  <td><p>Nguyễn Văn Hợp</p></td>
  <td><p>Bảo vệ</p></td>
  <td><p>0332.893.509</p></td>
  <td></td>
 </tr>
</tbody>
    ),
    photoName: "haNoi"
  },
  {
    nameProvince: "TỈNH HÀ TĨNH",
    address: "số 16 đường Võ Liêm Sơn, phường Thành Sen, tỉnh Hà Tĩnh.",
    phone: "",
    website: "https://hoinongdanhatinh.vn",
    email: "",
    zipCode: "",
    contentComponent: (
      <tbody>
    <tr>
  <th><p><b>TT</b></p></th>
  <th><p><b>Họ và tên</b></p></th>
  <th><p><b>Chức vụ</b></p></th>
  <th><p><b>Số điện thoại</b></p></th>
 </tr>
 <tr>
  <td><p>1</p></td>
  <td><p>Ngô Văn Huỳnh</p></td>
  <td><p>Chủ tịch</p></td>
  <td><p>0912.626.728</p></td>
 </tr>
 <tr>
  <td><p>2</p></td>
  <td><p>Trần Đình Ước</p></td>
  <td><p>Phó Chủ tịch, Trưởng ban CTND</p></td>
  <td><p>0912.354.447</p></td>
 </tr>
 <tr>
  <td><p>3</p></td>
  <td><p>Nguyễn Tiến Anh</p></td>
  <td><p>Phó CT, Chánh VP MTTQ tỉnh</p></td>
  <td><p>0913.221.024</p></td>
 </tr>
 <tr>
  <td><p>4</p></td>
  <td><p>Phan Văn Hùng</p></td>
  <td><p>Giám đốc Trung tâm HTND</p></td>
  <td><p>0914.748.266</p></td>
 </tr>
 <tr>
  <td><p>5</p></td>
  <td><p>Nguyễn Thị Hồng Minh</p></td>
  <td><p>Phó ban</p></td>
  <td><p>0984.218.886</p></td>
 </tr>
 <tr>
  <td><p>6</p></td>
  <td><p>Phan Thị Lệ Hăng</p></td>
  <td><p>Phó ban</p></td>
  <td><p>0947.067.479</p></td>
 </tr>
 <tr>
  <td><p>7</p></td>
  <td><p>Lê Đình Hòa</p></td>
  <td><p>Phó ban</p></td>
  <td><p>0945.314.909</p></td>
 </tr>
 <tr>
  <td><p>8</p></td>
  <td><p>Nguyễn Thị Kim Nhung</p></td>
  <td><p>Phó ban</p></td>
  <td><p>0941.085.688</p></td>
 </tr>
 <tr>
  <td><p>9</p></td>
  <td><p>Trần Thị Thiêm</p></td>
  <td><p>Chuyên viên</p></td>
  <td><p>0915.466.768</p></td>
 </tr>
 <tr>
  <td><p>10</p></td>
  <td><p>Nguyễn Tố Nữ</p></td>
  <td><p>Chuyên viên</p></td>
  <td><p>0961.046.777</p></td>
 </tr>
 <tr>
  <td><p>11</p></td>
  <td><p>Lê Thị Như Quỳnh</p></td>
  <td><p>Chuyên viên</p></td>
  <td><p>0813.386.789</p></td>
 </tr>
</tbody>
    ),
    photoName: "haTinh"
  },
  {
    nameProvince: "THÀNH PHỐ HẢI PHÒNG",
    address: "Lô 26A đường Lê Hồng Phong, phường Gia Viên, TP Hải Phòng.",
    phone: "",
    website: "",
    email: "",
    zipCode: "",
    contentComponent: (
      <tbody>
    <tr>
  <th><p><b>TT</b></p></th>
  <th><p><b>Họ và tên</b></p></th>
  <th><p><b>Chức vụ</b></p></th>
  <th><p><b>Số điện thoại</b></p></th>
 </tr>
 <tr>
  <td><p>1</p></td>
  <td><p>Trịnh Văn Thiện</p></td>
  <td><p>Chủ tịch</p></td>
  <td><p>0915.019.043</p></td>
 </tr>
 <tr>
  <td><p>2</p></td>
  <td><p>Nguyễn Hồng Hưng</p></td>
  <td><p>Phó Chủ tịch</p></td>
  <td><p>0982.191.080</p></td>
 </tr>
 <tr>
  <td><p>3</p></td>
  <td><p>Đào Xuân Anh</p></td>
  <td><p>Phó Chủ tịch</p></td>
  <td><p>0915.415.498</p></td>
 </tr>
 <tr>
  <td><p>4</p></td>
  <td><p>Nguyễn Thị Mơ</p></td>
  <td><p>Ủy viên BTV</p></td>
  <td><p>0973.802.088</p></td>
 </tr>
 <tr>
  <td><p>5</p></td>
  <td><p>Nguyễn Ngọc Thoa</p></td>
  <td><p>Ủy viên BTV</p></td>
  <td><p>0852.902.718</p></td>
 </tr>
 <tr>
  <td><p>6</p></td>
  <td><p>Đỗ Đức Chung</p></td>
  <td><p>Ủy viên BTV</p></td>
  <td><p>0904.336.370</p></td>
 </tr>
 <tr>
  <td><p>7</p></td>
  <td><p>Nguyễn Xuân Thắng</p></td>
  <td><p>Ủy viên BTV</p></td>
  <td><p>0904.379.286</p></td>
 </tr>
 <tr>
  <td><p>8</p></td>
  <td><p>Nguyễn Đình Kiểm</p></td>
  <td><p>Ủy viên BTV</p></td>
  <td><p>0969.313.545</p></td>
 </tr>
 <tr>
  <td><p>9</p></td>
  <td><p>Đặng Quang Hưng</p></td>
  <td><p>Ủy viên BTV</p></td>
  <td><p>0984.084.729</p></td>
 </tr>
 <tr>
  <td><p>10</p></td>
  <td><p>Phạm Thị Minh Trà</p></td>
  <td><p>Ủy viên BCH</p></td>
  <td><p>0916.941.766</p></td>
 </tr>
 <tr>
  <td><p>11</p></td>
  <td><p>Trịnh Thị Thu Hằng</p></td>
  <td><p>Ủy viên BCH</p></td>
  <td><p>0904.466.786</p></td>
 </tr>
 <tr>
  <td><p>12</p></td>
  <td><p>Bùi Thị Thúy Phương</p></td>
  <td><p>Ủy viên BCH</p></td>
  <td><p>0906.281.369</p></td>
 </tr>
 <tr>
  <td><p>13</p></td>
  <td><p>Bùi Hải Hưng</p></td>
  <td><p>Ủy viên BCH</p></td>
  <td><p>0358.544.280</p></td>
 </tr>
 <tr>
  <td><p>14</p></td>
  <td><p>Bùi Mạnh Hà</p></td>
  <td><p>Ủy viên BCH</p></td>
  <td><p>0373.398.106</p></td>
 </tr>
 <tr>
  <td><p>15</p></td>
  <td><p>Lê Tất Tỉnh</p></td>
  <td><p>Chuyên viên</p></td>
  <td><p>0989.343.386</p></td>
 </tr>
 <tr>
  <td><p>16</p></td>
  <td><p>Lê Thị Nhàn</p></td>
  <td><p>Chuyên viên</p></td>
  <td><p>0986.375.675</p></td>
 </tr>
 <tr>
  <td><p>17</p></td>
  <td><p>Phạm Thị Luyến</p></td>
  <td><p>Chuyên viên</p></td>
  <td><p>0977.987.754</p></td>
 </tr>
 <tr>
  <td><p>18</p></td>
  <td><p>Vũ Thế Anh</p></td>
  <td><p>Chuyên viên</p></td>
  <td><p>0934.338.036</p></td>
 </tr>
 <tr>
  <td><p>19</p></td>
  <td><p>Nguyễn Thị Mai Hương</p></td>
  <td><p>Chuyên viên</p></td>
  <td><p>0919.237.089</p></td>
 </tr>
 <tr>
  <td><p>20</p></td>
  <td><p>Bùi Thị Thu Huyền</p></td>
  <td><p>Chuyên viên</p></td>
  <td><p>0983.799.219</p></td>
 </tr>
 <tr>
  <td><p>21</p></td>
  <td><p>Nguyễn Thị Minh Nguyệt</p></td>
  <td><p>Chuyên viên</p></td>
  <td><p>0966.987.790</p></td>
 </tr>
 <tr>
  <td><p>22</p></td>
  <td><p>Nguyễn Hồng Hạnh</p></td>
  <td><p>Chuyên viên</p></td>
  <td><p>0396.821.124</p></td>
 </tr>
 <tr>
  <td><p>23</p></td>
  <td><p>Ngô Thị Thơ</p></td>
  <td><p>Chuyên viên</p></td>
  <td><p>0973.064.359</p></td>
 </tr>
 <tr>
  <td><p>24</p></td>
  <td><p>Lê Việt Anh</p></td>
  <td><p>Chuyên viên</p></td>
  <td><p>0975.046.995</p></td>
 </tr>
 <tr>
  <td><p>25</p></td>
  <td><p>Lê Thị Hải Quyên</p></td>
  <td><p>Chuyên viên</p></td>
  <td><p>0915.988.344</p></td>
 </tr>
 <tr>
  <td><p>26</p></td>
  <td><p>Đỗ Thị Thơm</p></td>
  <td><p>Chuyên viên</p></td>
  <td><p>0979.713.925</p></td>
 </tr>
 <tr>
  <td><p>27</p></td>
  <td><p>Phan Thị Yến</p></td>
  <td><p>Chuyên viên</p></td>
  <td><p>0988.265.263</p></td>
 </tr>
 <tr>
  <td><p>28</p></td>
  <td><p>Nguyễn Thị Đoan</p></td>
  <td><p>Kế toán</p></td>
  <td><p>0906.435.502</p></td>
 </tr>
 <tr>
  <td><p>29</p></td>
  <td><p>Nguyễn Ngọc Cường</p></td>
  <td><p>Lái xe</p></td>
  <td><p>0396.969.736</p></td>
 </tr>
</tbody>
    ),
    photoName: "haiPhong"
  },
  {
    nameProvince: "TỈNH HƯNG YÊN",
    address: "Đường Quảng Trường, phường Phố Hiến, tỉnh Hưng Yên.",
    phone: "",
    website: "http://www.hoinongdanhungyen.org.vn",
    email: "hoinongdanhungyenph@gmail.com",
    zipCode: "02213",
    contentComponent: (
      <tbody>
    <tr>
  <th><p><b>TT</b></p></th>
  <th><p><b>Họ và tên</b></p></th>
  <th><p><b>Chức vụ</b></p></th>
  <th><p><b>Số điện thoại</b></p></th>
  <th><p><b>Email</b></p></th>
 </tr>
 <tr>
  <td><p>1</p></td>
  <td><p>Nguyễn Minh Hồng</p></td>
  <td><p>Chủ tịch</p></td>
  <td><p>0911.823.682</p></td>
  <td><p>Nmhong83<br/>
  @gmail.com</p></td>
 </tr>
 <tr>
  <td><p>2</p></td>
  <td><p>Lưu Tuấn Tú </p></td>
  <td><p>Phó Chủ tịch- Trưởng ban CTND</p></td>
  <td><p>0912.780.555</p></td>
  <td><p>tuantuhy74<br/>
  @gmail.com</p></td>
 </tr>
 <tr>
  <td><p>3</p></td>
  <td><p>Đào Thị Phương Thảo</p></td>
  <td><p>Phó Chủ tịch</p></td>
  <td><p>0918.586.918</p></td>
  <td><p>thaotdhy80<br/>
  @gmail.com</p></td>
 </tr>
 <tr>
  <td><p>4</p></td>
  <td><p>Vũ Trường Nam </p></td>
  <td><p>Phó ban</p></td>
  <td><p>0988.253.653</p></td>
  <td><p>vutruongnam75<br/>
  @gmail.com</p></td>
 </tr>
 <tr>
  <td><p>5</p></td>
  <td><p>Hà Văn Thịnh</p></td>
  <td><p>Phó ban</p></td>
  <td><p>0946.555.929</p></td>
  <td><p>havanthinh.hnd<br/>
  @gmail.com</p></td>
 </tr>
 <tr>
  <td><p>6</p></td>
  <td><p>Nguyễn Hoàng Thái</p></td>
  <td><p>Phó ban</p></td>
  <td><p>0904.653.368</p></td>
  <td><p>thaivnfu<br/>
  @gmail.com</p></td>
 </tr>
 <tr>
  <td><p>7</p></td>
  <td><p>Vũ Văn Kiên</p></td>
  <td><p>Phó ban</p></td>
  <td><p>0975.450.299</p></td>
  <td><p>vukienhndhy<br/>
  @gmail.com</p></td>
 </tr>
 <tr>
  <td><p>8</p></td>
  <td><p>Lại Thị Phượng</p></td>
  <td><p>Phó ban</p></td>
  <td><p>0914.525.186</p></td>
  <td><p>laiphuonghnd<br/>
  @gmail.com</p></td>
 </tr>
 <tr>
  <td><p>9</p></td>
  <td><p>Phạm Thanh Bình</p></td>
  <td><p>Phó ban</p></td>
  <td><p>0975.355.133</p></td>
  <td><p>thanhbinh76th<br/>
  @gmail.com</p></td>
 </tr>
 <tr>
  <td><p>10</p></td>
  <td><p>Nguyễn Minh Đức</p></td>
  <td><p>Phó ban</p></td>
  <td><p>0915.776.111</p></td>
  <td><p>hndthaibinh<br/>
  @gmail.com</p></td>
 </tr>
 <tr>
  <td><p>11</p></td>
  <td><p>Nguyễn Văn Cố </p></td>
  <td><p>Chuyên viên </p></td>
  <td><p>0353.585.099</p></td>
  <td><p>trungtamtuvanphapluathndhy<br/>
  @gmail.com</p></td>
 </tr>
 <tr>
  <td><p>12</p></td>
  <td><p>Trịnh Quang Hưng</p></td>
  <td><p>Chuyên viên </p></td>
  <td><p>0942.383.638</p></td>
  <td><p>Tqhungck19hua<br/>
  @gmail.com</p></td>
 </tr>
 <tr>
  <td><p>13</p></td>
  <td><p>Hà Thị Thuận</p></td>
  <td><p>Chuyên viên </p></td>
  <td><p>0868.923.923</p></td>
  <td><p>Hungthuan1203<br/>
  @gmail.com</p></td>
 </tr>
 <tr>
  <td><p>14</p></td>
  <td><p>Phạm Quang Trang</p></td>
  <td><p>Chuyên viên </p></td>
  <td><p>0978.397.289</p></td>
  <td><p>phamtrangfxr289<br/>
  @gmail.com</p></td>
 </tr>
 <tr>
  <td><p>15</p></td>
  <td><p>Doãn Thành Đạt</p></td>
  <td><p>Chuyên viên </p></td>
  <td><p>0916.959.199</p></td>
  <td><p>doanthanhdat982<br/>
  @gmail.com</p></td>
 </tr>
 <tr>
  <td><p>16</p></td>
  <td><p>Lê Thị Hồng Hạnh</p></td>
  <td><p>Chuyên viên </p></td>
  <td><p>0975.586.288</p></td>
  <td><p>lethihonghanh7101982<br/>
  @gmail.com</p></td>
 </tr>
 <tr>
  <td><p>17</p></td>
  <td><p>Nguyễn Thị Diệp</p></td>
  <td><p>Chuyên viên </p></td>
  <td><p>0973.888.865</p></td>
  <td><p>Huynhdiepanh<br/>
  @gmail.com</p></td>
 </tr>
 <tr>
  <td><p>18</p></td>
  <td><p>Vũ Thị Hồng Yến</p></td>
  <td><p>Chuyên viên </p></td>
  <td><p>0944.394.354</p></td>
  <td><p>vuyen.vuyen711<br/>
  @gmail.com</p></td>
 </tr>
 <tr>
  <td><p>19</p></td>
  <td><p>Nguyễn Thị Thu Hà</p></td>
  <td><p>Chuyên viên </p></td>
  <td><p>0967.968.955</p></td>
  <td><p>hndthaibinh<br/>
  @gmail.com</p></td>
 </tr>
 <tr>
  <td><p>20</p></td>
  <td><p>Nguyễn Thị Uyên</p></td>
  <td><p>Kế toán </p></td>
  <td><p>0984.915.318</p></td>
  <td><p>nguyenthuuyen211085<br/>
  @gmail.com</p></td>
 </tr>
 <tr>
  <td><p>21</p></td>
  <td><p>Lê Hồng Dương</p></td>
  <td><p>Lái xe</p></td>
  <td><p>0948.993.158</p></td>
  <td></td>
 </tr>
 <tr>
  <td><p>22</p></td>
  <td><p>Nhâm Gia Chính</p></td>
  <td><p>Lái xe</p></td>
  <td><p>0941.756.846</p></td>
  <td></td>
 </tr>
 <tr>
  <td><p>23</p></td>
  <td><p>Nguyễn Văn Lợi </p></td>
  <td><p>Lái xe</p></td>
  <td><p>0912.231.080</p></td>
  <td></td>
 </tr>
      </tbody>
    ),
    photoName: "hungYen"
  },
  {
    nameProvince: "TỈNH KHÁNH HÒA",
    address: "số 02 Ngô Quyền, phường Nha Trang, tỉnh Khánh Hòa.",
    phone: "0258.3560927",
    website: "https://hoinongdankhanhhoa.org.vn",
    email: "hndtkhanhhoa@gmail.com",
    zipCode: "",
    contentComponent: (
      <tbody>
    <tr>
  <th><p><b>TT</b></p></th>
  <th><p><b>Họ và tên</b></p></th>
  <th><p><b>Chức vụ</b></p></th>
  <th><p><b>Số điện thoại</b></p></th>
 </tr>
 <tr>
  <td><p>1</p></td>
  <td><p>Phan Thị Ngân Hạnh</p></td>
  <td><p>Chủ tịch</p></td>
  <td><p>091.893.5044</p></td>
 </tr>
 <tr>
  <td><p>2</p></td>
  <td><p>Lê Quốc Toàn</p></td>
  <td><p>Phó
  Chủ tịch TT,<br/>
  Trưởng Ban CTND</p></td>
  <td><p>077.545.1060</p></td>
 </tr>
 <tr>
  <td><p>3</p></td>
  <td><p>Phan Thị Phượng</p></td>
  <td><p>Phó Chủ
  tịch,<br/>
  Trưởng Ban Dân chủ, GS và PBXH</p></td>
  <td><p>093.804.7075</p></td>
 </tr>
 <tr>
  <td><p>4</p></td>
  <td><p>Thái Bá Hòa</p></td>
  <td><p>Phó Chủ tịch</p></td>
  <td><p>090.875.7669</p></td>
 </tr>
 <tr>
  <td><p>5</p></td>
  <td><p>Võ Trọng Hiếu</p></td>
  <td><p>Phó ban</p></td>
  <td><p>090.527.6430</p></td>
 </tr>
 <tr>
  <td><p>6</p></td>
  <td><p>Trượng Thị Như Ý</p></td>
  <td><p>Phó ban</p></td>
  <td><p>091.467.1767</p></td>
 </tr>
 <tr>
  <td><p>7</p></td>
  <td><p>Mai Dương</p></td>
  <td><p>Phó ban</p></td>
  <td><p>098.311.7058</p></td>
 </tr>
 <tr>
  <td><p>8</p></td>
  <td><p>Nguyễn Hà Ngọc Phương</p></td>
  <td><p>Phó ban</p></td>
  <td><p>091.413.7059</p></td>
 </tr>
 <tr>
  <td><p>9</p></td>
  <td><p>Nguyễn Thị Lê Uyên</p></td>
  <td><p>Phó ban</p></td>
  <td><p>090.247.1373</p></td>
 </tr>
 <tr>
  <td><p>10</p></td>
  <td><p>Ngô Xuân Nông</p></td>
  <td><p>Chuyên viên</p></td>
  <td><p>033.851.2027</p></td>
 </tr>
 <tr>
  <td><p>11</p></td>
  <td><p>Ngô Quốc Khánh</p></td>
  <td><p>Chuyên viên</p></td>
  <td><p>097.834.8380</p></td>
 </tr>
 <tr>
  <td><p>12</p></td>
  <td><p>Trần Việt Trung</p></td>
  <td><p>Chuyên viên</p></td>
  <td><p>078.773.8179</p></td>
 </tr>
 <tr>
  <td><p>13</p></td>
  <td><p>Nguyễn Ngọc Hiền Trang</p></td>
  <td><p>Chuyên viên</p></td>
  <td><p>090.933.0382</p></td>
 </tr>
 <tr>
  <td><p>14</p></td>
  <td><p>Nguyễn Thị Thu Hà</p></td>
  <td><p>Kế toán</p></td>
  <td><p>037.377.4311</p></td>
 </tr>
</tbody>
    ),
    photoName: "khanhHoa"
  },
  {
    nameProvince: "TỈNH LAI CHÂU",
    address: "Tầng 6, Nhà C, Trung tâm HCCT tỉnh Lai Châu, phường Tân Phong, tỉnh Lai Châu.",
    phone: "021.338.91438",
    website: "https://hoinongdan.laichau.gov.vn",
    email: "",
    zipCode: "",
    contentComponent: (
      <tbody>
    <tr>
  <th><p><b>TT</b></p></th>
  <th><p><b>Họ và tên</b></p></th>
  <th><p><b>Chức vụ</b></p></th>
  <th><p><b>Số điện thoại</b></p></th>
  <th><p><b>Email</b></p></th>
 </tr>
 <tr>
  <td><p>1</p></td>
  <td><p>Phạm Ngọc Đang</p></td>
  <td><p>Phó Chủ tịch</p></td>
  <td><p>096.365.4888</p></td>
  <td><p>&nbsp;</p></td>
 </tr>
 <tr>
  <td><p>2</p></td>
  <td><p>Lò Minh Hiếu</p></td>
  <td><p>Phó Chủ tịch</p></td>
  <td><p>082.551.2999</p></td>
  <td><p>&nbsp;</p></td>
 </tr>
 <tr>
  <td><p>3</p></td>
  <td><p>Bùi Văn Toán</p></td>
  <td><p>Phó ban</p></td>
  <td><p>036.678.8494</p><p>084.398.6586</p></td>
  <td><p>toan83hndlaichau<br/>
  @gmail.com</p></td>
 </tr>
 <tr>
  <td><p>4</p></td>
  <td><p>Phàng Thị Bích Hoa</p></td>
  <td><p>Phó ban</p></td>
  <td><p>035.756.4569</p></td>
  <td><p>hoahndlaichau<br/>
  @gmail.com</p>
  <p>&nbsp;</p></td>
 </tr>
 <tr>
  <td><p>5</p></td>
  <td><p>Lưu Thị Nhung</p></td>
  <td><p>Chuyên viên</p></td>
  <td><p>097.335.8296</p></td>
  <td><p>nguyenthanhvinh552010@gmail.com<br/>
  @gmail.com</p>
  <p>&nbsp;</p></td>
 </tr>
 <tr>
  <td><p>6</p></td>
  <td><p>Lò Thị Hà</p></td>
  <td><p>Chuyên viên</p></td>
  <td><p>097.335.8296</p></td>
  <td><p>lohatdlc<br/>
  @gmail.com</p>
  </td>
 </tr>
 <tr>
  <td><p>7</p></td>
  <td><p>Phạm Thị Thoa</p></td>
  <td><p>Chuyên viên</p></td>
  <td><p>094.452.6974</p></td>
  <td><p>thoaminhha<br/>
  @gmail.com</p></td>
 </tr>
 <tr>
  <td><p>8</p></td>
  <td><p>Ngô Thị Hiền</p></td>
  <td><p>Chuyên viên</p></td>
  <td><p>091.796.4129</p></td>
  <td><p>ngothihienbvlp<br/>
  @gmail.com</p></td>
 </tr>
 <tr>
  <td><p>9</p></td>
  <td><p>Vũ Đức Long</p></td>
  <td><p>Chuyên viên</p></td>
  <td><p>090.171.9668</p><p>091.514.3229</p></td>
  <td><p>longhnd<br/>
  @gmail.com</p></td>
 </tr>
 <tr>
  <td><p>10</p></td>
  <td><p>Thùng Xuân Thành</p></td>
  <td><p>Chuyên viên</p></td>
  <td><p>098.285.5005</p><p>033.687.7889</p></td>
  <td><p>xuanthanhhnd<br/>
  @gmail.com</p></td>
 </tr>
</tbody>
    ),
    photoName: "laiChau"
  },
  {
    nameProvince: "TỈNH LẠNG SƠN",
    address: "Số 6, đường Văn Cao, phường Lương Văn Tri, tỉnh Lạng Sơn.",
    phone: "(0205) 3 810 407",
    website: "",
    email: "hoind@langson.gov.vn",
    zipCode: "0205",
    contentComponent: (
      <tbody>
    <tr>
  <th><p><b>TT</b></p></th>
  <th><p><b>Họ và tên</b></p></th>
  <th><p><b>Chức vụ</b></p></th>
  <th><p><b>Số điện thoại</b></p></th>
 </tr>
 <tr>
  <td><p>1</p></td>
  <td><p>Bùi Văn Côi</p></td>
  <td><p>Phó Chủ tịch Hội ND, kiêm Trưởng Ban CTND</p></td>
  <td><p>091.283.1888</p></td>
 </tr>
 <tr>
  <td><p>2</p></td>
  <td><p>Hoàng Thị Huế</p></td>
  <td><p>Phó ban</p></td>
  <td><p>090.400.2976</p></td>
 </tr>
 <tr>
  <td><p>3</p></td>
  <td><p>Hoàng Thanh Châm</p></td>
  <td><p>Phó ban</p></td>
  <td><p>098.820.6555</p></td>
 </tr>
 <tr>
  <td><p>4</p></td>
  <td><p>Đặng Thị Thúy</p></td>
  <td><p>Chuyên viên</p></td>
  <td><p>091.896.9889</p></td>
 </tr>
 <tr>
  <td><p>5</p></td>
  <td><p>Hoàng Thị Hải Yến</p></td>
  <td><p>Chuyên viên</p></td>
  <td><p>091.235.9985</p></td>
 </tr>
 <tr>
  <td><p>6</p></td>
  <td><p>Hoàng Công Hưng</p></td>
  <td><p>Chuyên viên</p></td>
  <td><p>098.344.6333</p></td>
 </tr>
 <tr>
  <td><p>7</p></td>
  <td><p>Lý Thị Hường</p></td>
  <td><p>Chuyên viên</p></td>
  <td><p>083.534.3888</p></td>
 </tr>
 <tr>
  <td><p>8</p></td>
  <td><p>Nông Thị Dung</p></td>
  <td><p>Chuyên viên</p></td>
  <td><p>091.662.4970</p></td>
 </tr>
 <tr>
  <td><p>9</p></td>
  <td><p>Mã Thùy Linh</p></td>
  <td><p>Chuyên viên</p></td>
  <td><p>038.967.3322</p></td>
 </tr>
</tbody>
    ),
    photoName: "langSon"
  },
  {
    nameProvince: "TỈNH LÀO CAI",
    address: "Tổ dân phố Thanh Hùng, phường Văn Phú, tỉnh Lào Cai.",
    phone: "097.599.9626",
    website: "https://hoinongdan.laocai.org.vn",
    email: "contact-hnd@laocai.gov.vn",
    zipCode: "",
    contentComponent: (
      <tbody>
    <tr>
  <th><p><b>TT</b></p></th>
  <th><p><b>Họ và tên</b></p></th>
  <th><p><b>Chức vụ</b></p></th>
  <th><p><b>Số điện thoại</b></p></th>
 </tr>
 <tr>
  <td><p>1</p></td>
  <td><p>Nguyễn Thị Phương Đông</p></td>
  <td><p>Phó Chủ tịch kiêm trưởng ban CTND</p></td>
  <td><p>0988.515.070</p></td>
 </tr>
 <tr>
  <td><p>2</p></td>
  <td><p>Đỗ Thị Thu Hiền</p></td>
  <td><p>Phó ban</p></td>
  <td><p>0974.522.511</p></td>
 </tr>
 <tr>
  <td><p>3</p></td>
  <td><p>Nguyễn Đức Thịnh</p></td>
  <td><p>Phó ban</p></td>
  <td><p>0983.169.122</p></td>
 </tr>
 <tr>
  <td><p>4</p></td>
  <td><p>Lê Như Quỳnh</p></td>
  <td><p>Kế toán, Chuyên viên</p></td>
  <td><p>0832.104.453</p></td>
 </tr>
 <tr>
  <td><p>5</p></td>
  <td><p>Hòa Thị Hà</p></td>
  <td><p>Chuyên viên</p></td>
  <td><p>0986.865.459</p></td>
 </tr>
 <tr>
  <td><p>6</p></td>
  <td><p>Hoàng Thái Xuân</p></td>
  <td><p>Văn thư - Lưu trữ</p></td>
  <td><p>0975.999.626</p></td>
 </tr>
 <tr>
  <td><p>7</p></td>
  <td><p>Lã Hồng Giang</p></td>
  <td><p>Nhân viên</p></td>
  <td><p>0984.739.806</p></td>
 </tr>
 <tr>
  <td><p>8</p></td>
  <td><p>Đỗ Tuấn Ngọc</p></td>
  <td><p>Lái xe</p></td>
  <td><p>0984.783.115</p></td>
 </tr>
 <tr>
  <td><p>9</p></td>
  <td><p>Đỗ Thanh Tùng</p></td>
  <td><p>Phó ban</p></td>
  <td><p>0986.109.204</p></td>
 </tr>
 <tr>
  <td><p>10</p></td>
  <td><p>Hạ Thị Khánh Nguyệt</p></td>
  <td><p>Phó ban</p></td>
  <td><p>0976.778.188</p></td>
 </tr>
 <tr>
  <td><p>11</p></td>
  <td><p>Cao Thị Hằng Nga</p></td>
  <td><p>Phó ban</p></td>
  <td><p>0972.060.135</p></td>
 </tr>
 <tr>
  <td><p>12</p></td>
  <td><p>Hà Thị Thu Hương</p></td>
  <td><p>Phó ban</p></td>
  <td><p>0974.890.928</p></td>
 </tr>
 <tr>
  <td><p>13</p></td>
  <td><p>Đặng Thị Thu Thịnh</p></td>
  <td><p>Chuyên viên</p></td>
  <td><p>0967.382.074</p></td>
 </tr>
 <tr>
  <td><p>14</p></td>
  <td><p>Hoàng Thị Minh Huệ</p></td>
  <td><p>Chuyên viên</p></td>
  <td><p>0333.499.666</p></td>
 </tr>
 <tr>
  <td><p>15</p></td>
  <td><p>Vũ Tuyết Mai</p></td>
  <td><p>Chuyên viên</p></td>
  <td><p>0973.315.807</p></td>
 </tr>
 <tr>
  <td><p>16</p></td>
  <td><p>Vũ Thị Hạnh</p></td>
  <td><p>Phó ban</p></td>
  <td><p>0982.463.538</p></td>
 </tr>
 <tr>
  <td><p>17</p></td>
  <td><p>Hà Thị Liên Phương</p></td>
  <td><p>Phó ban</p></td>
  <td><p>0912.439.434</p></td>
 </tr>
 <tr>
  <td><p>18</p></td>
  <td><p>Nguyễn Thị Thanh Thuỷ</p></td>
  <td><p>Chuyên viên</p></td>
  <td><p>0978.255.994</p></td>
 </tr>
 <tr>
  <td><p>19</p></td>
  <td><p>Đinh Trọng Giáp</p></td>
  <td><p>Chuyên viên</p></td>
  <td><p>0965.133.336</p></td>
 </tr>
 <tr>
  <td><p>20</p></td>
  <td><p>Nguyễn Vĩnh Thắng</p></td>
  <td><p>Chuyên viên</p></td>
  <td><p>0978 12 3915</p></td>
 </tr>
 <tr>
  <td><p>21</p></td>
  <td><p>Dương Thị Yến</p></td>
  <td><p>Chuyên viên</p></td>
  <td><p>0946.134.428</p></td>
 </tr>
</tbody>
    ),
    photoName: "laoCai"
  },
  {
    nameProvince: "TỈNH LÂM ĐỒNG",
    address: "Số 50 Quang Trung, phường Lâm Viên – Đà Lạt, tỉnh Lâm Đồng.",
    phone: "0263.3822.323",
    website: "hnd.lamdong.gov.vn  ",
    email: "hnd@lamdong.gov.vn hoặc lamdong.hnd@gmail.com",
    zipCode: "0263",
    contentComponent: (
      <tbody>
    <tr>
  <th><p><b>TT</b></p></th>
  <th><p><b>Họ và tên</b></p></th>
  <th><p><b>Chức vụ</b></p></th>
  <th><p><b>Số điện thoại</b></p></th>
  <th><p><b>Email</b></p></th>
 </tr>
 <tr>
  <td><p>1</p></td>
  <td><p>Trương Văn Tùng</p></td>
  <td><p>Chủ tịch</p></td>
  <td><p>093.381.7777</p></td>
  <td><p><a href="mailto:tungtv@lamdong.gov.vn">tungtv<br/>
  @lamdong.gov.vn</a></p></td>
 </tr>
 <tr>
  <td><p>2</p></td>
  <td><p>Trần Thị Oanh</p></td>
  <td><p>Phó Chủ tịch kiêm Trưởng Ban CTND</p></td>
  <td><p>096.820.8997</p></td>
  <td><p><a href="mailto:oanhdate77@gmail.com">oanhdate77<br/>
  @gmail.com</a></p></td>
 </tr>
 <tr>
  <td><p>3</p></td>
  <td><p>Nguyễn Đức Hán</p></td>
  <td><p>Phó Chủ tịch</p></td>
  <td><p>091.420.7676</p></td>
  <td><p><a href="mailto:nguyen.duchan708@gmail.">nguyen.duchan708<br/>
  @gmail.</a></p></td>
 </tr>
 <tr>
  <td><p>4</p></td>
  <td><p>Phạm Ngọc Trà Ly</p></td>
  <td><p>Phó Ban TT Ban CTND</p></td>
  <td><p>090.937.3300</p></td>
  <td><p><a href="mailto:traly.pham@gmail.com">traly.pham<br/>
  @gmail.com</a></p></td>
 </tr>
 <tr>
  <td><p>5</p></td>
  <td><p>Nông Đức Thuận</p></td>
  <td><p>Phó ban</p></td>
  <td><p>097.553.4273</p></td>
  <td><p><a href="mailto:thuanmtk30@gmail.com">thuanmtk30<br/>
  @gmail.com</a></p></td>
 </tr>
 <tr>
  <td><p>6</p></td>
  <td><p>Bùi Trần Thảo Ly</p></td>
  <td><p>Phó ban</p></td>
  <td><p>090.832.1431</p></td>
  <td><p><a href="mailto:bantinnongdanlamdong@gmail.com">bantinnongdanlamdong<br/>
  @gmail.com</a></p></td>
 </tr>
 <tr>
  <td><p>7</p></td>
  <td><p>Nguyễn Thị Thùy Trinh</p></td>
  <td><p>Phó ban</p></td>
  <td><p>093.741.0101</p></td>
  <td><p><a href="mailto:thuytrinhhnd2011@gmail.com">thuytrinhhnd2011<br/>
  @gmail.com</a></p></td>
 </tr>
 <tr>
  <td><p>8</p></td>
  <td><p>Mai Văn Long</p></td>
  <td><p>Phó ban</p></td>
  <td><p>090.654.7778</p></td>
  <td><p><a href="mailto:maivanlong01@gmail.com">maivanlong01<br/>
  @gmail.com</a></p></td>
 </tr>
 <tr>
  <td><p>9</p></td>
  <td><p>Nguyễn Văn Long</p></td>
  <td><p>Phó ban</p></td>
  <td><p>094.215.1097</p></td>
  <td><p><a href="mailto:longktxh2011@gmail.com">longktxh2011<br/>
  @gmail.com</a></p></td>
 </tr>
 <tr>
  <td><p>10</p></td>
  <td><p>Ngô Xuân Diện</p></td>
  <td><p>Phó ban</p></td>
  <td><p>091.997.9209</p></td>
  <td><p><a href="mailto:xuandiendr@gmail.com">xuandiendr<br/>
  @gmail.com</a></p></td>
 </tr>
 <tr>
  <td><p>11</p></td>
  <td><p>Lê Hiếu</p></td>
  <td><p>Chuyên viên</p></td>
  <td><p>033.642.4160</p></td>
  <td><p><a href="mailto:lehieu18071990@gmail.com">lehieu18071990<br/>
  @gmail.com</a></p></td>
 </tr>
 <tr>
  <td><p>12</p></td>
  <td><p>Nguyễn Thị Ngọc Trâm</p></td>
  <td><p>Chuyên viên</p></td>
  <td><p>090.805.0644</p></td>
  <td><p><a href="mailto:ntnt.nguyentram@gmail.com">ntnt.nguyentram<br/>
  @gmail.com</a></p></td>
 </tr>
 <tr>
  <td><p>13</p></td>
  <td><p>Lê Hồng Nhạn</p></td>
  <td><p>Chuyên viên</p></td>
  <td><p>098.845.1011</p></td>
  <td><p><a href="mailto:hongnhanhnd@gmail.com">hongnhanhnd<br/>
  @gmail.com</a></p></td>
 </tr>
 <tr>
  <td><p>14</p></td>
  <td><p>Lê Thị Kiều Hoa</p></td>
  <td><p>Chuyên viên</p></td>
  <td><p>091.782.1819</p></td>
  <td><p><a href="mailto:kieuhoa0309@gmail.com">kieuhoa0309<br/>
  @gmail.com</a></p></td>
 </tr>
 <tr>
  <td><p>15</p></td>
  <td><p>Nguyễn Thị Thùy Linh</p></td>
  <td><p>Chuyên viên</p></td>
  <td><p>036.856.5744</p></td>
  <td><p><a href="mailto:thuylinhpt0512@gmail.com">thuylinhpt0512<br/>
  @gmail.com</a></p></td>
 </tr>
 <tr>
  <td><p>16</p></td>
  <td><p>Dương Thị Thu Sang</p></td>
  <td><p>Chuyên viên</p></td>
  <td><p>098.485.8993</p></td>
  <td><p><a href="mailto:duongthusang2013@gmail.com">duongthusang2013<br/>
  @gmail.com</a></p></td>
 </tr>
 <tr>
  <td><p>17</p></td>
  <td><p>Nguyễn Lâm Thuận</p></td>
  <td><p>Chuyên viên</p></td>
  <td><p>091.961.5460</p></td>
  <td><p><a href="mailto:thuanhndbt@gmail.com">thuanhndbt<br/>
  @gmail.com</a></p></td>
 </tr>
 <tr>
  <td><p>18</p></td>
  <td><p>Phan Quốc Chính</p></td>
  <td><p>Chuyên viên</p></td>
  <td><p>097.588.6885</p></td>
  <td><p><a href="mailto:phanquocchinhdl@gmail.com">phanquocchinhdl<br/>
  @gmail.com</a></p></td>
 </tr>
 <tr>
  <td><p>19</p></td>
  <td><p>Bùi Duy Đức</p></td>
  <td><p>Chuyên viên</p></td>
  <td><p>091.939.8884</p></td>
  <td><p><a href="mailto:mrduy8884@gmail.com">mrduy8884<br/>
  @gmail.com</a></p></td>
 </tr>
 <tr>
  <td><p>20</p></td>
  <td><p>Trần Thế Quang</p></td>
  <td><p>Chuyên viên</p></td>
  <td><p>086.670.8141</p></td>
  <td><p><a href="mailto:quangcctyld@gmail.com">quangcctyld<br/>
  @gmail.com</a></p></td>
 </tr>
 <tr>
  <td><p>21</p></td>
  <td><p>Võ Duy Khoa</p></td>
  <td><p>Chuyên viên</p></td>
  <td><p>091.827.6013</p></td>
  <td><p><a href="mailto:duykhoahnd@gmail.com">duykhoahnd<br/>
  @gmail.com</a></p></td>
 </tr>
 <tr>
  <td><p>22</p></td>
  <td><p>Trần Thị Mai Anh</p></td>
  <td><p>Chuyên viên</p></td>
  <td><p>098.972.3319</p></td>
  <td><p><a href="mailto:maianh1199@gmail.com">maianh1199<br/>
  @gmail.com</a></p></td>
 </tr>
 <tr>
  <td><p>23</p></td>
  <td><p>Lương Thị Vân Anh</p></td>
  <td><p>Chuyên viên</p></td>
  <td><p>097.999.8772</p></td>
  <td><p>luongthivananhdn87<br/>
  @gmail.com</p></td>
 </tr>
 <tr>
  <td><p>24</p></td>
  <td><p>Huỳnh Thị Mỹ Oanh</p></td>
  <td><p>Chuyên viên</p></td>
  <td><p>097.945.4847</p></td>
  <td><p><a href="mailto:oanh.hnd.bt@gmail.com">oanh.hnd.bt<br/>
  @gmail.com</a></p></td>
 </tr>
 <tr>
  <td><p>25</p></td>
  <td><p>Hồ Thị Thanh Hoa</p></td>
  <td><p>Chuyên viên</p></td>
  <td><p>096.723.4839</p></td>
  <td><p><a href="mailto:thanhhoaqb306@gmail.com">thanhhoaqb306<br/>
  @gmail.com</a></p></td>
 </tr>
 <tr>
  <td><p>26</p></td>
  <td><p>Phan Thị Hương</p></td>
  <td><p>Chuyên viên</p></td>
  <td><p>094.865.2311</p></td>
  <td><p><a href="mailto:phanhuongdalat@gmail.com">phanhuongdalat<br/>
  @gmail.com</a></p></td>
 </tr>
 <tr>
  <td><p>27</p></td>
  <td><p>Thái Thanh Tâm</p></td>
  <td><p>Chuyên viên</p></td>
  <td><p>097.611.0720</p></td>
  <td><p><a href="mailto:thaitamttdn@gmail.com">thaitamttdn<br/>
  @gmail.com</a></p></td>
 </tr>
 <tr>
  <td><p>28</p></td>
  <td><p>Trần Thị Minh Phương</p></td>
  <td><p>Chuyên viên</p></td>
  <td><p>098.774.4647</p></td>
  <td><p><a href="mailto:minhphuong09022011@gmail.com">minhphuong09022011<br/>
  @gmail.com</a></p></td>
 </tr>
 <tr>
  <td><p>29</p></td>
  <td><p>Vũ Thị Diệp</p></td>
  <td><p>Chuyên viên</p></td>
  <td><p>091.424.1584</p></td>
  <td><p><a href="mailto:dieulinhhaloween@gmail.com">dieulinhhaloween<br/>
  @gmail.com</a></p></td>
 </tr>
 <tr>
  <td><p>30</p></td>
  <td><p>Nguyễn Hoàng Thùy Duyên</p></td>
  <td><p>Kế toán</p></td>
  <td><p>097.378.8488</p></td>
  <td><p><a href="mailto:duyennht.hnd@gmail.com">duyennht.hnd<br/>
  @gmail.com</a></p></td>
 </tr>
 <tr>
  <td><p>31</p></td>
  <td><p>Nguyễn Thị Nhơn</p></td>
  <td><p>Kế toán </p></td>
  <td><p>091.789.9178</p></td>
  <td><p><a href="mailto:nguyennhon1981tb@gmail.com">nguyennhon1981tb<br/>
  @gmail.com</a></p></td>
 </tr>
 <tr>
  <td><p>32</p></td>
  <td><p>Cao Thị Huyền Anh</p></td>
  <td><p>Kế toán</p></td>
  <td><p>094.979.8177</p></td>
  <td><p><a href="mailto:huyenanhlt2015@gmail.com">huyenanhlt2015<br/>
  @gmail.com</a></p></td>
 </tr>
 <tr>
  <td><p>33</p></td>
  <td><p>Nguyễn Thế Ngọc Trâm</p></td>
  <td><p>Văn thư</p></td>
  <td><p>098.828.1733</p></td>
  <td><p><a href="mailto:nguyentram1804@gmail.com">nguyentram1804<br/>
  @gmail.com</a></p></td>
 </tr>
</tbody>
    ),
    photoName: "lamDong"
  },
  {
    nameProvince: "TỈNH NINH BÌNH",
    address: "Đường Đại Cồ Việt, phường Hoa Lư, Tỉnh Ninh Bình.",
    phone: "",
    website: "www.hoinongdanninhbinh.org.vn",
    email: "",
    zipCode: "",
    contentComponent: (
      <tbody>
    <tr>
  <th><p><b>TT</b></p></th>
  <th><p><b>Họ tên</b></p></th>
  <th><p><b>Chức vụ</b></p></th>
  <th><p><b>Số điện thoại</b></p></th>
 </tr>
 <tr>
  <td><p>1</p></td>
  <td><p>Triệu Văn Thái</p></td>
  <td><p>Chủ tịch </p></td>
  <td><p>0905.279.555</p></td>
 </tr>
 <tr>
  <td><p>2</p></td>
  <td><p>Tô Xuân Hiệp</p></td>
  <td><p>Phó Chủ tịch </p></td>
  <td><p>0912.894.209</p></td>
 </tr>
 <tr>
  <td><p>3</p></td>
  <td><p>Phạm Thị Thanh Huyền</p></td>
  <td><p>Phó Chủ tịch </p></td>
  <td><p>0988.424.757</p></td>
 </tr>
 <tr>
  <td><p>4</p></td>
  <td><p>Hoàng Ngọc Chinh</p></td>
  <td><p>Phó Chủ tịch, Trưởng ban CTND</p></td>
  <td><p>0916.868.892</p></td>
 </tr>
 <tr>
  <td><p>5</p></td>
  <td><p>Ngô Văn Toản</p></td>
  <td><p>Phó Chủ tịch </p></td>
  <td><p>0946.225.188</p></td>
 </tr>
 <tr>
  <td><p>6</p></td>
  <td><p>Nguyễn Thị Phương Quỳnh</p></td>
  <td><p>Phó Chủ tịch </p></td>
  <td><p>0918.758.385</p></td>
 </tr>
 <tr>
  <td><p>7</p></td>
  <td><p>Nguyễn Thanh Nghị</p></td>
  <td><p>Phó ban </p></td>
  <td><p>0915.666.289</p></td>
 </tr>
 <tr>
  <td><p>8</p></td>
  <td><p>Trương Thị Thu Thủy</p></td>
  <td><p>Phó ban </p></td>
  <td><p>0915.727.168</p></td>
 </tr>
 <tr>
  <td><p>9</p></td>
  <td><p>Hoàng Thị Nhung</p></td>
  <td><p>Phó ban </p></td>
  <td><p>0913.561.276</p></td>
 </tr>
 <tr>
  <td><p>10</p></td>
  <td><p>Nguyễn Văn Chiến</p></td>
  <td><p>Phó ban </p></td>
  <td><p>0946.064.382</p></td>
 </tr>
 <tr>
  <td><p>11</p></td>
  <td><p>Phạm Văn Hậu</p></td>
  <td><p>Phó ban </p></td>
  <td><p>0916.139.930</p></td>
 </tr>
 <tr>
  <td><p>12</p></td>
  <td><p>Nguyễn Thị Hằng</p></td>
  <td><p>Phó ban </p></td>
  <td><p>0949.563.221</p></td>
 </tr>
 <tr>
  <td><p>13</p></td>
  <td><p>Phạm Minh Quyết</p></td>
  <td><p>Phó ban </p></td>
  <td><p>0944.598.006</p></td>
 </tr>
 <tr>
  <td><p>14</p></td>
  <td><p>Khổng Thị Tám</p></td>
  <td><p>Phó ban </p></td>
  <td><p>0983.538.058</p></td>
 </tr>
 <tr>
  <td><p>15</p></td>
  <td><p>Trần Thị Huệ</p></td>
  <td><p>Phó ban </p></td>
  <td><p>0984.973.505</p></td>
 </tr>
 <tr>
  <td><p>16</p></td>
  <td><p>Lê Văn Tấn</p></td>
  <td><p>Phó ban </p></td>
  <td><p>0918.762.935</p></td>
 </tr>
 <tr>
  <td><p>17</p></td>
  <td><p>Trần Thọ Đan</p></td>
  <td><p>Giám đốc TTDN và HTND tỉnh </p></td>
  <td><p>0949.135.861</p></td>
 </tr>
 <tr>
  <td><p>18</p></td>
  <td><p>Đỗ Văn Cường</p></td>
  <td><p>Phó giám đốc TTDN và HTND tỉnh </p></td>
  <td><p>0912.161.011</p></td>
 </tr>
 <tr>
  <td><p>19</p></td>
  <td><p>Nguyễn Thanh Khiêm</p></td>
  <td><p>Chuyên viên </p></td>
  <td><p>0914.530.498</p></td>
 </tr>
 <tr>
  <td><p>20</p></td>
  <td><p>Nguyễn Thị Thùy Linh</p></td>
  <td><p>Chuyên viên </p></td>
  <td><p>0911.189.789</p></td>
 </tr>
 <tr>
  <td><p>21</p></td>
  <td><p>Phạm Hoài Linh</p></td>
  <td><p>Chuyên viên </p></td>
  <td><p>0918.955.356</p></td>
 </tr>
 <tr>
  <td><p>22</p></td>
  <td><p>Vũ Khánh Linh</p></td>
  <td><p>Văn thư </p></td>
  <td><p>0338.709.402</p></td>
 </tr>
 <tr>
  <td><p>23</p></td>
  <td><p>Phạm Thị Xuyên</p></td>
  <td><p>Văn thư </p></td>
  <td><p>0912.062.368</p></td>
 </tr>
 <tr>
  <td><p>24</p></td>
  <td><p>Vũ Thị Thu Huyền</p></td>
  <td><p>Chuyên viên </p></td>
  <td><p>0983.734.783</p></td>
 </tr>
 <tr>
  <td><p>25</p></td>
  <td><p>Trần Văn Phúc</p></td>
  <td><p>Chuyên viên </p></td>
  <td><p>0834.918.525</p></td>
 </tr>
 <tr>
  <td><p>26</p></td>
  <td><p>Trần Thị Mai Hương</p></td>
  <td><p>Chuyên viên </p></td>
  <td><p>0983.318.695</p></td>
 </tr>
 <tr>
  <td><p>27</p></td>
  <td><p>Trần Vũ</p></td>
  <td><p>Chuyên viên </p></td>
  <td><p>0912.829.957</p></td>
 </tr>
 <tr>
  <td><p>28</p></td>
  <td><p>Nguyễn Thị Thu Hương</p></td>
  <td><p>Chuyên viên </p></td>
  <td><p>0944.486.415</p></td>
 </tr>
 <tr>
  <td><p>29</p></td>
  <td><p>Phạm Trung Kiên</p></td>
  <td><p>Chuyên viên </p></td>
  <td><p>0914.727.827</p></td>
 </tr>
 <tr>
  <td><p>30</p></td>
  <td><p>Trần Thị Thanh Mai</p></td>
  <td><p>Chuyên viên </p></td>
  <td><p>0838.232.266</p></td>
 </tr>
 <tr>
  <td><p>31</p></td>
  <td><p>Trần Thị Thanh Hương</p></td>
  <td><p>Chuyên viên </p></td>
  <td><p>0984.295.938</p></td>
 </tr>
 <tr>
  <td><p>32</p></td>
  <td><p>Phạm Thị Thanh Hương</p></td>
  <td><p>Chuyên viên </p></td>
  <td><p>0914.366.826</p></td>
 </tr>
 <tr>
  <td><p>33</p></td>
  <td><p>Trương Ngọc Huấn</p></td>
  <td><p>Chuyên viên </p></td>
  <td><p>0948.686.161</p></td>
 </tr>
 <tr>
  <td><p>34</p></td>
  <td><p>Trịnh Hoàng Hiệp</p></td>
  <td><p>Chuyên viên </p></td>
  <td><p>0984.764.141</p></td>
 </tr>
 <tr>
  <td><p>35</p></td>
  <td><p>Nguyễn Thị Duyên</p></td>
  <td><p>Chuyên viên</p></td>
  <td><p>0979.438.889</p></td>
 </tr>
 <tr>
  <td><p>36</p></td>
  <td><p>Nguyễn Thị Hồng Lý</p></td>
  <td><p>Chuyên viên</p></td>
  <td><p>0942.755.659</p></td>
 </tr>
 <tr>
  <td><p>37</p></td>
  <td><p>Trần Thị Mai Hiên</p></td>
  <td><p>Chuyên viên</p></td>
  <td><p>0388.470.502</p></td>
 </tr>
 <tr>
  <td><p>38</p></td>
  <td><p>Bùi Thị Nữ</p></td>
  <td><p>CV TTDN &amp; HTND </p></td>
  <td><p>0917.247.815</p></td>
 </tr>
 <tr>
  <td><p>39</p></td>
  <td><p>Nguyễn Thị Thủy</p></td>
  <td><p>CV TTDN &amp; HTND </p></td>
  <td><p>0399.478.886</p></td>
 </tr>
 <tr>
  <td><p>40</p></td>
  <td><p>Vũ Thị Hương Sen </p></td>
  <td><p>Cán bộ TTDN &amp; HTND </p></td>
  <td><p>0989.130.091</p></td>
 </tr>
 <tr>
  <td><p>41</p></td>
  <td><p>Phạm Thị Thùy Dung</p></td>
  <td><p>Cán bộ TTDN &amp; HTND </p></td>
  <td><p>0396.767.789</p></td>
 </tr>
 <tr>
  <td><p>42</p></td>
  <td><p>Vũ Thị Ngọc Linh</p></td>
  <td><p>Cán bộ TTDN &amp; HTND </p></td>
  <td><p>0977.536.193</p></td>
 </tr>
 <tr>
  <td><p>43</p></td>
  <td><p>Phạm Văn Tú</p></td>
  <td><p>Lái xe cơ quan</p></td>
  <td><p>0917.386.540</p></td>
 </tr>
</tbody>
    ),
    photoName: "ninhBinh"
  },
  {
    nameProvince: "TỈNH NGHỆ AN",
    address: "số 1 Nguyễn Văn Cừ phường Trường Vinh, Nghệ An.",
    phone: "",
    website: "",
    email: "hndtna@gmail.com",
    zipCode: "",
    contentComponent: (
      <tbody>
    <tr>
  <th><p><b>TT</b></p></th>
  <th><p><b>Họ và tên</b></p></th>
  <th><p><b>Chức vụ</b></p></th>
  <th><p><b>Số điện thoại</b></p></th>
 </tr>
 <tr>
  <td><p>1</p></td>
  <td><p>Nguyễn Quang Tùng</p></td>
  <td><p>Chủ tịch</p></td>
  <td><p>0913.074.064</p></td>
 </tr>
 <tr>
  <td><p>2</p></td>
  <td><p>Võ Văn Phong</p></td>
  <td><p>Phó Chủ tịch, kiêm Trưởng Ban CTND</p></td>
  <td><p>0912.363.476</p></td>
 </tr>
 <tr>
  <td><p>3</p></td>
  <td><p>Tạ Viết Hải</p></td>
  <td><p>Phó ban, kiêm Giám đốc QHTND</p></td>
  <td><p>0919.589.682</p></td>
 </tr>
 <tr>
  <td><p>4</p></td>
  <td><p>Trần Văn Đức</p></td>
  <td><p>Phó ban</p></td>
  <td><p>0917.386.226</p></td>
 </tr>
 <tr>
  <td><p>5</p></td>
  <td><p>Nguyễn Đình Thắng</p></td>
  <td><p>Phó ban</p></td>
  <td><p>0973.283.737</p></td>
 </tr>
 <tr>
  <td><p>6</p></td>
  <td><p>Võ Thị Lan</p></td>
  <td><p>Phó ban</p></td>
  <td><p>0855.066.292</p></td>
 </tr>
 <tr>
  <td><p>7</p></td>
  <td><p>Đặng Thị Phương</p></td>
  <td><p>Phó ban</p></td>
  <td><p>359553168</p></td>
 </tr>
 <tr>
  <td><p>8</p></td>
  <td><p>Nguyễn Thị Liên</p></td>
  <td><p>Phó ban</p></td>
  <td><p>0915.571.666</p></td>
 </tr>
 <tr>
  <td><p>9</p></td>
  <td><p>Phạm Thị Lan Anh</p></td>
  <td><p>Chuyên viên</p></td>
  <td><p>0975.785.226</p></td>
 </tr>
 <tr>
  <td><p>10</p></td>
  <td><p>Lữ Thị Ngọc</p></td>
  <td><p>Chuyên viên</p></td>
  <td><p>0974.032.777</p></td>
 </tr>
 <tr>
  <td><p>11</p></td>
  <td><p>Trần Thị Tuyến</p></td>
  <td><p>Chuyên viên</p></td>
  <td><p>0973.411.199</p></td>
 </tr>
 <tr>
  <td><p>12</p></td>
  <td><p>Trần Thị Thu Hằng</p></td>
  <td><p>Chuyên viên</p></td>
  <td><p>0961.040.491</p></td>
 </tr>
</tbody>
    ),
    photoName: "ngheAn"
  },
  {
    nameProvince: "TỈNH PHÚ THỌ",
    address: "Phố Tân Việt- Phường Việt Trì- tỉnh Phú Thọ.",
    phone: "02103.846.658",
    website: "https://hoinongdan.phutho.gov.vn",
    email: "thongtinhndphutho@gmail.com",
    zipCode: "02103",
    contentComponent: (
      <tbody>
    <tr>
  <th><p><b>TT</b></p></th>
  <th><p><b>Họ và tên</b></p></th>
  <th><p><b>Chức vụ</b></p></th>
  <th><p><b>Số điện thoại</b></p></th>
 </tr>
 <tr>
  <td><p>1</p></td>
  <td><p>Hoàng Xuân Giao</p></td>
  <td><p>Chủ tịch</p></td>
  <td><p>098.681.3113</p></td>
 </tr>
 <tr>
  <td><p>2</p></td>
  <td><p>Hoàng Đức Công</p></td>
  <td><p>Phó Chủ tịch-Trưởng Ban CTND</p></td>
  <td><p>091.787.3888</p></td>
 </tr>
 <tr>
  <td><p>3</p></td>
  <td><p>Lê Thị Quỳnh</p></td>
  <td><p>Phó Chủ tịch</p></td>
  <td><p>098.216.5557</p></td>
 </tr>
 <tr>
  <td><p>4</p></td>
  <td><p>Nguyễn Thị Hương Hải</p></td>
  <td><p>Phó Chủ tịch</p></td>
  <td><p>098.416.7448</p></td>
 </tr>
 <tr>
  <td><p>5</p></td>
  <td><p>Triệu Thống</p></td>
  <td><p>Phó Chủ tịch</p></td>
  <td><p>091.228.1558</p></td>
 </tr>
 <tr>
  <td><p>6</p></td>
  <td><p>Lý Quang Đại</p></td>
  <td><p>Phó ban</p></td>
  <td><p>097.562.0363</p></td>
 </tr>
 <tr>
  <td><p>7</p></td>
  <td><p>Nguyễn Bình Dương</p></td>
  <td><p>Phó ban</p></td>
  <td><p>094.511.6099</p></td>
 </tr>
 <tr>
  <td><p>8</p></td>
  <td><p>Đặng Việt Anh</p></td>
  <td><p>Phó ban</p></td>
  <td><p>091.503.2636</p></td>
 </tr>
 <tr>
  <td><p>9</p></td>
  <td><p>Vũ Công Bình</p></td>
  <td><p>Phó ban</p></td>
  <td><p>096.779.9898</p></td>
 </tr>
 <tr>
  <td><p>10</p></td>
  <td><p>Lưu Thị Huyền Ánh</p></td>
  <td><p>Phó ban</p></td>
  <td><p>094.319.0558</p></td>
 </tr>
 <tr>
  <td><p>11</p></td>
  <td><p>Lê Thị Bích Huệ</p></td>
  <td><p>Phó ban</p></td>
  <td><p>0945.089.339</p></td>
 </tr>
 <tr>
  <td><p>12</p></td>
  <td><p>Nguyễn Duy Tài</p></td>
  <td><p>Phó ban</p></td>
  <td><p>091.226.5466</p></td>
 </tr>
 <tr>
  <td><p>13</p></td>
  <td><p>Nguyễn Trung Tâm</p></td>
  <td><p>Phó ban</p></td>
  <td><p>097.409.9868</p></td>
 </tr>
 <tr>
  <td><p>14</p></td>
  <td><p>Trần Thị Thu Bắc</p></td>
  <td><p>Phó ban</p></td>
  <td><p>091.930.0088</p></td>
 </tr>
 <tr>
  <td><p>15</p></td>
  <td><p>Hoàng Hưng</p></td>
  <td><p>Phó ban</p></td>
  <td><p>0912.327.477</p></td>
 </tr>
 <tr>
  <td><p>16</p></td>
  <td><p>Lê Duy Anh</p></td>
  <td><p>Chuyên viên</p></td>
  <td><p>091.501.2668</p></td>
 </tr>
 <tr>
  <td><p>17</p></td>
  <td><p>Nguyễn Thị Ngọc Hoa</p></td>
  <td><p>Chuyên viên</p></td>
  <td><p>098.387.7466</p></td>
 </tr>
 <tr>
  <td><p>18</p></td>
  <td><p>Bùi Trí Dũng</p></td>
  <td><p>Chuyên viên</p></td>
  <td><p>0984.885.738</p></td>
 </tr>
 <tr>
  <td><p>19</p></td>
  <td><p>Bùi Thị Tuyết</p></td>
  <td><p>Chuyên viên</p></td>
  <td><p>0918.950.686</p></td>
 </tr>
 <tr>
  <td><p>20</p></td>
  <td><p>Nguyễn Thị Thúy</p></td>
  <td><p>Chuyên viên</p></td>
  <td><p>086.816.1990</p></td>
 </tr>
 <tr>
  <td><p>21</p></td>
  <td><p>Lê Trung Thực</p></td>
  <td><p>Chuyên viên</p></td>
  <td><p>098.855.1668</p></td>
 </tr>
 <tr>
  <td><p>22</p></td>
  <td><p>Hoàng Thị Việt Hà</p></td>
  <td><p>Chuyên viên</p></td>
  <td><p>094.290.1907</p></td>
 </tr>
 <tr>
  <td><p>23</p></td>
  <td><p>Hoàng Thị Phương</p></td>
  <td><p>Chuyên viên</p></td>
  <td><p>097.436.1179</p></td>
 </tr>
 <tr>
  <td><p>24</p></td>
  <td><p>Đỗ Ngọc Duy</p></td>
  <td><p>Chuyên viên</p></td>
  <td><p>093.612.3363</p></td>
 </tr>
 <tr>
  <td><p>25</p></td>
  <td><p>Nguyễn Văn Hanh</p></td>
  <td><p>Chuyên viên</p></td>
  <td><p>0904.977.234</p></td>
 </tr>
 <tr>
  <td><p>26</p></td>
  <td><p>Nguyễn Thị Bích Ngọc</p></td>
  <td><p>Chuyên viên</p></td>
  <td><p>0968.963.595</p></td>
 </tr>
 <tr>
  <td><p>27</p></td>
  <td><p>Nguyễn Thị Thu Giang</p></td>
  <td><p>Chuyên viên</p></td>
  <td><p>088.826.4588</p></td>
 </tr>
 <tr>
  <td><p>28</p></td>
  <td><p>Nguyễn Thị Hoài Anh</p></td>
  <td><p>Chuyên viên</p></td>
  <td><p>098.676.8838</p></td>
 </tr>
 <tr>
  <td><p>29</p></td>
  <td><p>Chu Thị Huyền Trang</p></td>
  <td><p>CV, kiêm Kế toán CQ</p></td>
  <td><p>096.694.5678</p></td>
 </tr>
 <tr>
  <td><p>30</p></td>
  <td><p>Trần Thị Nguyệt</p></td>
  <td><p>Chuyên viên</p></td>
  <td><p>0915.908.986</p></td>
 </tr>
 <tr>
  <td><p>31</p></td>
  <td><p>Hoàng Thị Lan</p></td>
  <td><p>Chuyên viên</p></td>
  <td><p>0989.594.881</p></td>
 </tr>
 <tr>
  <td><p>32</p></td>
  <td><p>Vũ Thị Hằng Nga</p></td>
  <td><p>Chuyên viên</p></td>
  <td><p>0349.329.868</p></td>
 </tr>
 <tr>
  <td><p>33</p></td>
  <td><p>Nguyễn Đức Tuấn</p></td>
  <td><p>Chuyên viên</p></td>
  <td><p>0917.166.488</p></td>
 </tr>
 <tr>
  <td><p>34</p></td>
  <td><p>Phùng Thị Thanh Chà</p></td>
  <td><p>Chuyên viên</p></td>
  <td><p>098.306.1775</p></td>
 </tr>
</tbody>
    ),
    photoName: "phuTho"
  },
  {
    nameProvince: "TỈNH QUẢNG NINH",
    address: "Số 2, Bến Đoan, phường Hồng Gai, tỉnh Quảng Ninh.",
    phone: "0914.322.068",
    website: "",
    email: "",
    zipCode: "",
    contentComponent: (
      <tbody>
    <tr>
  <th><p><b>TT</b></p></th>
  <th><p><b>Họ và tên</b></p></th>
  <th><p><b>Chức vụ</b></p></th>
  <th><p><b>Số điện thoại</b></p></th>
 </tr>
 <tr>
  <td><p>1</p></td>
  <td><p>Nguyễn Thị Tuyết Hạnh</p></td>
  <td><p>Chủ tịch</p></td>
  <td><p>091.535.4982</p></td>
 </tr>
 <tr>
  <td><p>2</p></td>
  <td><p>Lê Phương Thảo</p></td>
  <td><p>Phó Chủ tịch, Trưởng Ban CTND</p></td>
  <td><p>093.431.3358</p></td>
 </tr>
 <tr>
  <td><p>3</p></td>
  <td><p>Bùi Thanh Hải</p></td>
  <td><p>Phó ban</p></td>
  <td><p>089.926.1588</p></td>
 </tr>
 <tr>
  <td><p>4</p></td>
  <td><p>Lê Kim Ngọc</p></td>
  <td><p>Phó ban</p></td>
  <td><p>096.607.0058</p></td>
 </tr>
 <tr>
  <td><p>5</p></td>
  <td><p>Nguyễn Lan Anh</p></td>
  <td><p>Phó ban</p></td>
  <td><p>091.432.2068</p></td>
 </tr>
 <tr>
  <td><p>6</p></td>
  <td><p>Nguyễn Phương Nam</p></td>
  <td><p>Chuyên viên</p></td>
  <td><p>093.150.1892</p></td>
 </tr>
 <tr>
  <td><p>7</p></td>
  <td><p>Nguyễn Hòa Bình</p></td>
  <td><p>Chuyên viên</p></td>
  <td><p>037.971.9973</p></td>
 </tr>
 <tr>
  <td><p>8</p></td>
  <td><p>Mai Lê Mỹ Duyên</p></td>
  <td><p>Chuyên viên</p></td>
  <td><p>036.259.5899</p></td>
 </tr>
 <tr>
  <td><p>9</p></td>
  <td><p>Ngô Hàn Chi</p></td>
  <td><p>Chuyên viên</p></td>
  <td><p>098.133.0966</p></td>
 </tr>
 <tr>
  <td><p>10</p></td>
  <td><p>Đinh Đặng Ngọc Anh</p></td>
  <td><p>Cán bộ nghiệp vụ Quỹ HTND</p></td>
  <td><p>097.804.5024</p></td>
 </tr>
</tbody>
    ),
    photoName: "quangNinh"
  },
  
  {
    nameProvince: "TỈNH QUẢNG NGÃI",
    address: "208A Đường Hùng Vương, phường Nghĩa Lộ, tỉnh Quảng Ngãi.",
    phone: "0255.3823593",
    website: "hoinongdanquangngai.org.vn",
    email: "hnd@quangngai.gov.vn",
    zipCode: "0255",
    contentComponent: (
      <tbody>
    <tr>
  <th><p><b>TT</b></p></th>
  <th><p><b>Họ và tên</b></p></th>
  <th><p><b>Chức vụ</b></p></th>
  <th><p><b>Số điện thoại</b></p></th>
  <th><p><b>Email</b></p></th>
 </tr>
 <tr>
  <td><p>1</p></td>
  <td><p>Nguyễn Quang Thủy</p></td>
  <td><p>Chủ tịch </p></td>
  <td><p>091.415.6925</p></td>
  <td><p>nqthuy-hnd<br/>
  @quangngai.gov.vn</p></td>
 </tr>
 <tr>
  <td><p>2</p></td>
  <td><p>Trần Minh Nhật</p></td>
  <td><p>Phó ban phụ trách XD Hội</p></td>
  <td><p>093.500.5140</p></td>
  <td><p>tmnhat-hnd<br/>
  @quangngai.gov.vn</p></td>
 </tr>
 <tr>
  <td><p>3</p></td>
  <td><p>Phùng Thị Mỹ Ngọc</p></td>
  <td><p>Phó ban phụ trách HC-TH</p></td>
  <td><p>090.566.0003</p></td>
  <td><p>ptmngoc-hnd<br/>
  @quangngai.gov.vn</p></td>
 </tr>
 <tr>
  <td><p>4</p></td>
  <td><p>Lê Trung Việt</p></td>
  <td><p>Phó ban phụ trách KT-XH</p></td>
  <td><p>094.602.4534</p></td>
  <td><p>ltviet-hnd<br/>
  @quangngai.gov.vn</p></td>
 </tr>
 <tr>
  <td><p>5</p></td>
  <td><p>Trần Quang Hưng</p></td>
  <td><p>Phó ban </p></td>
  <td><p>988.175737</p></td>
  <td><p>tqhung-hnd<br/>
  @quangngai.gov.vn</p></td>
 </tr>
 <tr>
  <td><p>6</p></td>
  <td><p>Ngô Thị Kiều Diễm</p></td>
  <td><p>Phó ban</p></td>
  <td><p>098.376.0829</p></td>
  <td><p>ntkdiem-hnd<br/>
  @quangngai.gov.vn</p></td>
 </tr>
 <tr>
  <td><p>7</p></td>
  <td><p>Nguyễn Thị Minh Phượng</p></td>
  <td><p>Chuyên viên</p></td>
  <td><p>090.566.4755</p></td>
  <td><p>ntmphuong-hnd<br/>
  @quangngai.gov.vn</p></td>
 </tr>
 <tr>
  <td><p>8</p></td>
  <td><p>Nguyễn Văn Nghĩa</p></td>
  <td><p>Chuyên viên</p></td>
  <td><p>097.318.0671</p></td>
  <td><p>nvnghia-hnd<br/>
  @quangngai.gov.vn</p></td>
 </tr>
 <tr>
  <td><p>9</p></td>
  <td><p>Lê Văn Chương</p></td>
  <td><p>Chuyên viên</p></td>
  <td><p>091.543.6046</p></td>
  <td><p>lvchuong-hnd<br/>
  @quangngai.gov.vn</p></td>
 </tr>
 <tr>
  <td><p>10</p></td>
  <td><p>Đỗ Thị Nguyệt</p></td>
  <td><p>Chuyên viên</p></td>
  <td><p>097.131.3629</p></td>
  <td><p>dtnguyet-hnd<br/>
  @quangngai.gov.vn</p></td>
 </tr>
 <tr>
  <td><p>11</p></td>
  <td><p>Đồng Thị Xuân</p></td>
  <td><p>Chuyên viên</p></td>
  <td><p>091.592.3592</p></td>
  <td><p>dtxuan-hnd<br/>
  @quangngai.gov.vn</p></td>
 </tr>
 <tr>
  <td><p>12</p></td>
  <td><p>Nguyễn Thị Thúy Liễu</p></td>
  <td><p>Chuyên viên</p></td>
  <td><p>098.358.8401</p></td>
  <td><p>nttlieu-hnd<br/>
  @quangngai.gov.vn</p></td>
 </tr>
 <tr>
  <td><p>13</p></td>
  <td><p>Ngô Thị Hương</p></td>
  <td><p>Chuyên viên</p></td>
  <td><p>091.686.0861</p></td>
  <td><p>nthuong-hnd<br/>
  @quangngai.gov.vn</p></td>
 </tr>
 <tr>
  <td><p>14</p></td>
  <td><p>Võ Văn Quang</p></td>
  <td><p>Chuyên viên</p></td>
  <td><p>098.574.4113</p></td>
  <td><p>vvquang-hnd<br/>
  @quangngai.gov.vn</p></td>
 </tr>
 <tr>
  <td><p>15</p></td>
  <td><p>Trương Thị Thu Thủy</p></td>
  <td><p>Chuyên viên</p></td>
  <td><p>098.687.5354</p></td>
  <td><p>tttthuy-hnd<br/>
  @quangngai.gov.vn</p></td>
 </tr>
 <tr>
  <td><p>16</p></td>
  <td><p>Lê Thanh Hoạt</p></td>
  <td><p>Chuyên viên - Văn thư</p></td>
  <td><p>035.802.7324</p></td>
  <td><p>lthoat-hnd<br/>
  @quangngai.gov.vn</p></td>
 </tr>
 <tr>
  <td><p>17</p></td>
  <td><p>Huỳnh Trung Bạo</p></td>
  <td><p>NV lái xe Ban CTND</p></td>
  <td><p>094.667.1476</p></td>
  <td><p>htbao-hnd<br/>
  @quangngai.gov.vn</p></td>
 </tr>
 <tr>
  <td><p>18</p></td>
  <td><p>Nguyễn Thị Hiện</p></td>
  <td><p>NV Quỹ HTND</p></td>
  <td><p>090.542.4273</p></td>
  <td><p>nthihien-hnd<br/>
  @quangngai.gov.vn</p></td>
 </tr>
 <tr>
  <td><p>19</p></td>
  <td><p>Vương Thị Hồng Vấn</p></td>
  <td><p>Viên chức Trung tâm HT và GDNN ND-PN</p></td>
  <td><p>091.413.1448</p></td>
  <td><p>vthvan-hnd<br/>
  @quangngai.gov.vn</p></td>
 </tr>
 <tr>
  <td><p>20</p></td>
  <td><p>Trần Thị Bích Yến</p></td>
  <td><p>Viên chức Trung tâm HT và GDNN ND-PN</p></td>
  <td><p>077.442.2123</p></td>
  <td><p>ttbyen-hnd<br/>
  @quangngai.gov.vn</p></td>
 </tr>
 <tr>
  <td><p>21</p></td>
  <td><p>Bùi Thị Thảo</p></td>
  <td><p>Viên chức Trung tâm HT và GDNN ND-PN</p></td>
  <td><p>091.423.2090</p></td>
  <td><p>btthao-hnd<br/>
  @quangngai.gov.vn</p></td>
 </tr>
 <tr>
  <td><p>22</p></td>
  <td><p>Nguyễn Ngọc Xuyến</p></td>
  <td><p>NV bảo vệ</p></td>
  <td><p>036.677.6865</p></td>
  <td></td>
 </tr>
</tbody>
    ),
    photoName: "quangNgai"
  },
  {
    nameProvince: "TỈNH QUẢNG TRỊ",
    address: "43 Nguyễn Hữu Cảnh, Phường Đồng Hới, tỉnh Quảng Trị.",
    phone: "",
    website: "hnd.quangtri.gov.vn",
    email: "bancongtacnongdanqt@gmail.com",
    zipCode: "",
    contentComponent: (
      <tbody>
    <tr>
  <th><p><b>TT</b></p></th>
  <th><p><b>Họ và tên</b></p></th>
  <th><p><b>Chức vụ</b></p></th>
  <th><p><b>Số điện thoại</b></p></th>
  <th><p><b>Email</b></p></th>
 </tr>
 <tr>
  <td><p>1</p></td>
  <td><p>Trần Tiến Sỹ</p></td>
  <td><p>Chủ tịch</p></td>
  <td><p>091.309.4175</p></td>
  <td><p><a href="mailto:sybotrach@gmail.com">sybotrach<br/>
  @gmail.com</a></p></td>
 </tr>
 <tr>
  <td><p>2</p></td>
  <td><p>Mai Văn Nam</p></td>
  <td><p>Phó Chủ tịch, Trưởng ban CTND</p></td>
  <td><p>094.514.6777</p></td>
  <td><p><a href="mailto:nammaihlqt@gmail.com">nammaihlqt<br/>
  @gmail.com</a></p></td>
 </tr>
 <tr>
  <td><p>3</p></td>
  <td><p>Phùng Xuân Tiến </p></td>
  <td><p>Phó ban</p></td>
  <td><p>090.633.3660</p></td>
  <td><p><a href="mailto:phungngocbaohuy250612@gmail.com">phungngocbaohuy250612<br/>
  @gmail.com</a></p></td>
 </tr>
 <tr>
  <td><p>4</p></td>
  <td><p>Hồ Thị Thu Hà</p></td>
  <td><p>Phó ban</p></td>
  <td><p>091.535.1267</p></td>
  <td><p><a href="mailto:thuha053@gmail.com">thuha053<br/>
  @gmail.com</a></p></td>
 </tr>
 <tr>
  <td><p>5</p></td>
  <td><p>Trần Thị Hoàng Mai </p></td>
  <td><p>Phó ban</p></td>
  <td><p>090.355.7866</p></td>
  <td><p><a href="mailto:hoangmaihnd@gmail.com">hoangmaihnd<br/>
  @gmail.com</a></p></td>
 </tr>
 <tr>
  <td><p>6</p></td>
  <td><p>Nguyễn Trường Thành </p></td>
  <td><p>Phó ban</p></td>
  <td><p>093.520.0100</p></td>
  <td><p><a href="mailto:truongthanhqb@gmail.com">truongthanhqb<br/>
  @gmail.com</a></p></td>
 </tr>
 <tr>
  <td><p>7</p></td>
  <td><p>Nguyễn Xuân Hiếu</p></td>
  <td><p>Phó ban</p></td>
  <td><p>094.794.4111</p></td>
  <td><p><a href="mailto:hieudaynghevinhlinh@gmail.com">hieudaynghevinhlinh<br/>
  @gmail.com</a></p></td>
 </tr>
 <tr>
  <td><p>8</p></td>
  <td><p>Hoàng Thị Vân Anh</p></td>
  <td><p>Phó ban</p></td>
  <td><p>094.529.8444</p></td>
  <td><p>vananhdhqt7983<br/>
  @gmail.com</p></td>
 </tr>
 <tr>
  <td><p>9</p></td>
  <td><p>Nguyễn Thị Thu Hoài</p></td>
  <td><p>CVC</p></td>
  <td><p>091.894.9159</p></td>
  <td><p><a href="mailto:thuhoaiqt@gmail.com">thuhoaiqt<br/>
  @gmail.com</a></p></td>
 </tr>
 <tr>
  <td><p>10</p></td>
  <td><p>Phan Thị Thanh Bình</p></td>
  <td><p>Chuyên viên</p></td>
  <td><p>093.522.6236</p></td>
  <td><p><a href="mailto:phanbinhqb@gmail.com">phanbinhqb<br/>
  @gmail.com</a></p></td>
 </tr>
 <tr>
  <td><p>11</p></td>
  <td><p>Đoàn Ngọc Thuý Anh</p></td>
  <td><p>Chuyên viên</p></td>
  <td><p>097.262.0555</p></td>
  <td><p><a href="mailto:doanthuyanh91@gmail.com">doanthuyanh91<br/>
  @gmail.com</a></p></td>
 </tr>
 <tr>
  <td><p>12</p></td>
  <td><p>Nguyễn Thanh Hải</p></td>
  <td><p>Chuyên viên</p></td>
  <td><p>090.555.1186</p></td>
  <td><p><a href="mailto:nguyenphucthanhhai@gmail.com">nguyenphucthanhhai<br/>
  @gmail.com</a></p></td>
 </tr>
 <tr>
  <td><p>13</p></td>
  <td><p>Nguyễn Đức Thắng</p></td>
  <td><p>Chuyên viên</p></td>
  <td><p>091.663.8895</p></td>
  <td><p><a href="mailto:thangndqb@gmail.com">thangndqb<br/>
  @gmail.com</a></p></td>
 </tr>
 <tr>
  <td><p>14</p></td>
  <td><p>Phan Thị Lan</p></td>
  <td><p>Chuyên viên</p></td>
  <td><p>090.539.3757</p></td>
  <td><p><a href="mailto:Lanqb1981@gmail.com">Lanqb1981<br/>
  @gmail.com</a></p></td>
 </tr>
 <tr>
  <td><p>15</p></td>
  <td><p>Võ Thị Hồng Nhạn</p></td>
  <td><p>CVC</p></td>
  <td><p>086.845.6246</p></td>
  <td><p><a href="mailto:hongnhanhndqt187@gmail.com">hongnhanhndqt187<br/>
  @gmail.com</a></p></td>
 </tr>
 <tr>
  <td><p>16</p></td>
  <td><p>Võ Thị Linh Nhân</p></td>
  <td><p>Chuyên viên</p></td>
  <td><p>091.687.8159</p></td>
  <td><p><a href="mailto:linhnhansp@gmail.com">linhnhansp<br/>
  @gmail.com</a></p></td>
 </tr>
 <tr>
  <td><p>17</p></td>
  <td><p>Võ Thị Đào</p></td>
  <td><p>Kế toán</p></td>
  <td><p>091.927.5567</p></td>
  <td><p><a href="mailto:daovta.vms@gmail.com">daovta.vms<br/>
  @gmail.com</a></p></td>
 </tr>
 <tr>
  <td><p>18</p></td>
  <td><p>Lê Thị Huyến</p></td>
  <td><p>Nhân viên</p></td>
  <td><p>094.142.3557</p></td>
  <td><p><a href="mailto:lehuyenhndqt@gmail.com">lehuyenhndqt<br/>
  @gmail.com</a></p></td>
 </tr>
 <tr>
  <td><p>19</p></td>
  <td><p>Lê Vân Anh</p></td>
  <td><p>Nhân viên</p></td>
  <td><p>081.577.7559</p></td>
  <td><p>&nbsp;</p></td>
 </tr>
 <tr>
  <td><p>20</p></td>
  <td><p>Lê Văn An</p></td>
  <td><p>Lái xe</p></td>
  <td><p>094.652.4555</p></td>
  <td><p>&nbsp;</p></td>
 </tr>
 <tr>
  <td><p>21</p></td>
  <td><p>Hoàng Anh Tuấn</p></td>
  <td><p>Lái xe</p></td>
  <td><p>098.359.0888</p></td>
  <td><p>&nbsp;</p></td>
 </tr>
</tbody>
    ),
    photoName: "quangTri"
  },
  {
    nameProvince: "TỈNH SƠN LA",
    address: "Số 20 đường Hoàng Quốc Việt, Phường Chiềng Cơi, Tỉnh Sơn La.",
    phone: "",
    website: "",
    email: "",
    zipCode: "",
    contentComponent: (
      <tbody>
    <tr>
  <th><p><b>TT</b></p></th>
  <th><p><b>Họ và tên</b></p></th>
  <th><p><b>Chức vụ</b></p></th>
  <th><p><b>Di động</b></p></th>
 </tr>
 <tr>
  <td><p>1</p></td>
  <td><p>Vũ Đức Thuận</p></td>
  <td><p>Chủ tịch</p></td>
  <td><p>0913.024.864</p></td>
 </tr>
 <tr>
  <td><p>2</p></td>
  <td><p>Bạc Cầm Khuyên</p></td>
  <td><p>Phó Chủ tịch</p></td>
  <td><p>0986.762.999</p></td>
 </tr>
 <tr>
  <td><p>3</p></td>
  <td><p>Quàng Thị Hương</p></td>
  <td><p>Phó ban</p></td>
  <td><p>0915.607.712</p></td>
 </tr>
 <tr>
  <td><p>4</p></td>
  <td><p>Giàng Thị Giang</p></td>
  <td><p>Phó ban</p></td>
  <td><p>0975.037.996</p></td>
 </tr>
 <tr>
  <td><p>5</p></td>
  <td><p>Trần Văn Hùng</p></td>
  <td><p>Phó ban</p></td>
  <td><p>0964.654.188</p></td>
 </tr>
 <tr>
  <td><p>6</p></td>
  <td><p>Nguyễn Mạnh Đức</p></td>
  <td><p>Phó ban</p></td>
  <td><p>0948.318.877</p></td>
 </tr>
 <tr>
  <td><p>7</p></td>
  <td><p>Lường Thị Thuông</p></td>
  <td><p>Chuyên viên</p></td>
  <td><p>0348.174.557</p></td>
 </tr>
 <tr>
  <td><p>8</p></td>
  <td><p>Hoàng Thị Kiên</p></td>
  <td><p>Chuyên viên</p></td>
  <td><p>0983.406.619</p></td>
 </tr>
 <tr>
  <td><p>9</p></td>
  <td><p>Nguyễn Hồng Tâm</p></td>
  <td><p>Chuyên viên</p></td>
  <td><p>0915.421.726</p></td>
 </tr>
 <tr>
  <td><p>10</p></td>
  <td><p>Lò Văn Hoàng</p></td>
  <td><p>Chuyên viên</p></td>
  <td><p>0985.007.589</p></td>
 </tr>
 <tr>
  <td><p>11</p></td>
  <td><p>Nhữ Thương Trần Huyền</p></td>
  <td><p>Chuyên viên</p></td>
  <td><p>0981.020.189</p></td>
 </tr>
 <tr>
  <td><p>12</p></td>
  <td><p>Nguyễn Thị Thúy</p></td>
  <td><p>Chuyên viên</p></td>
  <td><p>0904.796.498</p></td>
 </tr>
 <tr>
  <td><p>13</p></td>
  <td><p>Nguyễn Việt Hương</p></td>
  <td><p>Chuyên viên</p></td>
  <td><p>0967.898.919</p></td>
 </tr>
 <tr>
  <td><p>14</p></td>
  <td><p>Đoàn Thanh Nam</p></td>
  <td><p>Chuyên viên</p></td>
  <td><p>0979.057.899</p></td>
 </tr>
</tbody>
    ),
    photoName: "sonLa"
  },
  {
    nameProvince: "TỈNH TÂY NINH",
    address: "số 02 đường Song Hành, phường Long An, tỉnh Tây Ninh.",
    phone: "0272 3826 350",
    website: "hoinongdan.tayninh.gov.vn",
    email: "hoinongdan@tayninh.gov.vn",
    zipCode: "",
    contentComponent: (
      <tbody>
    <tr>
  <th><p><b>TT</b></p></th>
  <th><p><b>Họ và tên</b></p></th>
  <th><p><b>Chức vụ</b></p></th>
  <th><p><b>Số điện thoại</b></p></th>
  <th><p><b>Email</b></p></th>
 </tr>
 <tr>
  <td><p>1</p></td>
  <td><p>Ngô Thanh Tuyền</p></td>
  <td><p>Phó Chủ tịch</p></td>
  <td><p>0918.430.096</p></td>
  <td><p>hnd_pcttruc<br/>
  @tayninh.gov.vn</p></td>
 </tr>
 <tr>
  <td><p>2</p></td>
  <td><p>Đặng Thị Thu Thủy</p></td>
  <td><p>Phó ban</p></td>
  <td><p>0966.712.487</p></td>
  <td><p>thuthuydang.070984<br/>
  @gmail.com</p></td>
 </tr>
 <tr>
  <td><p>3</p></td>
  <td><p>Nguyễn Thanh Hiếu</p></td>
  <td><p>Phó ban</p></td>
  <td><p>0912.946.679</p></td>
  <td><p>hieulafu<br/>
  @gmail.com</p></td>
 </tr>
 <tr>
  <td><p>4</p></td>
  <td><p>Nguyễn Minh Tuấn</p></td>
  <td><p>Phó ban</p></td>
  <td><p>0909.108.797</p></td>
  <td><p>minhtuantdla<br/>
  @gmail.com</p></td>
 </tr>
 <tr>
  <td><p>5</p></td>
  <td><p>Nguyễn Trung Tướng</p></td>
  <td><p>Phó ban</p></td>
  <td><p>0945.096.775<br/>
  0943.123.405</p></td>
  <td><p>trungtuongvinhthanh<br/>
  @gmail.com</p></td>
 </tr>
 <tr>
  <td><p>6</p></td>
  <td><p>Trần Thị Thanh Thúy</p></td>
  <td><p>Phó ban</p></td>
  <td><p>0908.906.517</p></td>
  <td><p>tranthithanhthuy610<br/>
  @gmail.com</p></td>
 </tr>
 <tr>
  <td><p>7</p></td>
  <td><p>Trần Nhật Đông</p></td>
  <td><p>Phó ban</p></td>
  <td><p>0918.000.137</p></td>
  <td><p>phutang.tran<br/>
  @gmail.com</p></td>
 </tr>
 <tr>
  <td><p>8</p></td>
  <td><p>Cao Trường Hận</p></td>
  <td><p>Chuyên viên</p></td>
  <td><p>0387.006.081</p></td>
  <td><p>truonghan1881989<br/>
  @gmail.com</p></td>
 </tr>
 <tr>
  <td><p>9</p></td>
  <td><p>Nguyễn Ngọc Toàn</p></td>
  <td><p>Chuyên viên</p></td>
  <td><p>0848.518.881</p></td>
  <td><p>toan963655<br/>
  @gmail.com</p></td>
 </tr>
 <tr>
  <td><p>10</p></td>
  <td><p>Nguyễn Văn Hậu</p></td>
  <td><p>Chuyên viên</p></td>
  <td><p>0839.893.752</p></td>
  <td><p>haulafu<br/>
  @gmail.com</p></td>
 </tr>
 <tr>
  <td><p>11</p></td>
  <td><p>Lê Minh Nhật</p></td>
  <td><p>Chuyên viên</p></td>
  <td><p>0915.228.119</p></td>
  <td><p>minhnhathnd<br/>
  @gmail.com</p></td>
 </tr>
 <tr>
  <td><p>12</p></td>
  <td><p>Hồ Trọng Hiếu</p></td>
  <td><p>Chuyên viên</p></td>
  <td><p>0987.017.456</p></td>
  <td><p>hohieu.hnd<br/>
  @gmail.com</p></td>
 </tr>
 <tr>
  <td><p>13</p></td>
  <td><p>Mai Xuân Chi</p></td>
  <td><p>Chuyên viên</p></td>
  <td><p>0975.425.268</p></td>
  <td><p>ankhanh2403<br/>
  @gmail.com</p></td>
 </tr>
 <tr>
  <td><p>14</p></td>
  <td><p>Hà Xuân Trường</p></td>
  <td><p>Nhiên viên Quỹ HTND</p></td>
  <td><p>0974.946.771</p></td>
  <td><p>truongreus11<br/>
  @gmail.com</p></td>
 </tr>
</tbody>
    ),
    photoName: "tayNinh"
  },
  {
    nameProvince: "TỈNH TUYÊN QUANG",
    address: "Tổ 19, Phường An Tường, Tỉnh Tuyên Quang.",
    phone: "020.738.22667",
    website: "",
    email: "Vanphonghndt@gmail.com",
    zipCode: "",
    contentComponent: (
      <tbody>
    <tr>
  <th><p><b>TT</b></p></th>
  <th><p><b>Họ và tên</b></p></th>
  <th><p><b>Chức danh</b></p></th>
  <th><p><b>Số điện thoại</b></p></th>
  <th><p><b>Email</b></p></th>
 </tr>
 <tr>
  <td><p>1</p></td>
  <td><p>Hoàng Nhị Sơn</p></td>
  <td><p>Chủ tịch</p></td>
  <td><p>091.466.1056</p></td>
  <td><p>sonhg1968<br/>
  @gmail.com</p></td>
 </tr>
 <tr>
  <td><p>2</p></td>
  <td><p>Hoàng Quốc Tuấn</p></td>
  <td><p>Phó Chủ tịch</p></td>
  <td><p>091.570.6466</p></td>
  <td><p>Tuanthuminhly<br/>
  @gmail.com.vn</p></td>
 </tr>
 <tr>
  <td><p>1</p></td>
  <td><p>Nguyễn Thị Tươi Minh</p></td>
  <td><p>Trưởng ban CTND</p></td>
  <td><p>097.794.8480</p></td>
  <td><p>nminhpntq<br/>
  @gmail.com</p></td>
 </tr>
 <tr>
  <td><p>2</p></td>
  <td><p>Lưu Thị Hải Yên</p></td>
  <td><p>Phó ban</p></td>
  <td><p>094.724.8338</p></td>
  <td><p>cuongmai2011<br/>
  @gmail.com</p></td>
 </tr>
 <tr>
  <td><p>3</p></td>
  <td><p>Nguyễn Thị Phương Thảo</p></td>
  <td><p>Phó ban</p></td>
  <td><p>094.391.8626</p></td>
  <td><p>Hiepthao2000<br/>
  @gmail.com</p></td>
 </tr>
 <tr>
  <td><p>4</p></td>
  <td><p>Dương Tiến Dũng</p></td>
  <td><p>Phó ban</p></td>
  <td><p>034.903.0883</p></td>
  <td><p>duongtiendung915<br/>
  @mail.com</p></td>
 </tr>
 <tr>
  <td><p>5</p></td>
  <td><p>Nguyễn Ngọc Thành</p></td>
  <td><p>Phó ban</p></td>
  <td><p>038.572.7668</p></td>
  <td><p>thanhhndtq83<br/>
  @gmail.com</p></td>
 </tr>
 <tr>
  <td><p>1</p></td>
  <td><p>Nguyễn Thị Phượng</p></td>
  <td><p>Viên chức </p></td>
  <td><p>098.981.7669</p></td>
  <td><p>phuongtq410<br/>
  @gmail.com</p></td>
 </tr>
 <tr>
  <td><p>2</p></td>
  <td><p>Lê Hoàng </p></td>
  <td><p>Viên chức </p></td>
  <td><p>097.583.5455</p></td>
  <td><p>lehoangtq06<br/>
  @gmail.com</p></td>
 </tr>
 <tr>
  <td><p>3</p></td>
  <td><p>Nguyễn Bích Hằng</p></td>
  <td><p>Viên chức </p></td>
  <td><p>090.606.1771</p></td>
  <td><p>hangtrungtq86<br/>
  @gmail.com</p></td>
 </tr>
 <tr>
  <td><p>4</p></td>
  <td><p>Hoàng Thị Kim Cúc</p></td>
  <td><p>Chuyên viên</p></td>
  <td><p>094.284.3988</p></td>
  <td><p>hoangthikimcuc2010<br/>
  @gmail.com</p></td>
 </tr>
 <tr>
  <td><p>5</p></td>
  <td><p>Bùi Thị Thanh Nga</p></td>
  <td><p>Chuyên viên phụ trách văn thư</p></td>
  <td><p>0396.251.006</p></td>
  <td><p>ngahndtq<br/>
  @gmail.com</p></td>
 </tr>
 <tr>
  <td><p>6</p></td>
  <td><p>Trịnh Thị Dung</p></td>
  <td><p>Chuyên viên</p></td>
  <td><p>094.360.8188</p></td>
  <td><p>dunghndhagiang<br/>
  @gmail.com</p></td>
 </tr>
 <tr>
  <td><p>7</p></td>
  <td><p>Bùi Đức Thái Bình</p></td>
  <td><p>Chuyên viên</p></td>
  <td><p>0915.433.003</p></td>
  <td><p>binhhnd<br/>
  @gmail.com</p></td>
 </tr>
 <tr>
  <td><p>8</p></td>
  <td><p>Hồ Thị Nhân</p></td>
  <td><p>Chuyên viên</p></td>
  <td><p>082.987.4486</p></td>
  <td><p>honhan37.90<br/>
  @gmail.com</p></td>
 </tr>
 <tr>
  <td><p>9</p></td>
  <td><p>Vương Thị Phương</p></td>
  <td><p>Chuyên viên</p></td>
  <td><p>097.684.5049</p></td>
  <td><p>vuongphuonghg1980<br/>
  @gmail.com</p></td>
 </tr>
 <tr>
  <td><p>10</p></td>
  <td><p>Lê Kiên Trung</p></td>
  <td><p>Chuyên viên</p></td>
  <td><p>033.490.7268</p></td>
  <td><p>letrungtq86<br/>
  @gmail.com</p></td>
 </tr>
 <tr>
  <td><p>11</p></td>
  <td><p>Hoàng Thị Kiều Loan</p></td>
  <td><p>Chuyên viên</p></td>
  <td><p>035.537.4145</p></td>
  <td><p>hoangloansp<br/>
  @gmail.com</p></td>
 </tr>
 <tr>
  <td><p>12</p></td>
  <td><p>Hà Hải Hằng</p></td>
  <td><p>Cán bộ </p></td>
  <td><p>0988.231.223</p></td>
  <td><p>haihangha.1986<br/>
  @gmail.com</p></td>
 </tr>
 <tr>
  <td><p>13</p></td>
  <td><p>Nguyễn Ánh Nguyệt</p></td>
  <td><p>Cán bộ </p></td>
  <td><p>082.968.6222</p></td>
  <td><p>nguyettqqv<br/>
  @gmail.com</p></td>
 </tr>
</tbody>
    ),
    photoName: "tuyenQuang"
  },
  {
    nameProvince: "TỈNH THÁI NGUYÊN",
    address: "Tổ dân phố Sơn Quang, xã Đồng Hỷ, tỉnh Thái Nguyên.",
    phone: "02083.855.007",
    website: "https://hoinongdan.thainguyen.gov.vn",
    email: "hoinongdantinhthainguyen@gmail.com",
    zipCode: "",
    contentComponent: (
      <tbody>
    <tr>
  <th><p><b>TT</b></p></th>
  <th><p><b>Họ và tên</b></p></th>
  <th><p><b>Chức vụ</b></p></th>
  <th><p><b>Số điện thoại</b></p></th>
  <th><p><b>Email</b></p></th>
 </tr>
 <tr>
  <td><p>1</p></td>
  <td><p>Phan Thanh Hà</p></td>
  <td><p>Chủ tịch</p></td>
  <td><p>091.200.3929</p></td>
  <td><p><a href="mailto:Hapt.ubkttn@gmail.com">Hapt.ubkttn<br/>
  @gmail.com</a></p></td>
 </tr>
 <tr>
  <td><p>2</p></td>
  <td><p>Nguyễn Đình Điệp</p></td>
  <td><p>Phó Chủ tịch, Trưởng Ban CTND</p></td>
  <td><p>098.270.0458</p></td>
  <td><p><a href="mailto:Diepnd.hnd@backan.gov.vn">Diepnd.hnd<br/>
  @backan.gov.vn</a></p></td>
 </tr>
 <tr>
  <td><p>3</p></td>
  <td><p>Nguyễn Công Lệnh</p></td>
  <td><p>Phó Chủ tịch</p></td>
  <td><p>098.955.4489</p></td>
  <td><p><a href="mailto:lenhbvtvbk@gmail.com">lenhbvtvbk<br/>
  @gmail.com</a></p></td>
 </tr>
 <tr>
  <td><p>4</p></td>
  <td><p>Vũ Thị Kim Oanh</p></td>
  <td><p>Phó ban</p></td>
  <td><p>091.121.2589</p></td>
  <td><p><a href="mailto:kimoanhhnd@gmail.com">kimoanhhnd<br/>
  @gmail.com</a></p></td>
 </tr>
 <tr>
  <td><p>5</p></td>
  <td><p>Nguyễn Trí Dũng</p></td>
  <td><p>Phó ban</p></td>
  <td><p>091.536.8222</p></td>
  <td><p><a href="mailto:tridungtiensinh@gmail.com">tridungtiensinh<br/>
  @gmail.com</a></p></td>
 </tr>
 <tr>
  <td><p>6</p></td>
  <td><p>Triệu Thanh Bình</p></td>
  <td><p>Phó ban</p></td>
  <td><p>091.270.0227</p></td>
  <td><p><a href="mailto:trieubinhhnd@gmail.com">trieubinhhnd<br/>
  @gmail.com</a></p></td>
 </tr>
 <tr>
  <td><p>7</p></td>
  <td><p>Đỗ Đình Thủy</p></td>
  <td><p>Phó ban</p></td>
  <td><p>038.992.2477</p></td>
  <td><p><a href="mailto:Thuydd.hnd@backan.gov.vn">Thuydd.hnd<br/>
  @backan.gov.vn</a></p></td>
 </tr>
 <tr>
  <td><p>8</p></td>
  <td><p>Đàm Quang Tuấn</p></td>
  <td><p>Phó ban</p></td>
  <td><p>091.200.4647</p></td>
  <td><p><a href="mailto:Damquangtuanhnd@gmail.com">Damquangtuanhnd<br/>
  @gmail.com</a></p></td>
 </tr>
 <tr>
  <td><p>9</p></td>
  <td><p>Vũ Thị Thu Hằng</p></td>
  <td><p>Chuyên viên, Quyền Trưởng ban Điều hành Quỹ HTND</p></td>
  <td><p>097.570.2801</p></td>
  <td><p><a href="mailto:Vuthuhang201186@gmail.com">Vuthuhang201186<br/>
  @gmail.com</a></p></td>
 </tr>
 <tr>
  <td><p>10</p></td>
  <td><p>Vũ Thị Vân Anh</p></td>
  <td><p>Chuyên viên</p></td>
  <td><p>091.122.6288</p></td>
  <td><p><a href="mailto:vuanhhnd@gmail.com">vuanhhnd<br/>
  @gmail.com</a></p></td>
 </tr>
 <tr>
  <td><p>11</p></td>
  <td><p>Nguyễn Thị Hồng Nhung</p></td>
  <td><p>Chuyên viên</p></td>
  <td><p>098.866.8021</p></td>
  <td><p><a href="mailto:Hongnhungdt1990@gmail.com">Hongnhungdt1990<br/>
  @gmail.com</a></p></td>
 </tr>
 <tr>
  <td><p>12</p></td>
  <td><p>Trần Ngọc Bích</p></td>
  <td><p>Chuyên viên</p></td>
  <td><p>098.693.7935</p></td>
  <td><p><a href="mailto:Bichtran84@gmail.com">Bichtran84<br/>
  @gmail.com</a></p></td>
 </tr>
 <tr>
  <td><p>13</p></td>
  <td><p>Nguyễn Thị Vân Anh</p></td>
  <td><p>Chuyên viên</p></td>
  <td><p>091.668.6008</p></td>
  <td><p><a href="mailto:vananhhndtn@gmail.com">vananhhndtn<br/>
  @gmail.com</a></p></td>
 </tr>
 <tr>
  <td><p>14</p></td>
  <td><p>Nguyễn Đình Kiên</p></td>
  <td><p>Chuyên viên</p></td>
  <td><p>035.877.7444</p></td>
  <td><p><a href="mailto:Nguyendinhkien120288@gmail.com">Nguyendinhkien120288<br/>
  @gmail.com</a></p></td>
 </tr>
 <tr>
  <td><p>15</p></td>
  <td><p>Lê Nguyễn Việt Hà</p></td>
  <td><p>Chuyên viên</p></td>
  <td><p>037.921.3951</p></td>
  <td><p><a href="mailto:Lenguyenvietha2901@gmail.com">Lenguyenvietha2901<br/>
  @gmail.com</a></p></td>
 </tr>
 <tr>
  <td><p>16</p></td>
  <td><p>Hoàng Chung</p></td>
  <td><p>Chuyên viên</p></td>
  <td><p>091.200.4997</p></td>
  <td><p><a href="mailto:Chunghoang2009@gmail.com">Chunghoang2009<br/>
  @gmail.com</a></p></td>
 </tr>
 <tr>
  <td><p>17</p></td>
  <td><p>Ma Thị Điềm</p></td>
  <td><p>Chuyên viên</p></td>
  <td><p>098.724.6025</p></td>
  <td><p><a href="mailto:diemndbk@gmail.com">diemndbk<br/>
  @gmail.com</a></p></td>
 </tr>
 <tr>
  <td><p>18</p></td>
  <td><p>Nông Thị Thu Trang</p></td>
  <td><p>Chuyên viên</p></td>
  <td><p>081.361.6365</p></td>
  <td><p><a href="mailto:Htrang.1984@gmail.com">Htrang.1984<br/>
  @gmail.com</a></p></td>
 </tr>
 <tr>
  <td><p>19</p></td>
  <td><p>Nông Thị Thanh Lê</p></td>
  <td><p>Chuyên viên</p></td>
  <td><p>098.334.9235</p></td>
  <td><p><a href="mailto:nguyenlehoangbk@gmail.com">nguyenlehoangbk<br/>
  @gmail.com</a></p></td>
 </tr>
</tbody>
    ),
    photoName: "thaiNguyen"
  },
  {
    nameProvince: "TỈNH THANH HOÁ",
    address: "số 49 phường Hạc Thành, tỉnh Thanh Hoá.",
    phone: "",
    website: "",
    email: "",
    zipCode: "",
    contentComponent: (
      <tbody>
    <tr>
  <th><p><b>TT</b></p></th>
  <th><p><b>Họ và tên</b></p></th>
  <th><p><b>Chức vụ</b></p></th>
  <th><p><b>Số điện thoại</b></p></th>
 </tr>
 <tr>
  <td><p>1</p></td>
  <td><p>Vũ Thị Thanh Xuân</p></td>
  <td><p>Phó ban</p></td>
  <td><p>0916.848.183</p></td>
 </tr>
 <tr>
  <td><p>2</p></td>
  <td><p>Bùi Xuân Thiên</p></td>
  <td><p>Phó ban</p></td>
  <td><p>0915.920.111</p></td>
 </tr>
 <tr>
  <td><p>3</p></td>
  <td><p>Nguyễn Văn Vinh</p></td>
  <td><p>Phó ban</p></td>
  <td><p>0912.202.392</p></td>
 </tr>
 <tr>
  <td><p>4</p></td>
  <td><p>Hoàng Bùi Đồng</p></td>
  <td><p>Phó ban</p></td>
  <td><p>0916.848.183</p></td>
 </tr>
 <tr>
  <td><p>5</p></td>
  <td><p>Lương Thị Ngọc Hà</p></td>
  <td><p>Phó ban</p></td>
  <td><p>0949.581.586</p></td>
 </tr>
 <tr>
  <td><p>6</p></td>
  <td><p>Hoàng Thị Dung</p></td>
  <td><p>Phó ban</p></td>
  <td><p>0947.859.286</p></td>
 </tr>
 <tr>
  <td><p>7</p></td>
  <td><p>Nguyễn Thị Gấm</p></td>
  <td><p>Chuyên viên</p></td>
  <td><p>0917.470.317</p></td>
 </tr>
 <tr>
  <td><p>8</p></td>
  <td><p>Nguyễn Thị Hoè</p></td>
  <td><p>Chuyên viên</p></td>
  <td><p>0986.898.434</p></td>
 </tr>
 <tr>
  <td><p>9</p></td>
  <td><p>Lưu Thanh Dung</p></td>
  <td><p>Chuyên viên</p></td>
  <td><p>0944.715.696</p></td>
 </tr>
 <tr>
  <td><p>10</p></td>
  <td><p>Lê Thị Hà</p></td>
  <td><p>Chuyên viên</p></td>
  <td><p>039.700.1980</p></td>
 </tr>
 <tr>
  <td><p>11</p></td>
  <td><p>Nguyễn Thanh Hiền</p></td>
  <td><p>Chuyên viên</p></td>
  <td><p>0911.267.568</p></td>
 </tr>
 <tr>
  <td><p>12</p></td>
  <td><p>Trịnh Thị Huyền</p></td>
  <td><p>Chuyên viên</p></td>
  <td><p>0914.306.292</p></td>
 </tr>
 <tr>
  <td><p>13</p></td>
  <td><p>Lê Thị Vân</p></td>
  <td><p>Chuyên viên</p></td>
  <td><p>0913.812.011</p></td>
 </tr>
</tbody>
    ),
    photoName: "thanhHoa"
  },
  {
    nameProvince: "THÀNH PHỐ HỒ CHÍ MINH",
    address: "Số 271/1 Nguyễn Trọng Tuyển, phường Phú Nhuận, TP Hồ Chí Minh.",
    phone: "028.384.41271",
    website: "",
    email: "hnd@tphcm.gov.vn",
    zipCode: "028",
    contentComponent: (
      <tbody>
    <tr>
  <th><p><b>TT</b></p></th>
  <th><p><b>Họ và tên</b></p></th>
  <th><p><b>Chức vụ</b></p></th>
  <th><p><b>Số điện thoại</b></p></th>
  <th><p><b>Email</b></p></th>
 </tr>
 <tr>
  <td><p>1</p></td>
  <td><p>Nguyễn Thành Trung</p></td>
  <td><p>Chủ tịch</p></td>
  <td><p>091.370.4693</p></td>
  <td></td>
 </tr>
 <tr>
  <td><p>2</p></td>
  <td><p>Đỗ Ngọc Huy</p></td>
  <td><p>Phó Chủ tịch TT</p></td>
  <td><p>098.214.4028</p></td>
  <td><p>dnhuy.hnd<br/>
  @tphcm.gov.vn</p></td>
 </tr>
 <tr>
  <td><p>3</p></td>
  <td><p>Huỳnh Thị Kim Xuyến</p></td>
  <td><p>Phó Chủ tịch</p></td>
  <td><p>091.877.5536</p></td>
  <td><p>htkxuyen.hnd<br/>
  @tphcm.gov.vn</p></td>
 </tr>
 <tr>
  <td><p>4</p></td>
  <td><p>Trương Thành Quang</p></td>
  <td><p>Phó Chủ tịch</p></td>
  <td><p>091.910.9811</p></td>
  <td><p>ttquang.hnd<br/>
  @tphcm.gov.vn</p></td>
 </tr>
 <tr>
  <td><p>5</p></td>
  <td><p>Trần Văn Mảng</p></td>
  <td><p>Phó Chủ tịch</p></td>
  <td><p>097.995.9284</p></td>
  <td><p>tvmang.hnd<br/>
  @tphcm.gov.vn</p></td>
 </tr>
 <tr>
  <td><p>6</p></td>
  <td><p>Nguyễn Thị Thanh Tâm</p></td>
  <td><p>Tổ trưởng Tổ Văn phòng</p></td>
  <td><p>093.403.6736</p></td>
  <td><p>ntttam.hnd<br/>
  @tphcm.gov.vn</p></td>
 </tr>
 <tr>
  <td><p>7</p></td>
  <td><p>Lê Trung Hiếu</p></td>
  <td><p>Tổ phó Tổ văn phòng</p></td>
  <td><p>090.935.1778</p></td>
  <td><p>lthieu.hnd<br/>
  @tphcm.gov.vn</p></td>
 </tr>
 <tr>
  <td><p>8</p></td>
  <td><p>Trần Thị Hoa</p></td>
  <td><p>Chuyên viên Tổ Văn phòng</p></td>
  <td><p>096.685.7788</p></td>
  <td><p>tthoa.hnd<br/>
  @tphcm.gov.vn</p></td>
 </tr>
 <tr>
  <td><p>9</p></td>
  <td><p>Trần Thị Ngọc Điền</p></td>
  <td><p>Chuyên viên Tổ Văn phòng (văn thư)</p></td>
  <td><p>097.940.3080</p></td>
  <td><p>ttndien.hnd<br/>
  @tphcm.gov.vn</p></td>
 </tr>
 <tr>
  <td><p>10</p></td>
  <td><p>Nguyễn Thị Ngọc Diễm</p></td>
  <td><p>Kế toán</p></td>
  <td><p>097.757.4356</p></td>
  <td><p>ntndiem.hnd<br/>
  @tphcm.gov.vn</p></td>
 </tr>
 <tr>
  <td><p>11</p></td>
  <td><p>Trương Thị Thanh Thúy</p></td>
  <td><p>Kế toán</p></td>
  <td><p>093.776.1315</p></td>
  <td><p>tttthuy.hnd<br/>
  @tphcm.gov.vn</p></td>
 </tr>
 <tr>
  <td><p>12</p></td>
  <td><p>Võ Minh Tuấn</p></td>
  <td><p>NV bảo vệ</p></td>
  <td><p>077.998.7271</p></td>
  <td></td>
 </tr>
 <tr>
  <td><p>13</p></td>
  <td><p>Nguyễn Hữu Điền</p></td>
  <td><p>NV lái xe</p></td>
  <td><p>093.827.2576</p></td>
  <td></td>
 </tr>
 <tr>
  <td><p>14</p></td>
  <td><p>Nguyễn Biện Trường Vinh</p></td>
  <td><p>Tổ trưởng Tổ TC-KT</p></td>
  <td><p>090.849.7748</p></td>
  <td><p>nbtvinh.hnd<br/>
  @tphcm.gov.vn</p></td>
 </tr>
 <tr>
  <td><p>15</p></td>
  <td><p>Nguyễn Anh Tuấn</p></td>
  <td><p>Tổ phó Tổ TC-KT</p></td>
  <td><p>093.828.2416</p></td>
  <td><p>natuan.hnd<br/>
  @tphcm.gov.vn</p></td>
 </tr>
 <tr>
  <td><p>16</p></td>
  <td><p>Nguyễn Thị Lê</p></td>
  <td><p>Tổ phó Tổ TC-KT</p></td>
  <td><p>039.787.8789</p></td>
  <td><p>ntle.hnd<br/>
  @tphcm.gov.vn</p></td>
 </tr>
 <tr>
  <td><p>17</p></td>
  <td><p>Lê Thị Kim Mai</p></td>
  <td><p>Chuyên viên Tổ TC-KT</p></td>
  <td><p>097.915.0101</p></td>
  <td><p>ltkmai.hnd<br/>
  @tphcm.gov.vn</p></td>
 </tr>
 <tr>
  <td><p>18</p></td>
  <td><p>Lê Đình Anh Thư</p></td>
  <td><p>Chuyên viên Tổ TC-KT</p></td>
  <td><p>098.365.8979</p></td>
  <td><p>ldathu.hnd<br/>
  @tphcm.gov.vn</p></td>
 </tr>
 <tr>
  <td><p>19</p></td>
  <td><p>Lê Phúc Tiến</p></td>
  <td><p>Chuyên viên Tổ TC-KT</p></td>
  <td><p>098.474.8335</p></td>
  <td><p>lptien.hnd<br/>
  @tphcm.gov.vn</p></td>
 </tr>
 <tr>
  <td><p>20</p></td>
  <td><p>Ngô Ngọc Tuyết</p></td>
  <td><p>Tổ trưởng Tổ KT-XH</p></td>
  <td><p>098.391.4714</p></td>
  <td><p>nntuyet.hnd<br/>
  @tphcm.gov.vn</p></td>
 </tr>
 <tr>
  <td><p>21</p></td>
  <td><p>Hoàng Minh Thắng</p></td>
  <td><p>Tổ phó Tổ KT-XH</p></td>
  <td><p>096.615.5556</p></td>
  <td><p>hmthang.hnd<br/>
  @tphcm.gov.vn</p></td>
 </tr>
 <tr>
  <td><p>22</p></td>
  <td><p>Lê Thị Mai</p></td>
  <td><p>Tổ phó Tổ KT-XH</p></td>
  <td><p>090.698.2379</p></td>
  <td><p>ltmai.hnd<br/>
  @tphcm.gov.vn</p></td>
 </tr>
 <tr>
  <td><p>23</p></td>
  <td><p>Phạm Trương Thanh Sơn</p></td>
  <td><p>Chuyên viên Tổ KT-XH</p></td>
  <td><p>090.808.9842</p></td>
  <td><p>pttson.hnd<br/>
  @tphcm.gov.vn</p></td>
 </tr>
 <tr>
  <td><p>24</p></td>
  <td><p>Dương Thị Hồng Diệu</p></td>
  <td><p>Chuyên viên Tổ KT-XH</p></td>
  <td><p>093.882.0007</p></td>
  <td><p>dthdieu.hnd<br/>
  @tphcm.gov.vn</p></td>
 </tr>
 <tr>
  <td><p>25</p></td>
  <td><p>Trần Thế Dương</p></td>
  <td><p>Tổ phó Tổ TG</p></td>
  <td><p>091.410.5067</p></td>
  <td><p>ttduong.hnd<br/>
  @tphcm.gov.vn</p></td>
 </tr>
 <tr>
  <td><p>26</p></td>
  <td><p>Văn Cập Tài</p></td>
  <td><p>Chuyên viên Tổ TG</p></td>
  <td><p>077.383.7374</p></td>
  <td><p>vctai.hnd<br/>
  @tphcm.gov.vn</p></td>
 </tr>
 <tr>
  <td><p>27</p></td>
  <td><p>Phạm Thanh Quản</p></td>
  <td><p>Chuyên viên Tổ TG</p></td>
  <td><p>090.886.2652</p></td>
  <td><p>ptquan.hnd<br/>
  @tphcm.gov.vn</p></td>
 </tr>
 <tr>
  <td><p>28</p></td>
  <td><p>Đỗ Ngọc Hân</p></td>
  <td><p>Chuyên viên Tổ TG</p></td>
  <td><p>090.890.9158</p></td>
  <td><p>dnhan.hnd<br/>
  @tphcm.gov.vn</p></td>
 </tr>
 <tr>
  <td><p>29</p></td>
  <td><p>Trương Ngọc Thanh Tùng</p></td>
  <td><p>Chuyên viên Tổ TG</p></td>
  <td><p>091.993.4935</p></td>
  <td><p>tnttung.hnd<br/>
  @tphcm.gov.vn</p></td>
 </tr>
 <tr>
  <td><p>30</p></td>
  <td><p>Nguyễn Hải Trung</p></td>
  <td><p>Tổ phó Tổ Quỹ HTND</p></td>
  <td><p>094.798.2968</p></td>
  <td><p>nhtrung.hnd<br/>
  @tphcm.gov.vn</p></td>
 </tr>
 <tr>
  <td><p>31</p></td>
  <td><p>Mạch Thanh Lê</p></td>
  <td><p>Kế toán Quỹ HTND</p></td>
  <td><p>090.521.3714</p></td>
  <td><p>mtle.hnd<br/>
  @tphcm.gov.vn</p></td>
 </tr>
 <tr>
  <td><p>32</p></td>
  <td><p>Vũ Khánh Phượng</p></td>
  <td><p>NV nghiệp vụ Quỹ HTND</p></td>
  <td><p>037.967.2382</p></td>
  <td><p>vkphuong.hnd<br/>
  @tphcm.gov.vn</p></td>
 </tr>
 <tr>
  <td><p>33</p></td>
  <td><p>Lê Nguyễn Hoàng Anh</p></td>
  <td><p>NV nghiệp vụ Quỹ HTND</p></td>
  <td><p>078.777.2511</p></td>
  <td><p>lnhanh.hnd<br/>
  @tphcm.gov.vn</p></td>
 </tr>
 <tr>
  <td><p>34</p></td>
  <td><p>Nguyễn Minh Vũ</p></td>
  <td><p>NV nghiệp vụ Quỹ HTND</p></td>
  <td><p>090.830.3472</p></td>
  <td><p>nmvu.hnd<br/>
  @tphcm.gov.vn</p></td>
 </tr>
 <tr>
  <td><p>35</p></td>
  <td><p>Lê Đại Lâm</p></td>
  <td><p>NV nghiệp vụ Quỹ HTND</p></td>
  <td><p>083.434.2554</p></td>
  <td><p>ldlam.hnd<br/>
  @tphcm.gov.vn</p></td>
 </tr>
 <tr>
  <td><p>36</p></td>
  <td><p>Nguyễn Thiên Phước</p></td>
  <td><p>NV nghiệp vụ Quỹ HTND</p></td>
  <td><p>090.945.9710</p></td>
  <td><p>ntphuoc.hnd<br/>
  @tphcm.gov.vn</p></td>
 </tr>
 <tr>
  <td><p>37</p></td>
  <td><p>Nguyễn Hữu Thuận</p></td>
  <td><p>NV nghiệp vụ Quỹ HTND</p></td>
  <td><p>091.553.7948</p></td>
  <td></td>
 </tr>
 <tr>
  <td><p>38</p></td>
  <td><p>Nguyễn Tấn Đạt</p></td>
  <td><p>NV nghiệp vụ Quỹ HTND</p></td>
  <td><p>091.176.8479</p></td>
  <td></td>
 </tr>
 <tr>
  <td><p>39</p></td>
  <td><p>Đỗ Thị Lệ Hằng</p></td>
  <td><p>NV Bảo vệ</p></td>
  <td><p>098.534.3301</p></td>
  <td></td>
 </tr>
</tbody>
    ),
    photoName: "hochiMinh"
  },
  {
    nameProvince: "THÀNH PHỐ HUẾ",
    address: "14 Đống Đa, Phường Thuận Hóa, TP Huế.",
    phone: "0234.3823076",
    website: "www.hoinongdan.hue.gov.vn",
    email: "",
    zipCode: "0234",
    contentComponent: (
      <>
      <thead>
      <tr>
          <th rowSpan={2}><p><b>TT</b></p></th>
          <th rowSpan={2}><p><b>Họ và tên</b></p></th>
          <th rowSpan={2}><p><b>Chức vụ</b></p></th>
          <th colSpan={2}><p><b>Số máy điện thoại</b></p></th>
        </tr>
        <tr>
          <th><p><b>Cơ quan</b></p></th>
          <th><p><b>Di động</b></p></th>
        </tr>
      </thead>
      <tbody>
 <tr>
  <td><p>1</p></td>
  <td><p>Nguyễn Chí Quang</p></td>
  <td><p>Chủ tịch</p></td>
  <td><p>3820744</p></td>
  <td><p>091.411.4897</p></td>
 </tr>
 <tr>
  <td><p>2</p></td>
  <td><p>Phan Xuân Nam</p></td>
  <td><p>Phó chủ tịch, Trưởng ban CTND</p></td>
  <td><p>&nbsp;</p></td>
  <td><p>091.412.5436</p></td>
 </tr>
 <tr>
  <td><p>3</p></td>
  <td><p>Nguyễn Thị Thanh Nga</p></td>
  <td><p>Phó ban TT</p></td>
  <td><p>&nbsp;</p></td>
  <td><p>091.523.2892</p></td>
 </tr>
 <tr>
  <td><p>4</p></td>
  <td><p>Nguyễn Văn Lâm</p></td>
  <td><p>Phó ban</p></td>
  <td><p>&nbsp;</p></td>
  <td><p>093.590.6504</p></td>
 </tr>
 <tr>
  <td><p>5</p></td>
  <td><p>Trương Thị Thanh Bình</p></td>
  <td><p>Phó ban</p></td>
  <td><p>&nbsp;</p></td>
  <td><p>093.483.0699</p></td>
 </tr>
 <tr>
  <td><p>6</p></td>
  <td><p>Phạm Anh Vũ</p></td>
  <td><p>Chuyên viên</p></td>
  <td><p>&nbsp;</p></td>
  <td><p>079.932.2663</p></td>
 </tr>
 <tr>
  <td><p>7</p></td>
  <td><p>Nguyễn Duy Tiến</p></td>
  <td><p>Chuyên viên</p></td>
  <td><p>&nbsp;</p></td>
  <td><p>098.574.4954</p></td>
 </tr>
 <tr>
  <td><p>8</p></td>
  <td><p>Hoàng Đức Đạt</p></td>
  <td><p>Chuyên viên</p></td>
  <td><p>&nbsp;</p></td>
  <td><p>077.240.9856</p></td>
 </tr>
 <tr>
  <td><p>9</p></td>
  <td><p>Hồ Thị Phong Lan</p></td>
  <td><p>Chuyên viên</p></td>
  <td><p>&nbsp;</p></td>
  <td><p>089.922.6659</p></td>
 </tr>
 <tr>
  <td><p>10</p></td>
  <td><p>Nguyễn Thị Hà</p></td>
  <td><p>Văn thư</p></td>
  <td><p>&nbsp;</p></td>
  <td><p>034.903.7333</p></td>
 </tr>
</tbody>
      </>
      
    ),
    photoName: "hue"
  },
  {
    nameProvince: "TỈNH VĨNH LONG",
    address: "380/8 ấp Thanh Sơn, phường Thanh Đức, tỉnh Vĩnh Long.",
    phone: "0270 3823389",
    website: "",
    email: "vanphonghndtvl@gmail.com",
    zipCode: "",
    contentComponent: (
      <tbody>
    <tr>
  <th><p><b>TT</b></p></th>
  <th><p><b>Họ và tên</b></p></th>
  <th><p><b>Chức vụ</b></p></th>
  <th><p><b>Số điện thoại</b></p></th>
 </tr>
 <tr>
  <td><p>1</p></td>
  <td><p>Nguyễn Văn Dũng</p></td>
  <td><p>Chủ tịch</p></td>
  <td><p>091.374.2336</p></td>
 </tr>
 <tr>
  <td><p>2</p></td>
  <td><p>Lê Thanh Hiền</p></td>
  <td><p>Phó Chủ tịch</p></td>
  <td><p>091.850.8379</p></td>
 </tr>
 <tr>
  <td><p>3</p></td>
  <td><p>Bùi Văn Chiều</p></td>
  <td><p>Phó Chủ tịch</p></td>
  <td><p>090.713.6676</p></td>
 </tr>
 <tr>
  <td><p>4</p></td>
  <td><p>Quảng Thanh Tú</p></td>
  <td><p>Phó Chủ tịch</p></td>
  <td><p>093.999.6989</p></td>
 </tr>
 <tr>
  <td><p>5</p></td>
  <td><p>Nguyễn Thanh Phong</p></td>
  <td><p>Phó ban</p></td>
  <td><p>097.586.7393</p></td>
 </tr>
 <tr>
  <td><p>6</p></td>
  <td><p>Nguyễn Thị Mỹ An</p></td>
  <td><p>Phó ban</p></td>
  <td><p>090.662.5319</p></td>
 </tr>
 <tr>
  <td><p>7</p></td>
  <td><p>Lưu Quốc Tùng</p></td>
  <td><p>Chuyên viên</p></td>
  <td><p>090.910.1070</p></td>
 </tr>
 <tr>
  <td><p>8</p></td>
  <td><p>Phan Thanh Thảo</p></td>
  <td><p>Chuyên viên</p></td>
  <td><p>090.835.1345</p></td>
 </tr>
 <tr>
  <td><p>9</p></td>
  <td><p>Thái Văn Phi</p></td>
  <td><p>Lái xe</p></td>
  <td><p>091.609.2925</p></td>
 </tr>
 <tr>
  <td><p>10</p></td>
  <td><p>Bành Thị Bích Ngọc</p></td>
  <td><p>Chuyên viên</p></td>
  <td><p>097.853.8828</p></td>
 </tr>
 <tr>
  <td><p>11</p></td>
  <td><p>Trần Thị Trẻo</p></td>
  <td><p>Chuyên viên</p></td>
  <td><p>096.488.8478</p></td>
 </tr>
 <tr>
  <td><p>12</p></td>
  <td><p>Nguyễn Thị Tuyết Mai</p></td>
  <td><p>Chuyên viên</p></td>
  <td><p>093.856.1236</p></td>
 </tr>
 <tr>
  <td><p>13</p></td>
  <td><p>Châu Vĩnh Phúc</p></td>
  <td><p>Phó ban</p></td>
  <td><p>093.913.8366</p></td>
 </tr>
 <tr>
  <td><p>14</p></td>
  <td><p>Lê Thành Vững</p></td>
  <td><p>Phó ban</p></td>
  <td><p>079.454.4441</p></td>
 </tr>
 <tr>
  <td><p>15</p></td>
  <td><p>Đỗ Kim Thư</p></td>
  <td><p>Chuyên viên</p></td>
  <td><p>091.902.7991</p></td>
 </tr>
 <tr>
  <td><p>16</p></td>
  <td><p>Nguyễn Minh Triết</p></td>
  <td><p>Chuyên viên</p></td>
  <td><p>094.999.8219</p></td>
 </tr>
 <tr>
  <td><p>17</p></td>
  <td><p>Đoàn Trọng Quý</p></td>
  <td><p>Chuyên viên</p></td>
  <td><p>036.974.5945</p></td>
 </tr>
 <tr>
  <td><p>18</p></td>
  <td><p>Nguyễn Thị Ngọc Mai</p></td>
  <td><p>Chuyên viên</p></td>
  <td><p>038.493.3051</p></td>
 </tr>
 <tr>
  <td><p>19</p></td>
  <td><p>Nguyễn Nhựt Trường</p></td>
  <td><p>Phó ban</p></td>
  <td><p>094.153.6162</p></td>
 </tr>
 <tr>
  <td><p>20</p></td>
  <td><p>Thạch Thị Sa Rây Sách Thia</p></td>
  <td><p>Chuyên viên</p></td>
  <td><p>090.724.5677</p></td>
 </tr>
 <tr>
  <td><p>21</p></td>
  <td><p>Nguyễn Đăng Khoa</p></td>
  <td><p>Chuyên viên</p></td>
  <td><p>094.515.5718</p></td>
 </tr>
 <tr>
  <td><p>22</p></td>
  <td><p>Nguyễn Quốc Trai</p></td>
  <td><p>Chuyên viên</p></td>
  <td><p>034.700.6676</p></td>
 </tr>
 <tr>
  <td><p>23</p></td>
  <td><p>Nguyễn Bích Tuyền</p></td>
  <td><p>Chuyên viên TT HTND</p></td>
  <td><p>091.848.8670</p></td>
 </tr>
 <tr>
  <td><p>24</p></td>
  <td><p>Thạch Thị Bích Ngọc</p></td>
  <td><p>Chuyên viên TT HTND</p></td>
  <td><p>038.498.8938</p></td>
 </tr>
 <tr>
  <td><p>25</p></td>
  <td><p>Trầm Thanh Ngoan</p></td>
  <td><p>Chuyên viên TT HTND</p></td>
  <td><p>093.018.9382</p></td>
 </tr>
 <tr>
  <td><p>26</p></td>
  <td><p>Võ Quế Hiền Anh</p></td>
  <td><p>Chuyên viên TT HTND</p></td>
  <td><p>033.266.5154</p></td>
 </tr>
</tbody>
    ),
    photoName: "vinhLong"
  },
  // {
  //   nameProvince: "",
  //   address: ".",
  //   phone: "",
  //   website: "",
  //   email: "",
  //   zipCode: "",
  //   contentComponent: (
      
  //   ),
  //   photoName: ""
  // },  
];